(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["aes-coll-product-section2"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('aes-coll-product-section2')) {
  customElements.define('aes-coll-product-section2', class AesCollProductSection2 extends HTMLElement {
    connectedCallback() {
      this.events?.abort();
      this.events = new AbortController();
      this.button = this.querySelector('[data-aes-coll-product-section2-more]');
      this.grid = this.querySelector('[data-aes-coll-product-section2-grid]');
      this.status = this.querySelector('[data-aes-coll-product-section2-status]');
      this.results = this.querySelector('[data-aes-coll-product-section2-results]');
      this.spinner = this.querySelector('[data-aes-coll-product-section2-spinner]');
      this.arrow = this.querySelector('[data-aes-coll-product-section2-arrow]');
      this.loader = this.results?.querySelector('[data-aes-global-loading]');
      this.setLoading(false);
      if (this.button) this.button.hidden = false;
      this.addEventListener('click', event => {
        if (event.target.closest('[data-aes-coll-product-section2-more]')) this.loadMore();
      }, { signal: this.events.signal });
    }
    setLoading(busy) {
      this.busy = busy;
      for (const node of [this, this.results, this.grid, this.button]) {
        if (!node) continue;
        if (busy) node.setAttribute('aria-busy', 'true');
        else node.removeAttribute('aria-busy');
      }
      if (this.button) {
        if (busy) {
          this.button.setAttribute('aria-disabled', 'true');
          this.button.setAttribute('aria-label', this.dataset.loadingText);
        } else {
          this.button.removeAttribute('aria-disabled');
          this.button.removeAttribute('aria-label');
        }
      }
      if (this.grid) {
        if (busy) {
          if (this.gridWasInert === undefined) this.gridWasInert = this.grid.hasAttribute('inert');
          this.grid.inert = true;
        } else if (this.gridWasInert !== undefined) {
          this.grid.toggleAttribute('inert', this.gridWasInert);
          this.gridWasInert = undefined;
        }
      }
      if (this.spinner) this.spinner.hidden = !busy;
      if (this.loader) {
        if (busy && this.results) {
          const box = this.results.getBoundingClientRect();
          const top = Math.max(0, box.top);
          const bottom = Math.min(window.innerHeight, box.bottom);
          const center = bottom > top ? (top + bottom) / 2 - box.top : box.height / 2;
          this.loader.style.setProperty('--aes-coll-product-section2-loading-y', center + 'px');
        }
        this.loader.hidden = !busy;
      }
    }
    async loadMore() {
      if (this.busy || !this.button?.dataset.nextUrl || this.button.disabled) return;
      const nextUrl = new URL(this.button.dataset.nextUrl, location.href);
      if (nextUrl.origin !== location.origin) return;
      nextUrl.searchParams.set('section_id', this.dataset.sectionId);
      const request = new AbortController();
      this.request = request;
      this.setLoading(true);
      this.status.classList.add('visually-hidden');
      this.status.textContent = this.dataset.loadingText;
      const timeout = setTimeout(() => request.abort(), 15000);
      this.timeout = timeout;
      let firstNewLink;
      try {
        const response = await fetch(nextUrl, { signal: request.signal, credentials: 'same-origin' });
        if (!response.ok) throw new Error('Collection request failed');
        const html = new DOMParser().parseFromString(await response.text(), 'text/html');
        const incoming = [...html.querySelectorAll('aes-coll-product-section2')].find(section => section.dataset.sectionId === this.dataset.sectionId);
        const incomingGrid = incoming?.querySelector('[data-aes-coll-product-section2-grid]');
        const nextButton = incoming?.querySelector('[data-aes-coll-product-section2-more]');
        if (!incomingGrid || !nextButton || !this.isConnected || this.request !== request) throw new Error('Invalid collection response');
        const existing = new Set([...this.grid.children].map(card => card.dataset.productId));
        const cards = [...incomingGrid.children].filter(card => card.dataset.productId && !existing.has(card.dataset.productId));
        if (!cards.length) throw new Error('No new products in response');
        const next = nextButton.dataset.nextUrl || '';
        if (next && new URL(next, location.href).href === new URL(this.button.dataset.nextUrl, location.href).href) throw new Error('Repeated page');
        const fragment = document.createDocumentFragment();
        cards.forEach(card => fragment.append(card));
        this.grid.append(fragment);
        this.button.dataset.nextUrl = next;
          this.status.textContent = this.dataset.loadedText.replace('[count]', String(cards.length));
        if (!next) {
          this.button.disabled = true;
          this.button.querySelector('[data-aes-coll-product-section2-label]').textContent = this.dataset.doneText;
          this.status.textContent += ' ' + this.dataset.doneText;
        }
        firstNewLink = cards[0].querySelector('a');
      } catch (error) {
        if (this.isConnected && this.request === request) {
          this.status.textContent = this.dataset.errorText;
          this.status.classList.remove('visually-hidden');
        }
      } finally {
        clearTimeout(timeout);
        if (this.request === request) {
          this.request = null;
          this.timeout = null;
          this.setLoading(false);
          firstNewLink?.focus({ preventScroll: true });
        }
      }
    }
    disconnectedCallback() { this.events?.abort(); this.request?.abort(); this.request = null; clearTimeout(this.timeout); this.timeout = null; this.setLoading(false); }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["aes-header"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('aes-header')) {
  customElements.define('aes-header', class AesHeader extends HTMLElement {
    connectedCallback() {
      this.controller = new AbortController();
      const options = { signal: this.controller.signal };
      this.host = this.closest('.aes-header-section1-host');
      this.desktop = matchMedia('(min-width: 1081px)');
      this.disclosures = [...this.querySelectorAll('.aes-header-section1-disclosure')];
      this.menuAnimations = new Map();
      this.dialogs = [...this.querySelectorAll(':scope > dialog')];
      this.mobileCategories = [...this.querySelectorAll('[data-aes-menu-category]')];
      this.mobileCategories.forEach((button, index) => {
        button.addEventListener('click', () => this.selectMobileCategory(button), options);
        button.addEventListener('keydown', event => {
          const offset = event.key === 'ArrowDown' ? 1 : event.key === 'ArrowUp' ? -1 : 0;
          let next = null;
          if (offset) next = this.mobileCategories[(index + offset + this.mobileCategories.length) % this.mobileCategories.length];
          if (event.key === 'Home') next = this.mobileCategories[0];
          if (event.key === 'End') next = this.mobileCategories.at(-1);
          if (next) { event.preventDefault(); this.selectMobileCategory(next); next.focus(); }
          if (event.key === 'ArrowRight') {
            event.preventDefault();
            this.selectMobileCategory(button);
            this.querySelector(`#${CSS.escape(button.getAttribute('aria-controls'))}`)?.querySelector('a')?.focus();
          }
        }, options);
      });
      this.querySelectorAll('.aes-header-section1-menu-panel').forEach(panel => {
        panel.addEventListener('keydown', event => {
          if (event.key !== 'ArrowLeft') return;
          event.preventDefault();
          this.querySelector(`#${CSS.escape(panel.getAttribute('aria-labelledby'))}`)?.focus();
        }, options);
      });
      const backdrop = this.querySelector('[data-aes-header-backdrop]');
      const closeFromBackdrop = event => {
        event.preventDefault();
        const pointerDismissal = event.type === 'pointerdown' || event.detail > 0;
        const opened = this.disclosures.find(details => details.dataset.aesHeaderMenuActive === 'true');
        this.querySelector('aes-header-search')?.close?.(!pointerDismissal);
        this.closeMenus();
        if (pointerDismissal) {
          // A backdrop click leaves the header; do not retain its focus-within state.
          if (this.contains(document.activeElement)) document.activeElement.blur();
        } else {
          opened?.querySelector('summary')?.focus({ preventScroll:true });
        }
      };
      backdrop.addEventListener('pointerdown', closeFromBackdrop, options);
      backdrop.addEventListener('click', closeFromBackdrop, options);
      backdrop.addEventListener('pointerenter', event => {
        if (event.pointerType !== 'mouse') return;
        clearTimeout(this.menuTimer);
        this.menuTimer = setTimeout(() => {
          if (backdrop.matches(':hover') && !this.disclosures.some(details => details.contains(document.activeElement))) this.closeMenus();
        }, 120);
      }, options);
      this.addEventListener('aes:header-search:open', () => {
        this.closeMenus();
        this.dialogs.forEach(dialog => { if (dialog.open) dialog.close(); });
      }, options);
      this.querySelectorAll('[data-aes-header-wishlist]').forEach(trigger => {
        trigger.addEventListener('click', () => this.openWishlist(trigger), options);
      });
      this.header = this.querySelector('header');
      this.lastScrollY = Math.max(0, scrollY);
      this.scrollDirection = 0;
      this.scrollDistance = 0;
      this.syncState = event => {
        const y = Math.max(0, Math.min(scrollY, Math.max(0, document.documentElement.scrollHeight - innerHeight)));
        const scrolled = String(y > 0);
        if (this.dataset.aesHeaderScrolled !== scrolled) this.dataset.aesHeaderScrolled = scrolled;
        const height = this.header.offsetHeight;
        const firstSection = document.querySelector('#MainContent > .shopify-section:first-child');
        const hero = firstSection?.querySelector('.aes-page-home-section1-container, .aes-coll-product-section1-container') || firstSection;
        const overHero = this.dataset.aesHeaderOverlay === 'true' && (y <= 8 || (hero && hero.getBoundingClientRect().bottom >= height));
        const solid = String(!overHero);
        if (this.dataset.aesHeaderSolid !== solid) this.dataset.aesHeaderSolid = solid;
        const focused = this.header.querySelector(':focus-visible');
        const locked = this.editorSelected || this.disclosures.some(details => details.open) || this.querySelector('aes-header-search[data-aes-search-open="true"]') || document.querySelector('dialog[open], cart-drawer.active') || (this.keyboardFocus && focused && focused.getClientRects().length);
        let hidden = this.dataset.aesHeaderHidden === 'true';
        if (locked || y <= height) {
          hidden = false;
          this.scrollDirection = 0;
          this.scrollDistance = 0;
        } else if (event?.type === 'scroll') {
          const delta = y - this.lastScrollY;
          const direction = Math.sign(delta);
          if (direction) {
            this.scrollDistance = direction === this.scrollDirection ? this.scrollDistance + Math.abs(delta) : Math.abs(delta);
            this.scrollDirection = direction;
            if (this.scrollDistance >= 20) hidden = direction > 0;
          }
        } else {
          this.scrollDirection = 0;
          this.scrollDistance = 0;
        }
        this.lastScrollY = y;
        if (this.dataset.aesHeaderHidden !== String(hidden)) this.dataset.aesHeaderHidden = String(hidden);
      };
      this.onScroll = () => {
        if (this.scrollFrame) return;
        this.scrollFrame = requestAnimationFrame(() => {
          this.scrollFrame = null;
          this.syncState({ type: 'scroll' });
        });
      };
      this.syncSize = (entries = []) => {
        const height = entries[0]?.borderBoxSize?.[0]?.blockSize ?? this.header.offsetHeight;
        const reservedHeight = parseFloat(getComputedStyle(this.host).getPropertyValue('--aes-header-height'));
        if (Math.abs(reservedHeight - height) < 1) return;
        this.host?.style.setProperty('--aes-header-height', `${height}px`);
        this.syncState();
      };
      this.querySelectorAll('[data-aes-header-open]').forEach(trigger => {
        trigger.setAttribute('aria-haspopup', 'dialog');
        trigger.addEventListener('click', event => {
          const dialog = this.querySelector(`#${CSS.escape(trigger.dataset.aesHeaderOpen)}`);
          if (!dialog) return;
          event.preventDefault();
          this.querySelector('aes-header-search')?.close?.();
          this.closeMenus();
          this.dialogs.forEach(other => { if (other.open) other.close(); });
          document.querySelector('cart-drawer.active')?.close();
          dialog.aesReturnFocus = trigger;
          dialog.showModal();
          trigger.setAttribute('aria-expanded', 'true');
          this.syncState();
          dialog.querySelector('input[type="search"], [data-aes-header-close]')?.focus({ preventScroll: true });
        }, options);
      });
      this.dialogs.forEach(dialog => {
        if (dialog.classList.contains('aes-header-section1-drawer')) {
          dialog.addEventListener('keydown', event => {
            if (event.key !== 'Tab') return;
            const controls = [...dialog.querySelectorAll('a[href], button:not([disabled])')].filter(control => control.getClientRects().length);
            const first = controls[0], last = controls.at(-1);
            if (event.shiftKey && document.activeElement === first) { event.preventDefault(); last?.focus(); }
            else if (!event.shiftKey && document.activeElement === last) { event.preventDefault(); first?.focus(); }
          }, options);
        }
        dialog.querySelectorAll('[data-aes-header-close]').forEach(button => button.addEventListener('click', () => dialog.close(), options));
        dialog.addEventListener('click', event => {
          if (event.target !== dialog) return;
          const rect = dialog.getBoundingClientRect();
          if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) dialog.close();
        }, options);
        dialog.addEventListener('close', () => {
          this.querySelector(`[data-aes-header-open="${CSS.escape(dialog.id)}"]`)?.setAttribute('aria-expanded', 'false');
          if (dialog.hasAttribute('data-aes-header-wishlist-dialog')) {
            this.querySelectorAll('[data-aes-header-wishlist]').forEach(button => button.setAttribute('aria-expanded', 'false'));
            if (this.isConnected && this.wishlistReturnFocus?.isConnected && !this.dialogs.some(other => other.open)) this.wishlistReturnFocus.focus({ preventScroll: true });
          }
          dialog.querySelector('predictive-search')?.close?.();
          if (dialog.classList.contains('aes-header-section1-drawer') && !this.desktop.matches && !this.dialogs.some(other => other.open) && dialog.aesReturnFocus?.isConnected) dialog.aesReturnFocus.focus({ preventScroll: true });
          this.syncState();
        }, options);
      });
      this.disclosures.forEach(details => {
        const summary = details.querySelector('summary');
        summary.setAttribute('aria-expanded', 'false');
        summary.addEventListener('click', event => {
          if (event.target.closest('[data-aes-header-parent-link]')) return;
          event.preventDefault();
          if (event.pointerType === 'mouse' && details.dataset.aesHeaderMenuActive === 'true') return;
          this.setMenu(details, details.dataset.aesHeaderMenuActive !== 'true');
        }, options);
        summary.addEventListener('keydown', event => {
          if (event.key !== 'ArrowDown') return;
          event.preventDefault();
          this.setMenu(details, true);
          details.querySelector('.aes-header-section1-mega a, .aes-header-section1-mega button')?.focus();
        }, options);
        details.addEventListener('pointerenter', event => {
          clearTimeout(this.menuTimer);
          if (event.pointerType === 'mouse' && this.desktop.matches) {
            this.setMenu(details, true);
          }
        }, options);
        details.addEventListener('focusout', event => {
          if (!details.contains(event.relatedTarget)) this.setMenu(details, false);
        }, options);
      });
      this.querySelectorAll('.aes-header-section1-menu > li').forEach(item => {
        if (item.querySelector('details')) return;
        item.addEventListener('pointerenter', event => { if (event.pointerType === 'mouse') this.closeMenus(); }, options);
      });
      this.addEventListener('pointerenter', () => clearTimeout(this.menuTimer), options);
      this.addEventListener('pointerleave', event => {
        if (event.pointerType !== 'mouse') return;
        clearTimeout(this.menuTimer);
        this.menuTimer = setTimeout(() => {
          if (!this.matches(':hover') && !this.contains(document.activeElement)) this.closeMenus();
        }, 120);
      }, options);
      this.addEventListener('keydown', event => {
        if (event.key !== 'Escape' || this.dialogs.some(dialog => dialog.open)) return;
        const opened = this.disclosures.find(details => details.dataset.aesHeaderMenuActive === 'true');
        if (opened) {
          event.preventDefault();
          this.setMenu(opened, false);
          opened.querySelector('summary').focus();
        }
      }, options);
      document.addEventListener('click', event => { if (!this.contains(event.target)) this.closeMenus(); }, options);
      window.addEventListener('scroll', this.onScroll, { ...options, passive: true });
      window.addEventListener('resize', this.syncState, options);
      window.addEventListener('pageshow', this.syncState, options);
      window.addEventListener('load', this.syncState, options);
      document.addEventListener('DOMContentLoaded', this.syncState, options);
      this.header.addEventListener('focusin', event => { this.keyboardFocus = event.target.matches(':focus-visible'); this.syncState(); }, options);
      this.header.addEventListener('keydown', () => { this.keyboardFocus = true; this.syncState(); }, options);
      window.addEventListener('wheel', () => { this.keyboardFocus = false; }, { ...options, passive: true });
      window.addEventListener('touchstart', () => { this.keyboardFocus = false; }, { ...options, passive: true });
      this.stateObserver = new MutationObserver(() => this.syncState());
      this.stateObserver.observe(this, { subtree: true, attributes: true, attributeFilter: ['open', 'data-aes-search-open', 'data-aes-header-menu-active'] });
      const cartDrawer = document.querySelector('cart-drawer');
      if (cartDrawer) this.stateObserver.observe(cartDrawer, { attributes: true, attributeFilter: ['class'] });
      document.addEventListener('shopify:section:select', event => {
        if (event.target === this.host) { this.editorSelected = true; this.syncState(); }
      }, options);
      this.desktop.addEventListener('change', () => {
        this.closeMenus();
        this.dialogs.forEach(dialog => { if (dialog.open) dialog.close(); });
        this.syncSize();
        this.syncState();
      }, options);
      document.addEventListener('shopify:block:select', event => {
        if (!this.contains(event.target)) return;
        const details = event.target.closest('.aes-header-section1-disclosure');
        if (details && this.desktop.matches) this.setMenu(details, true);
      }, options);
      document.addEventListener('shopify:section:deselect', event => {
        if (event.target === this.host) { this.editorSelected = false; this.closeMenus(); this.dialogs.forEach(dialog => dialog.close()); this.syncState(); }
      }, options);
      this.resizeObserver = new ResizeObserver(this.syncSize);
      this.resizeObserver.observe(this.header);
      this.syncState();
      this.syncSize();
      if (document.readyState === 'complete') {
        document.querySelector('cart-drawer')?.setHeaderCartIconAccessibility?.();
      }
    }
    selectMobileCategory(button) {
      this.mobileCategories.forEach(category => {
        const active = category === button;
        category.setAttribute('aria-expanded', String(active));
        const panel = this.querySelector(`#${CSS.escape(category.getAttribute('aria-controls'))}`);
        if (panel) panel.hidden = !active;
      });
      this.querySelector('.aes-header-section1-menu-panels')?.scrollTo({ top: 0 });
    }
    setMenu(details, open, switching = false) {
      if (open === (details.dataset.aesHeaderMenuActive === 'true')) return;
      const panel = details.querySelector('.aes-header-section1-mega');
      const previous = this.menuAnimations.get(details);
      const wasOpen = details.open;
      const start = previous ? { opacity: getComputedStyle(panel).opacity, transform: getComputedStyle(panel).transform } : null;
      previous?.cancel();
      if (open) {
        this.querySelector('aes-header-search')?.close?.();
        switching = this.disclosures.some(other => other !== details && other.dataset.aesHeaderMenuActive === 'true');
        this.closeMenus(details, switching);
        details.open = true;
      }
      details.dataset.aesHeaderMenuActive = String(open);
      details.querySelector('summary').setAttribute('aria-expanded', String(open));
      panel.inert = !open;
      if (!wasOpen && !open) return;
      const css = getComputedStyle(this);
      const time = css.getPropertyValue('--aes-duration').trim();
      const duration = matchMedia('(prefers-reduced-motion: reduce)').matches ? 0 : parseFloat(time) * (time.endsWith('ms') ? 1 : 1000);
      const collapsed = { opacity: 0, transform: switching ? 'translateY(0)' : 'translateY(-8px)' };
      const expanded = { opacity: 1, transform: 'translateY(0)' };
      const animation = panel.animate([start || (open ? collapsed : expanded), open ? expanded : collapsed], {
        duration, easing: css.getPropertyValue('--aes-header-menu-ease').trim(), fill: 'both'
      });
      this.menuAnimations.set(details, animation);
      animation.onfinish = () => {
        if (!open) details.open = false;
        animation.cancel();
        this.menuAnimations.delete(details);
      };
    }
    closeMenus(except, switching = false) {
      this.disclosures.forEach(details => { if (details !== except) this.setMenu(details, false, switching); });
    }
    openWishlist(trigger) {
      const dialog = this.querySelector('[data-aes-header-wishlist-dialog]');
      if (dialog.open) return;
      this.wishlistReturnFocus = trigger?.closest('dialog') ? this.querySelector('.aes-header-section1-menu-toggle') : trigger || this.querySelector('[data-aes-header-wishlist]');
      this.querySelector('aes-header-search')?.close?.();
      this.closeMenus();
      this.dialogs.forEach(other => { if (other.open) other.close(); });
      document.querySelector('cart-drawer.active')?.close();
      this.querySelectorAll('[data-aes-header-wishlist]').forEach(button => button.setAttribute('aria-expanded', 'true'));
      dialog.showModal();
      this.syncState();
      dialog.querySelector('[data-aes-header-close]').focus({ preventScroll: true });
    }
    disconnectedCallback() {
      clearTimeout(this.menuTimer);
      this.menuAnimations?.forEach(animation => animation.cancel());
      this.dialogs?.forEach(dialog => { if (dialog.open) dialog.close(); });
      this.controller?.abort();
      this.resizeObserver?.disconnect();
      this.stateObserver?.disconnect();
      cancelAnimationFrame(this.scrollFrame);
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["aes-page-about-us-section1"] && !Shopify.designMode) return;
  try {
    
(() => {
  const reduced = matchMedia('(prefers-reduced-motion: reduce)');
  let controller;
  class AesAboutSequence {
    constructor(main, hero) {
      this.main = main;
      this.abort = new AbortController();
      this.phase = 'idle';
      this.frame = 0;
      this.heldKeys = new Set();
      this.wheelHistory = [];
      this.lastWheelTime = -Infinity;
      this.scenes = [];
      let host = hero.closest('.shopify-section');
      while (host) {
        const root = host.querySelector(':scope > .aes-page-about-us-section1-container, :scope > .aes-page-about-us-section2-container, :scope > .aes-page-about-us-section3-container, :scope > .aes-page-about-us-section4-container');
        if (!root) break;
        root.classList.add('aes-about-screen');
        this.scenes.push({ host, root });
        host = host.nextElementSibling;
      }
      this.measure();
      const signal = this.abort.signal;
      main.addEventListener('wheel', e => this.wheel(e), { passive: false, signal });
      main.addEventListener('touchstart', e => this.touchStart(e), { passive: true, signal });
      main.addEventListener('touchmove', e => this.touchMove(e), { passive: false, signal });
      main.addEventListener('touchend', () => { this.touch = null; }, { passive: true, signal });
      main.addEventListener('touchcancel', () => { this.touch = null; }, { passive: true, signal });
      document.addEventListener('keydown', e => this.key(e), { signal });
      document.addEventListener('keyup', e => this.heldKeys.delete(e.code || e.key), { signal });
      window.addEventListener('blur', () => { this.heldKeys.clear(); this.reset(); }, { signal });
      window.addEventListener('scroll', () => this.scroll(), { passive: true, signal });
      window.addEventListener('resize', () => this.resize(), { passive: true, signal });
      window.visualViewport?.addEventListener('resize', () => this.resize(), { passive: true, signal });
      document.addEventListener('visibilitychange', () => { if (document.hidden) { this.heldKeys.clear(); this.reset(); } }, { signal });
      document.addEventListener('focusin', () => { if (this.blocked()) this.reset(); }, { signal });
      this.state('idle');
      this.index = this.nearest();
      this.main.dataset.aesAboutActiveScreen = String(this.index + 1);
    }
    state(phase) { this.phase = phase; this.main.dataset.aesAboutScrollState = phase; }
    measure() {
      const y = scrollY;
      this.points = this.scenes.map(({ host }) => host.getBoundingClientRect().top + y);
      this.height = this.scenes[0]?.root.getBoundingClientRect().height || innerHeight;
      this.end = this.scenes.at(-1)?.host.getBoundingClientRect().bottom + y;
    }
    nearest() {
      let index = 0;
      this.points.forEach((point, i) => { if (Math.abs(point - scrollY) < Math.abs(this.points[index] - scrollY)) index = i; });
      return index;
    }
    inside() { return this.scenes.length > 1 && this.height >= 360 && scrollY >= this.points[0] - 2 && scrollY < this.end - 2; }
    blocked() {
      if (reduced.matches || window.Shopify?.designMode || document.hidden) return true;
      return [...document.querySelectorAll('dialog[open], [aria-modal="true"], aes-header details[open], aes-header-search[data-aes-search-open="true"], cart-drawer.active')].some(el => {
        const r = el.getBoundingClientRect();
        return r.width > 0 && r.height > 0 && getComputedStyle(el).visibility !== 'hidden';
      });
    }
    nativeTarget(target, direction) {
      if (!(target instanceof Element)) return false;
      if (target.closest('input, textarea, select, [contenteditable="true"], iframe')) return true;
      if (!this.main.contains(target)) return false;
      for (let el = target; el && el !== this.main; el = el.parentElement) {
        if (el.scrollHeight <= el.clientHeight + 2) continue;
        if (!/(auto|scroll)/.test(getComputedStyle(el).overflowY)) continue;
        if (direction > 0 ? el.scrollTop + el.clientHeight < el.scrollHeight - 2 : el.scrollTop > 2) return true;
      }
      return false;
    }
    destination(direction) {
      // A partially visible screen must be completed before stepping past it.
      // In particular, scrolling up from the CTA first restores the last image.
      if (direction > 0) {
        const index = this.points.findIndex(point => point > scrollY + 3);
        return index === -1 ? null : index;
      }
      for (let index = this.points.length - 1; index >= 0; index--) {
        if (this.points[index] < scrollY - 3) return index;
      }
      return null;
    }
    step(direction, queue = false) {
      if (this.phase === 'animating') {
        if (queue && performance.now() - this.animationStarted >= 120) this.pendingDirection = direction;
        return true;
      }
      const index = this.destination(direction);
      if (index === null) { clearTimeout(this.fitTimer); return false; }
      this.commit(index);
      return true;
    }
    position(top) { window.scrollTo({ top, behavior: 'instant' }); }
    animate(top, done) {
      cancelAnimationFrame(this.frame);
      const from = scrollY, start = performance.now(), duration = 700;
      const tick = now => {
        if (this.blocked()) { this.reset(); return; }
        const t = Math.min(1, (now - start) / duration);
        // Match Minotti's scrollbar-enabled fullPage easeInOutCubic motion.
        const eased = t < .5 ? 4 * t ** 3 : 1 - (-2 * t + 2) ** 3 / 2;
        this.position(from + (top - from) * eased);
        if (t < 1) this.frame = requestAnimationFrame(tick);
        else { this.frame = 0; this.position(top); done?.(); }
      };
      this.frame = requestAnimationFrame(tick);
    }
    commit(index) {
      clearTimeout(this.fitTimer);
      this.state('animating');
      this.animationStarted = performance.now();
      this.index = index;
      this.main.dataset.aesAboutActiveScreen = String(index + 1);
      this.animate(this.points[index], () => {
        const pending = this.pendingDirection;
        this.pendingDirection = null;
        this.state('idle');
        if (pending && this.inside() && !this.blocked()) this.step(pending);
      });
    }
    wheel(event) {
      if (event.ctrlKey || event.metaKey || Math.abs(event.deltaX) > Math.abs(event.deltaY) || !event.deltaY || !this.inside() || this.blocked()) return;
      const direction = Math.sign(event.deltaY);
      if (this.nativeTarget(event.target, direction)) return;
      const now = performance.now(), fresh = now - this.lastWheelTime > 160 || direction !== this.lastWheelDirection;
      const magnitude = Math.abs(event.deltaY);
      this.lastWheelTime = now;
      this.lastWheelDirection = direction;
      if (fresh) this.wheelHistory = [];
      this.wheelHistory.push(magnitude);
      if (this.wheelHistory.length > 70) this.wheelHistory.shift();
      const recent = this.wheelHistory.slice(-4);
      const average = values => values.reduce((sum, value) => sum + value, 0) / values.length;
      // Ignore decaying trackpad momentum, without extending a timed scroll lock.
      const intentional = fresh || average(recent) >= average(this.wheelHistory) * .9;
      if (this.phase === 'animating') {
        if (event.cancelable) event.preventDefault();
        if (fresh) this.step(direction, true);
        return;
      }
      if (!intentional) { if (event.cancelable) event.preventDefault(); return; }
      this.touch = null;
      if (this.step(direction) && event.cancelable) event.preventDefault();
    }
    touchStart(event) {
      this.touch = null;
      if (event.touches.length !== 1 || !this.inside() || this.blocked()) return;
      const t = event.touches[0];
      this.touch = { x: t.clientX, y: t.clientY, target: event.target, committed: false };
    }
    touchMove(event) {
      const touch = this.touch;
      if (!touch) return;
      if (event.touches.length !== 1 || this.blocked()) { this.touch = null; return; }
      const t = event.touches[0], dy = touch.y - t.clientY, dx = touch.x - t.clientX, direction = Math.sign(dy);
      if (Math.abs(dy) < 10) return;
      if (touch.committed) { if (event.cancelable) event.preventDefault(); return; }
      if (Math.abs(dx) > Math.abs(dy) || this.nativeTarget(touch.target, direction) || this.destination(direction) === null) { this.touch = null; return; }
      if (event.cancelable) event.preventDefault();
      if (this.phase === 'animating') return;
      // The reference uses touchSensitivity 15: one vertical swipe starts one screen.
      if (Math.abs(dy) > this.height * .15) { touch.committed = true; this.step(direction); }
    }
    key(event) {
      if (event.altKey || event.ctrlKey || event.metaKey || !this.inside() || this.blocked()) return;
      if (event.target instanceof Element && event.target.closest('input, textarea, select, button, a, [contenteditable="true"]')) return;
      const direction = ['PageDown', 'ArrowDown'].includes(event.key) || (event.key === ' ' && !event.shiftKey) ? 1 : ['PageUp', 'ArrowUp'].includes(event.key) || (event.key === ' ' && event.shiftKey) ? -1 : 0;
      if (!direction || this.nativeTarget(event.target, direction)) return;
      const code = event.code || event.key;
      if (this.heldKeys.has(code)) { event.preventDefault(); return; }
      if (this.phase !== 'animating' && this.destination(direction) === null) return;
      event.preventDefault();
      this.heldKeys.add(code);
      if (event.repeat) return;
      this.step(direction, true);
    }
    scroll() {
      if (this.phase !== 'idle') return;
      this.index = this.nearest();
      this.main.dataset.aesAboutActiveScreen = String(this.index + 1);
      clearTimeout(this.fitTimer);
      // Native scrollbar/trackpad movement settles after 1s, as in the reference.
      // Once leaving the last image, release the following CTA and footer entirely.
      if (!this.inside() || scrollY > this.points.at(-1) + 2 || this.blocked() || this.touch) return;
      this.fitTimer = setTimeout(() => {
        if (this.phase !== 'idle' || !this.inside() || this.blocked() || this.touch || scrollY > this.points.at(-1) + 2) return;
        const index = this.nearest();
        if (Math.abs(scrollY - this.points[index]) > 2) this.commit(index);
      }, 1000);
    }
    resize() {
      if (this.resizeFrame) return;
      const index = this.index, wasAligned = Math.abs(scrollY - this.points[index]) < 3;
      this.reset();
      this.resizeFrame = requestAnimationFrame(() => {
        this.resizeFrame = 0;
        this.measure();
        if (wasAligned && this.inside()) this.position(this.points[index]);
      });
    }
    reset() {
      cancelAnimationFrame(this.frame);
      this.frame = 0;
      clearTimeout(this.fitTimer);
      this.pendingDirection = null;
      this.wheelHistory = [];
      this.lastWheelTime = -Infinity;
      this.touch = null;
      this.state('idle');
    }
    destroy() {
      this.reset();
      cancelAnimationFrame(this.resizeFrame);
      this.abort.abort();
      this.scenes.forEach(({ root }) => root.classList.remove('aes-about-screen'));
      delete this.main.dataset.aesAboutScrollState;
      delete this.main.dataset.aesAboutActiveScreen;
    }
  }
  const boot = () => {
    controller?.destroy();
    controller = null;
    const main = document.querySelector('#MainContent'), hero = main?.querySelector('[data-aes-about-sequence="true"]');
    if (!hero || reduced.matches || window.Shopify?.designMode) return;
    controller = new AesAboutSequence(main, hero);
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot, { once: true });
  else boot();
  reduced.addEventListener('change', boot);
  document.addEventListener('shopify:section:load', boot);
  document.addEventListener('shopify:section:reorder', boot);
  document.addEventListener('shopify:section:unload', () => { controller?.destroy(); controller = null; requestAnimationFrame(boot); });
  window.addEventListener('pagehide', () => { controller?.destroy(); controller = null; });
  window.addEventListener('pageshow', event => { if (event.persisted) boot(); });
})();


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["aes-page-about-us-section2"] && !Shopify.designMode) return;
  try {
    
(() => {
  const aesPageAboutUsSection2Reduced = matchMedia('(prefers-reduced-motion: reduce)');
  let aesPageAboutUsSection2Controller;
  class AesPageAboutUsSection2Parallax {
    constructor(main) {
      this.abort = new AbortController();
      this.animation = 0;
      this.items = [2, 3, 4].flatMap(number => {
        const prefix = 'aes-page-about-us-section' + number;
        return [...main.querySelectorAll('.' + prefix + '-container')].flatMap(root => {
          const frame = root.querySelector('.' + prefix + '-frame');
          const media = root.querySelector('.' + prefix + '-media');
          if (!frame || !media?.firstElementChild) return [];
          root.classList.add(prefix + '-parallax');
          return [{ root, frame, prefix }];
        });
      });
      const signal = this.abort.signal;
      window.addEventListener('scroll', () => this.schedule(), { passive: true, signal });
      window.addEventListener('resize', () => this.schedule(), { passive: true, signal });
      window.visualViewport?.addEventListener('resize', () => this.schedule(), { passive: true, signal });
      document.addEventListener('visibilitychange', () => {
        if (document.hidden) {
          cancelAnimationFrame(this.animation);
          this.animation = 0;
        } else this.schedule();
      }, { signal });
      this.resizeObserver = new ResizeObserver(() => this.schedule());
      this.items.forEach(item => this.resizeObserver.observe(item.frame));
      this.resizeObserver.observe(main);
      this.update();
    }
    schedule() {
      if (this.animation || document.hidden) return;
      this.animation = requestAnimationFrame(() => {
        this.animation = 0;
        this.update();
      });
    }
    update() {
      const viewport = window.innerHeight;
      const measurements = this.items.map(item => {
        const rect = item.frame.getBoundingClientRect();
        const amplitude = Math.min(160, rect.height * 0.16, viewport * 0.2);
        const progress = Math.max(-1, Math.min(1, (viewport / 2 - rect.top - rect.height / 2) / ((viewport + rect.height) / 2)));
        return { item, amplitude, offset: progress * amplitude, visible: rect.bottom > 0 && rect.top < viewport };
      });
      measurements.forEach(({ item, amplitude, offset, visible }) => {
        item.root.style.setProperty('--' + item.prefix + '-parallax-overscan', (amplitude + 2).toFixed(2) + 'px');
        item.root.style.setProperty('--' + item.prefix + '-parallax-offset', offset.toFixed(2) + 'px');
        item.root.classList.toggle(item.prefix + '-parallax-visible', visible);
      });
    }
    destroy() {
      cancelAnimationFrame(this.animation);
      this.abort.abort();
      this.resizeObserver.disconnect();
      this.items.forEach(item => {
        item.root.classList.remove(item.prefix + '-parallax', item.prefix + '-parallax-visible');
        item.root.style.removeProperty('--' + item.prefix + '-parallax-overscan');
        item.root.style.removeProperty('--' + item.prefix + '-parallax-offset');
      });
    }
  }
  const aesPageAboutUsSection2Boot = () => {
    aesPageAboutUsSection2Controller?.destroy();
    aesPageAboutUsSection2Controller = null;
    const main = document.querySelector('#MainContent');
    if (main?.querySelector('[data-aes-about-sequence="true"]') || !main?.querySelector('[data-aes-page-about-us-section2-parallax="true"]') || window.Shopify?.designMode || aesPageAboutUsSection2Reduced.matches) return;
    aesPageAboutUsSection2Controller = new AesPageAboutUsSection2Parallax(main);
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', aesPageAboutUsSection2Boot, { once: true });
  else aesPageAboutUsSection2Boot();
  aesPageAboutUsSection2Reduced.addEventListener('change', aesPageAboutUsSection2Boot);
  document.addEventListener('shopify:section:load', aesPageAboutUsSection2Boot);
  document.addEventListener('shopify:section:unload', () => {
    aesPageAboutUsSection2Controller?.destroy();
    aesPageAboutUsSection2Controller = null;
    requestAnimationFrame(aesPageAboutUsSection2Boot);
  });
  window.addEventListener('pagehide', () => aesPageAboutUsSection2Controller?.destroy());
  window.addEventListener('pageshow', event => { if (event.persisted) aesPageAboutUsSection2Boot(); });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["aes-page-contact-section1"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('aes-page-contact-section1')) {
  customElements.define('aes-page-contact-section1',class extends HTMLElement {
    initLoading() {
      this.loadingRegion=this.querySelector('[data-aes-form-mount]');
      this.loadingLogo=this.loadingRegion?.querySelector('[data-aes-global-loading]');
      this.loadingStatus=this.loadingRegion?.querySelector('[data-aes-form-load-status]');
      this.loadingRetry=this.loadingRegion?.querySelector('[data-aes-form-load-retry]');
      this.loadingLocks=new Map();
      this.loadingAbort?.abort(); this.loadingAbort=new AbortController();
      this.loadingRetry?.addEventListener('click',()=>{
        clearInterval(this.locateTimer); this.attempts=0; this.setLoading(true); this.locate();
        if (!this.root) this.locateTimer=setInterval(this.locate,250);
      },{signal:this.loadingAbort.signal});
      this.setLoading(true);
    }
    setLoading(loading,failed=false) {
      if (!this.loadingLogo) return;
      const region=this.loadingRegion;
      if (loading) {
        if (region.contains(document.activeElement)) { this.loadingStatus.tabIndex=-1; this.loadingStatus.focus({preventScroll:true}); }
        region.querySelectorAll('.shopify-block,shopify-forms-embed').forEach(node=>{
          if (!this.loadingLocks.has(node)) this.loadingLocks.set(node,node.inert);
          node.inert=true;
        });
      } else { this.loadingLocks.forEach((inert,node)=>{node.inert=inert}); this.loadingLocks.clear(); }
      region.toggleAttribute('data-aes-form-loading',loading);
      region.setAttribute('aria-busy',String(loading));
      this.loadingLogo.hidden=!loading;
      this.loadingStatus.hidden=!loading&&!failed;
      this.loadingStatus.setAttribute('role',failed?'alert':'status');
      this.loadingStatus.textContent=failed?'The form could not be loaded. Please retry or refresh the page.':'Loading form. Please wait.';
      this.loadingRetry.hidden=!failed;
    }
    connectedCallback() {
      if (this.connected) return;
      this.connected=true;
      this.attempts=0;
      this.initLoading();
      this.initSuccess();
      this.locate=()=>{
        const root=this.querySelector('shopify-forms-embed')?.shadowRoot;
        if (root && (root.querySelector('[data-testid="banner-success"]') || (root.querySelector('[data-testid="btn-form-submit"]') && root.querySelectorAll('#first_name,#last_name,#email,[name="phone_number"],[id="custom#country_region"],[name="custom#country_region"],[id="custom#zip_postal_code"],[name="custom#zip_postal_code"],[name="custom#message"]').length===7))) {
          clearInterval(this.locateTimer);
          this.attach(root);
        } else if (++this.attempts>=120) {
          clearInterval(this.locateTimer);
          this.setLoading(false,true);
        }
      };
      this.locate();
      if (!this.root) this.locateTimer=setInterval(this.locate,250);
    }
    disconnectedCallback() {
      this.disposeSuccess();
      this.setLoading(false); this.loadingAbort?.abort();
      clearInterval(this.locateTimer);
      clearInterval(this.pendingTimer);
      this.observer?.disconnect();
      this.release();
      this.abort?.abort();
      this.prepareAbort?.abort();
      this.preparing=false;
      this.connected=false;
      this.root=null;
    }
    attach(root) {
      this.observer?.disconnect();
      clearInterval(this.pendingTimer);
      this.release();
      this.abort?.abort();
      this.prepareAbort?.abort();
      this.preparing=false;
      this.prepared=false;
      this.abort=new AbortController();
      window.addEventListener("resize",()=>this.positionPhoneMenu(),{signal:this.abort.signal});
      this.root=root;
      this.copy=this.querySelector('template[data-aes-page-contact-section1-copy]').content;
      this.form=root.querySelector('form');
      this.attempted=false;
      this.awaitingNative=false;
      this.locked=new Map();
      this.busy=false;
      const prefix='aes-page-contact-section1';
      let style=root.querySelector('style[data-aes-page-contact-section1-style]');
      if (!style) {
        style=document.createElement('style');
        style.dataset.aesPageContactSection1Style='';
        style.textContent=`
@layer aes-focus-policy {
  :is(:focus, :focus-visible, .focused) { outline: none !important; box-shadow: none !important; }
  :focus-within { outline: none !important; }
}

          :host{--inline-container-max-width:100%!important;--container-max-w:100%!important;--forms-body-font:normal 400 14px var(--aes-font-body)!important;--form-field-border-radius:0px!important;--button-border-radius:0px!important;--container-text-alignment:left!important}
          [data-form-root],[data-testid="app-router"],#form-container-ref,section[role="dialog"],[class*="_formContainer_"],[class*="_inline_"]{width:100%!important;max-width:none!important;padding:0!important;margin:0!important;background:transparent!important;border:0!important;box-shadow:none!important}
          :host(:focus),section[role="dialog"]:focus,form:focus{outline:none!important;box-shadow:none!important}
          [class*="_gridItemContent_"]{padding:0!important;min-width:0!important}
          [class*="_formHeader_"],form>div:has(shop-lead-capture){display:none!important}
          form[data-aes-page-contact-section1-form]{display:grid!important;grid-template-columns:minmax(0,1fr)!important;gap:24px!important;margin:0!important;padding:0!important;border:0!important;box-shadow:none!important;outline:none!important}
          form[data-aes-page-contact-section1-form],form[data-aes-page-contact-section1-form] *{box-sizing:border-box!important}
          .${prefix}-field{display:flex!important;flex-direction:column!important;gap:8px!important;position:relative!important;min-width:0!important}
          .${prefix}-field::before{content:none!important}
          .${prefix}-field label{position:static!important;order:-1!important;padding:0!important;margin:0!important;transform:none!important;color:var(--aes-text-primary)!important;font:400 14px/1.6 var(--aes-font-body)!important;line-height:round(nearest,22.4px,1px)!important;text-transform:uppercase!important;letter-spacing:0!important}
          .${prefix}-field label::after{content:' *'}
          .${prefix}-field :is(input,textarea,select){box-sizing:border-box!important;display:block!important;width:100%!important;max-width:none!important;min-height:48px!important;height:48px!important;padding:0 16px!important;margin:0!important;border:1px solid var(--aes-page-contact-section1-control-border)!important;border-radius:0!important;background:var(--aes-bg-primary)!important;color:var(--aes-text-secondary)!important;font:400 14px/1.6 var(--aes-font-body)!important;letter-spacing:0!important;box-shadow:none!important;outline:none!important;transition:border-color var(--aes-duration) var(--aes-ease)}
          .${prefix}-field textarea{height:96px!important;min-height:96px!important;resize:vertical!important;padding:12px 16px!important}
          .${prefix}-field :is(input,textarea,select)::placeholder{color:var(--aes-text-muted)!important;opacity:1!important}
          .${prefix}-field :is(input,textarea,select):is(:focus,:focus-visible){border-color:var(--aes-page-contact-section1-control-active)!important;outline:0!important;box-shadow:none!important}
          @media(hover:hover) and (pointer:fine){.${prefix}-field :is(input,textarea,select):hover:where(:not(:disabled)){border-color:var(--aes-page-contact-section1-control-active)!important}}
          .${prefix}-field :is(input,textarea,select)[aria-invalid="true"],.${prefix}-field[class*="_withError_"]>textarea,.${prefix}-field:has(+output[role="alert"]) :is(input,textarea,select){border-color:var(--aes-page-contact-section1-control-error)!important}
          output[role="alert"],[role="alert"]{grid-column:1/-1!important;margin:0!important;font:400 12px/1.6 var(--aes-font-body)!important;color:var(--aes-page-contact-section1-control-error)!important;text-transform:none!important;overflow-wrap:anywhere}
          .${prefix}-native-error{position:absolute!important;width:1px!important;height:1px!important;padding:0!important;margin:-1px!important;overflow:hidden!important;clip-path:inset(50%)!important;white-space:nowrap!important}
          .${prefix}-field-error{order:1!important;display:block;margin:0!important;color:var(--aes-page-contact-section1-control-error)!important;font:400 12px/1.6 var(--aes-font-body)!important;text-transform:none!important}
          [data-testid="btn-form-submit"]{position:relative!important;display:inline-flex!important;align-items:center!important;justify-content:center!important;gap:12px!important;justify-self:center!important;grid-column:1/-1!important;box-sizing:border-box!important;min-height:49px!important;height:49px!important;width:max-content!important;max-width:100%!important;margin:0!important;padding:0 16px!important;border:1px solid var(--aes-text-primary)!important;border-radius:0!important;box-shadow:none!important;background:transparent!important;color:var(--aes-text-primary)!important;font:400 16px/1.35 var(--aes-font-heading)!important;letter-spacing:0!important;text-transform:uppercase;transition:background var(--aes-duration),color var(--aes-duration)}
          [data-testid="btn-form-submit"]::after{content:'';position:absolute;inset:var(--aes-button-inset);border:var(--aes-button-inset-border-width) solid currentColor;opacity:0;pointer-events:none;transition:opacity var(--aes-duration)}
          [data-testid="btn-form-submit"]:is(:active,:focus-visible){background:#897266!important;border-color:#897266!important;color:var(--aes-text-inverse)!important}
          [data-testid="btn-form-submit"]:is(:active,:focus-visible)::after{opacity:1}
          [data-testid="btn-form-submit"]:focus{outline:none!important;box-shadow:none!important}
          .${prefix}-arrow{display:flex;align-items:center;justify-content:center;position:relative;width:16px;height:16px;flex:none}
          .${prefix}-arrow svg{display:block;width:24px;height:24px;flex:none;transform:rotate(-45deg) scale(.6666667)}
          .${prefix}-arrow [fill]:not([fill="none"]){fill:currentColor}
          [data-aes-page-contact-section1-busy] .${prefix}-arrow svg{visibility:hidden}
          [data-aes-page-contact-section1-busy] .${prefix}-arrow::after{content:'';position:absolute;inset:0;border:2px solid currentColor;border-right-color:transparent;border-radius:50%;animation:aes-page-contact-section1-submit 1s linear infinite}
          [data-aes-page-contact-section1-busy]>svg{display:none!important}
          [data-aes-page-contact-section1-busy] [data-testid="spinner-icon"]{display:none!important}
          [data-aes-page-contact-section1-busy] [class*="_visuallyHidden_"]{position:static!important;width:auto!important;height:auto!important;padding:0!important;margin:0!important;overflow:visible!important;clip:auto!important;clip-path:none!important;white-space:normal!important}
          [data-testid="btn-form-submit"][data-aes-page-contact-section1-busy]{min-width:var(--aes-page-contact-section1-submit-width,0px)!important}
          .${prefix}-status{grid-column:1/-1;margin:0;font:400 14px/1.6 var(--aes-font-body);color:var(--aes-text-secondary)}
          .${prefix}-status[hidden]{display:none!important}
          form[data-aes-page-contact-section1-busy] :is(input,textarea,select,button){cursor:wait}
          [data-testid="banner-success"]{position:relative;box-sizing:border-box;padding:24px 56px 24px 24px!important;border:1px solid #e5e5e5;background:#f7f7f7;color:var(--aes-text-primary);text-align:left}
          [data-testid="banner-success"] h2{margin:0 0 4px!important;font:400 16px/1.35 var(--aes-font-heading)!important;outline:none}
          [data-testid="banner-success"] p{margin:0!important;font:400 14px/1.6 var(--aes-font-body)!important;color:#66615e!important}
          [data-testid="banner-success"] [data-aes-form-success-close]{position:absolute;top:16px;right:16px;display:inline-flex;align-items:center;justify-content:center;width:24px;height:24px;padding:0;border:0;background:transparent;color:var(--aes-text-muted);cursor:pointer}
          [data-testid="banner-success"] [data-aes-form-success-close] svg{width:20px;height:20px}
          @keyframes aes-page-contact-section1-submit{to{transform:rotate(360deg)}}
          @media(hover:hover) and (pointer:fine){[data-testid="btn-form-submit"]:hover:not(:disabled):not([aria-disabled="true"]){background:#897266!important;border-color:#897266!important;color:var(--aes-text-inverse)!important}[data-testid="btn-form-submit"]:hover:not(:disabled):not([aria-disabled="true"])::after{opacity:1}}
          @media(min-width:768px){form[data-aes-page-contact-section1-form]{grid-template-columns:minmax(0,1fr) minmax(0,1fr)!important;column-gap:32px!important}.${prefix}-field{gap:12px!important}.${prefix}-field:has(:is(textarea)){grid-column:1/-1}}
          @media(prefers-reduced-motion:reduce){[data-testid="btn-form-submit"],[data-testid="btn-form-submit"]::after{transition:none!important}[data-aes-page-contact-section1-busy] .${prefix}-arrow::after{animation:none}}
        
          .aes-page-contact-section1-field{order:var(--aes-page-contact-section1-field-order)}
          .aes-page-contact-section1-cart{grid-column:1/-1;order:7;display:flex;align-items:center;gap:12px;margin:0;font:400 14px/1.6 var(--aes-font-body);cursor:pointer}
          .aes-page-contact-section1-cart input{appearance:none!important;-webkit-appearance:none!important;display:inline-grid;place-items:center;width:20px;height:20px;min-width:20px;margin:0;padding:0;border:1px solid var(--aes-text-primary);border-radius:0;background:var(--aes-bg-primary);flex:none;cursor:pointer}
          .aes-page-contact-section1-cart input::after{content:'';display:block;width:20px;height:20px;background:var(--aes-text-inverse);mask:var(--aes-page-contact-section1-check-icon) center/contain no-repeat;-webkit-mask:var(--aes-page-contact-section1-check-icon) center/contain no-repeat;opacity:0}
          .aes-page-contact-section1-cart input:checked{background:var(--aes-text-primary);border-color:var(--aes-text-primary)}
          .aes-page-contact-section1-cart input:checked::after{opacity:1}
          .aes-page-contact-section1-cart input:focus-visible{outline:2px solid var(--aes-border-focus)!important;outline-offset:2px}
          .aes-page-contact-section1-snapshot{display:none!important}
          .aes-page-contact-section1-field [data-aes-page-contact-section1-native-country]{display:none!important}
          .aes-page-contact-section1-field select{appearance:none;background-image:none!important;padding-right:44px!important}
          .aes-page-contact-section1-country{position:relative}
          .aes-page-contact-section1-country svg{position:absolute;right:16px;top:14px;width:20px;height:20px;pointer-events:none;transform:rotate(90deg);color:#897266}
          .aes-page-contact-section1-phone{order:3!important;display:block!important;position:relative!important;min-width:0!important}
          .aes-page-contact-section1-phone .phone-country-selector{position:absolute;left:1px;top:31px;z-index:2;width:74px;height:46px}
          .aes-page-contact-section1-phone .phone-country-selector button{height:46px;max-height:none;padding:0 10px;border:0;border-radius:0;background:transparent;box-shadow:none}
          .aes-page-contact-section1-phone .phone-country-selector button:focus-visible{outline:1px solid #897266;outline-offset:-1px;box-shadow:none}
          .aes-page-contact-section1-phone .phone-country-selector img{width:24px;height:16px;object-fit:contain}

          .aes-page-contact-section1-phone [class*="_dropdownContainer_"]{position:absolute!important;top:46px!important;bottom:auto!important;left:0!important;right:auto!important;width:var(--aes-contact-phone-menu-width,100%)!important;max-width:calc(100vw - 32px)!important;transform:none!important;margin:0!important;z-index:20!important;border-radius:0!important;box-shadow:none!important}
          .aes-page-contact-section1-phone [role="listbox"]{box-sizing:border-box!important;width:100%!important;max-width:none!important;margin:0!important;padding:0!important;overflow-x:hidden!important;border:1px solid var(--aes-page-contact-section1-control-active)!important;border-radius:0!important;background:var(--aes-bg-primary)!important;box-shadow:none!important;text-align:left!important}
          .aes-page-contact-section1-phone [role="listbox"]::-webkit-scrollbar{width:6px}
          .aes-page-contact-section1-phone [role="listbox"]::-webkit-scrollbar-thumb{background:var(--aes-text-muted);border-radius:0}
          .aes-page-contact-section1-phone [role="listbox"]::-webkit-scrollbar-button{display:none;width:0;height:0}
          .aes-page-contact-section1-phone [class*="_optionListItem_"]{margin:0!important;border:0!important;outline:0!important;box-shadow:none!important;border-radius:0!important;background:transparent!important}
          .aes-page-contact-section1-phone [role="option"]{box-sizing:border-box!important;display:flex;align-items:center;min-height:48px;padding:12px 16px!important;margin:0!important;border:0!important;outline:0!important;box-shadow:none!important;border-radius:0!important;background:var(--aes-bg-primary)!important;color:var(--aes-text-secondary)!important;font:400 14px/1.6 var(--aes-font-body)!important;text-align:left!important;white-space:normal!important;overflow-wrap:anywhere}
          .aes-page-contact-section1-phone [role="option"]:is(:hover,:focus,:focus-visible,[aria-selected="true"]){background:var(--aes-bg-subtle)!important;outline:0!important}
          .aes-page-contact-section1-field input[type=tel]{padding-left:84px!important}
          @media(min-width:768px){.aes-page-contact-section1-phone .phone-country-selector{top:35px}}
          @media(min-width:1440px){.${prefix}-field label{font-size:16px!important;line-height:round(nearest,25.6px,1px)!important}.aes-page-contact-section1-phone .phone-country-selector{top:39px}.aes-page-contact-section1-cart{font-size:16px;line-height:24px}}
          [data-testid="btn-form-submit"]{order:8!important}
          .aes-page-contact-section1-status,[role="alert"]{order:9!important}
          .aes-page-contact-section1-cart-error{grid-column:1/-1;order:8;margin:0;color:#c62828;font:400 12px/1.6 var(--aes-font-body)}
[data-testid="btn-form-submit"][data-aes-form-sent],[data-testid="btn-form-submit"][data-aes-form-sent]:is(:hover,:active,:focus){position:relative!important;box-sizing:border-box!important;inline-size:79px!important;block-size:49px!important;min-inline-size:0!important;border:1px solid #d3d3d1!important;background:transparent!important;color:transparent!important;font-size:0!important;box-shadow:none!important;cursor:default!important;transition:none!important}
[data-testid="btn-form-submit"][data-aes-form-sent]>:not([data-aes-form-sent-copy]){visibility:hidden!important}
[data-testid="btn-form-submit"][data-aes-form-sent]::before,[data-testid="btn-form-submit"][data-aes-form-sent]::after{display:none!important;content:none!important}
[data-testid="btn-form-submit"][data-aes-form-sent]>[data-aes-form-sent-copy]{position:absolute!important;inset:0!important;display:flex!important;align-items:center!important;justify-content:center!important;visibility:visible!important;margin:0!important;padding:0!important;color:#8c8c8c!important;font-family:var(--aes-form-sent-font-family,inherit)!important;font-size:var(--aes-form-sent-font-size,14px)!important;font-weight:400!important;line-height:1.6!important;letter-spacing:inherit!important;pointer-events:none!important}
        
          /* Contact form geometry follows its three device frames. */
          form[data-aes-page-contact-section1-form]{row-gap:20px!important}
          .${prefix}-field label{font-size:14px!important;line-height:22px!important}
          .${prefix}-field label:has(+ :is(input,textarea,select):required)::after,.${prefix}-field label::after{font-size:16px;line-height:26px}
          [data-testid="btn-form-submit"]{min-height:41px!important;height:41px!important;padding:8px!important;font-size:var(--aes-info-contact-submit)!important;line-height:round(nearest,calc(var(--aes-info-contact-submit) * 1.35),1px)!important;gap:12px!important}
          .${prefix}-arrow{width:8px!important;height:8px!important;flex:0 0 8px!important}
          .${prefix}-arrow svg{width:24px!important;height:24px!important;flex:none!important;transform:rotate(-45deg) scale(calc(8 / 13.5))!important}
          .aes-page-contact-section1-cart input{position:relative;width:24px;height:24px;min-width:24px;border:0;background:transparent}
          .aes-page-contact-section1-cart input::before{content:'';position:absolute;inset:2px;box-sizing:border-box;border:1px solid var(--aes-text-primary);background:var(--aes-bg-primary);pointer-events:none}
          .aes-page-contact-section1-cart input::after{position:absolute;left:50%;top:50%;transform:translate(-50%,-50%);pointer-events:none}
          .aes-page-contact-section1-cart input:checked{border:0;background:transparent}
          .aes-page-contact-section1-cart input:checked::before{background:var(--aes-bg-inverse);border-color:var(--aes-bg-inverse)}
          .aes-page-contact-section1-cart{font-size:14px;line-height:22px}
          .aes-page-contact-section1-phone .phone-country-selector{top:35px}
          [data-testid="btn-form-submit"][data-aes-form-sent],[data-testid="btn-form-submit"][data-aes-form-sent]:is(:hover,:active,:focus){block-size:41px!important}
          @media(min-width:768px){form[data-aes-page-contact-section1-form]{row-gap:24px!important}.aes-page-contact-section1-phone .phone-country-selector{top:39px}}
        `;
        root.append(style);
      }
      this.decorate();
      this.setLoading(false);
      this.restoreSuccessForm();
      if (this.form) {
        this.form.addEventListener('submit',event=>{
          if (this.successCooling()) { event.preventDefault(); event.stopImmediatePropagation(); return; }
          if (this.prepared) { this.prepared=false; this.attempted=true; this.awaitingNative=true; queueMicrotask(()=>{this.preparing=false;this.syncBusy();}); return; }
          if (this.busy || this.preparing) { event.preventDefault(); event.stopImmediatePropagation(); return; }
          const visible=[...this.form.querySelectorAll('.aes-page-contact-section1-field input,.aes-page-contact-section1-field textarea')];
          if (visible.some(input=>!input.validity.valid)) { this.attempted=true; queueMicrotask(()=>this.syncBusy()); return; }
          event.preventDefault(); event.stopImmediatePropagation(); this.prepareSubmission();
        },{capture:true,signal:this.abort.signal});
        this.form.addEventListener('input',event=>{
          if (!this.busy && !this.preparing) this.attempted=false;
          if (event.target.matches('input,textarea,select')) event.target.setCustomValidity('');
        },{signal:this.abort.signal});
        this.pendingTimer=setInterval(()=>this.syncBusy(),250);
      }
      this.observer=new MutationObserver(()=>{
        this.observer.disconnect();
        if (this.form!==root.querySelector('form')) { this.attach(root); return; }
        this.decorate();
        this.syncBusy();
        this.observer.observe(root,{childList:true,subtree:true,characterData:true,attributes:true,attributeFilter:['disabled','aria-disabled','aria-invalid']});
      });
      this.observer.observe(root,{childList:true,subtree:true,characterData:true,attributes:true,attributeFilter:['disabled','aria-disabled','aria-invalid']});
    }
    initSuccess() {
      this.successLifecycleAbort?.abort();
      this.successLifecycleAbort=new AbortController();
      this.successKey ||= (this.tagName.toLowerCase()==='aes-page-contact-section1'?'aes-contact-success:':'aes-inquiry-success:')+location.pathname+':'+this.id;
      const valid=notice=>notice && Number.isFinite(notice.at) && Date.now()-notice.at>=0 && Date.now()-notice.at<300000;
      let received=this.successRecoveryNotice || this.receivedNotice;
      if (!valid(received)) received=null;
      let stored;
      try {
        const raw=sessionStorage.getItem(this.successKey);
        sessionStorage.removeItem(this.successKey);
        stored=raw?JSON.parse(raw):null;
      } catch {}
      if (!received && valid(stored)) received=stored;
      try {
        if (history.state?.aesInquirySuccess?.key===this.successKey) {
          if (!received && valid(history.state.aesInquirySuccess.notice)) received=history.state.aesInquirySuccess.notice;
          const state={...history.state}; delete state.aesInquirySuccess;
          history.replaceState(state,'');
        }
      } catch {}
      if (received) {
        const notice={at:received.at,heading:'Message sent',description:'Thank you for reaching out. We’ll respond within 1–2 business days.'};
        if (this.tagName.toLowerCase()==='aes-page-contact-section1') notice.attachCart=true;
        this.successRecoveryNotice=notice;
        if (!this.successNoticeDismissed) this.showReceivedNotice(notice);
      }
      const schedule=()=>this.scheduleSuccessPosition();
      const signal=this.successLifecycleAbort.signal;
      window.addEventListener('scroll',schedule,{passive:true,signal});
      window.addEventListener('resize',schedule,{passive:true,signal});
      window.visualViewport?.addEventListener('resize',schedule,{passive:true,signal});
      window.visualViewport?.addEventListener('scroll',schedule,{passive:true,signal});
      window.addEventListener('pageshow',()=>{this.syncSuccessButton();this.scheduleSuccessPosition();},{signal});
      document.addEventListener('visibilitychange',()=>{if(!document.hidden){this.syncSuccessButton();this.scheduleSuccessPosition();}},{signal});
      this.successHeaderObserver?.disconnect();
      this.successHeaderResize?.disconnect();
      const header=document.querySelector('.aes-header-section1-host');
      if (header) {
        this.successHeaderObserver=new MutationObserver(schedule);
        this.successHeaderObserver.observe(header,{subtree:true,attributes:true,attributeFilter:['data-aes-header-hidden','data-aes-menu-open','aria-expanded']});
        if (typeof ResizeObserver!=='undefined') {
          this.successHeaderResize=new ResizeObserver(schedule);
          this.successHeaderResize.observe(header);
        }
      }
      this.scheduleSuccessPosition();
      this.syncSuccessButton();
    }
    showReceivedNotice(notice) {
      if (!this.loadingRegion) return;
      this.successNoticeAbort?.abort(); this.successNoticeAbort=new AbortController();
      this.loadingRegion.querySelector('[data-aes-form-success-notice]')?.remove();
      const banner=document.createElement('div');
      banner.className='aes-form-success-notice'; banner.dataset.aesFormSuccessNotice='';
      banner.setAttribute('role','status');
      const header=document.createElement('div'); header.className='aes-form-success-header';
      const heading=document.createElement('h2'); heading.textContent='Message sent'; heading.tabIndex=-1;
      const description=document.createElement('p'); description.textContent='Thank you for reaching out. We’ll respond within 1–2 business days.';
      const copy=this.copy || this.querySelector('template[data-aes-page-design-services-section5-copy],template[data-aes-page-contact-section1-copy]')?.content;
      const close=copy?.querySelector('[data-aes-form-success-close]')?.cloneNode(true);
      header.append(heading);
      if (close) {
        close.addEventListener('click',()=>{
          banner.remove(); this.receivedNotice=null; this.successNoticeDismissed=true;
        },{signal:this.successNoticeAbort.signal});
        header.append(close);
      }
      banner.append(header,description); this.loadingRegion.prepend(banner);
      this.receivedNotice=notice; this.successRecoveryNotice=notice;
      this.successFocusPending=true;
      this.scheduleSuccessPosition();
    }
    rememberSuccess(success) {
      if (this.restoringForm || !success?.matches?.('[data-testid="banner-success"]')) return {saved:false,notice:null};
      this.restoringForm=true;
      const notice={at:Date.now(),heading:'Message sent',description:'Thank you for reaching out. We’ll respond within 1–2 business days.'};
      if (this.tagName.toLowerCase()==='aes-page-contact-section1') notice.attachCart=true;
      let saved=false;
      try {sessionStorage.setItem(this.successKey,JSON.stringify(notice));saved=true;} catch {}
      if (!saved) try {history.replaceState({...history.state,aesInquirySuccess:{key:this.successKey,notice}},'');saved=true;} catch {}
      return {saved,notice};
    }
    restoreSuccessForm() {
      const form=this.form;
      if (this.tagName.toLowerCase()==='aes-page-contact-section1' && form && this.successLifecycleAbort && (this.successContactForm!==form || this.successContactSignal!==this.successLifecycleAbort.signal)) {
        const capture=()=>{
          const choice=form.querySelector('[data-aes-page-contact-section1-cart] input[type="checkbox"]');
          if (choice) this.successCartChoice=choice.checked;
        };
        this.successContactForm=form; this.successContactSignal=this.successLifecycleAbort.signal;
        form.addEventListener('change',capture,{signal:this.successContactSignal});
        form.addEventListener('submit',capture,{capture:true,signal:this.successContactSignal});
        capture();
      }
      const notice=this.successRecoveryNotice || this.receivedNotice;
      if (!notice || !form || !this.isConnected || !this.root?.contains(form) || form.hidden) return;
      if (this.loadingRegion?.hasAttribute('data-aes-form-loading')) {
        if (!this.successRestoreFrame) this.successRestoreFrame=requestAnimationFrame(()=>{
          this.successRestoreFrame=null;
          if (this.isConnected && !this.loadingRegion?.hasAttribute('data-aes-form-loading')) this.restoreSuccessForm();
        });
        return;
      }
      if (this.tagName.toLowerCase()==='aes-page-contact-section1' && !this.successCartRestored && typeof notice.attachCart==='boolean') {
        const choice=form.querySelector('[data-aes-page-contact-section1-cart] input[type="checkbox"]');
        if (!choice) return;
        choice.checked=notice.attachCart; this.successCartChoice=notice.attachCart; this.successCartRestored=true;
      }
      if (!this.successCountdownStarted) {
        this.successCountdownStarted=true; this.successSentUntil=Date.now()+3000;
      }
      this.restoringForm=false;
      this.syncSuccessButton();
      if (this.successFocusPending) {
        this.successFocusPending=false;
        this.successFocusFrame=requestAnimationFrame(()=>{
          this.successFocusFrame=null;
          if (!this.isConnected) return;
          const heading=this.loadingRegion?.querySelector('[data-aes-form-success-notice] h2');
          if (!heading) return;
          heading.focus({preventScroll:true});
          if (window.innerWidth>=768) heading.scrollIntoView({block:'center',behavior:'instant'});
        });
      }
    }
    successCooling() {
      return !!this.successCountdownStarted && Number.isFinite(this.successSentUntil) && Date.now()<this.successSentUntil;
    }
    releaseSuccessButton() {
      const state=this.successButtonState;
      if (!state) return;
      const button=state.button;
      button.removeAttribute('data-aes-form-sent');
      button.querySelector('[data-aes-form-sent-copy]')?.remove();
      button.disabled=state.disabled;
      if (state.hasAriaLabel) button.setAttribute('aria-label',state.ariaLabel); else button.removeAttribute('aria-label');
      for (const [name,value,priority] of state.properties) {
        if (value) button.style.setProperty(name,value,priority); else button.style.removeProperty(name);
      }
      this.successButtonState=null;
    }
    syncSuccessButton() {
      const button=this.form?.querySelector('[data-testid="btn-form-submit"]');
      if (this.successButtonState && this.successButtonState.button!==button) this.releaseSuccessButton();
      if (!this.successCooling()) {
        clearTimeout(this.successTimer); this.successTimer=null;
        this.releaseSuccessButton(); return false;
      }
      if (!button || !this.isConnected) return true;
      if (!this.successButtonState) {
        const names=['--aes-form-sent-width','--aes-form-sent-height','--aes-form-sent-font-size','--aes-form-sent-font-family'];
        const properties=names.map(name=>[name,button.style.getPropertyValue(name),button.style.getPropertyPriority(name)]);
        this.successButtonState={button,disabled:button.disabled,hasAriaLabel:button.hasAttribute('aria-label'),ariaLabel:button.getAttribute('aria-label'),properties};
        const rect=button.getBoundingClientRect();
        if (rect.width>0) button.style.setProperty(names[0],rect.width+'px');
        if (rect.height>0) button.style.setProperty(names[1],rect.height+'px');
        const computed=getComputedStyle(button);
        button.style.setProperty(names[2],computed.fontSize || '14px');
        button.style.setProperty(names[3],computed.fontFamily || 'inherit');
      }
      if (!button.hasAttribute('data-aes-form-sent')) button.setAttribute('data-aes-form-sent','');
      if (!button.disabled) button.disabled=true;
      if (button.getAttribute('aria-label')!=='SENT') button.setAttribute('aria-label','SENT');
      if (!button.querySelector('[data-aes-form-sent-copy]')) {
        const label=document.createElement('span'); label.dataset.aesFormSentCopy='';label.setAttribute('aria-hidden','true');label.textContent='SENT';button.append(label);
      }
      if (!this.successTimer) this.successTimer=setTimeout(()=>{
        this.successTimer=null;
        if (this.isConnected) this.syncSuccessButton();
      },Math.max(0,this.successSentUntil-Date.now()));
      return true;
    }
    scheduleSuccessPosition() {
      if (!this.isConnected || !this.loadingRegion?.querySelector('[data-aes-form-success-notice]')) return;
      this.successTrackUntil=Date.now()+260;
      if (this.successPositionFrame) return;
      const update=()=>{
        this.successPositionFrame=null;
        if (!this.isConnected) return;
        const notice=this.loadingRegion?.querySelector('[data-aes-form-success-notice]');
        if (!notice) return;
        if (window.innerWidth<768) {
          const bottom=document.querySelector('.aes-header-section1-host')?.getBoundingClientRect().bottom || 0;
          const value=Math.max(0,bottom)+8+'px';
          if (notice.style.getPropertyValue('--aes-form-success-top')!==value) notice.style.setProperty('--aes-form-success-top',value);
          if (Date.now()<this.successTrackUntil) this.successPositionFrame=requestAnimationFrame(update);
        } else notice.style.removeProperty('--aes-form-success-top');
      };
      this.successPositionFrame=requestAnimationFrame(update);
    }
    disposeSuccess() {
      this.successLifecycleAbort?.abort(); this.successNoticeAbort?.abort();
      this.successHeaderObserver?.disconnect(); this.successHeaderResize?.disconnect();
      clearTimeout(this.successTimer); this.successTimer=null;
      cancelAnimationFrame(this.successPositionFrame); this.successPositionFrame=null;
      cancelAnimationFrame(this.successRestoreFrame); this.successRestoreFrame=null;
      cancelAnimationFrame(this.successFocusFrame); this.successFocusFrame=null;
      this.releaseSuccessButton();
    }
    completeSubmission(success) {
      const {saved,notice}=this.rememberSuccess(success);
      if (!notice) return;
      const heading=success.querySelector('h2'),description=success.querySelector('p');
      if (heading) heading.textContent=notice.heading;
      if (description) description.textContent=notice.description;
      if (saved) {
        this.showReceivedNotice(notice);
        success.style.setProperty('display','none','important');
      }
      if (saved) location.reload();
      else {
        const close=this.copy.querySelector('[data-aes-form-success-close]').cloneNode(true);
        close.addEventListener('click',()=>location.reload(),{signal:this.abort.signal}); success.append(close);
      }
    }
    positionPhoneMenu() {
      const phone=this.form?.querySelector('.aes-page-contact-section1-phone');
      if (!phone) return;
      phone.style.setProperty('--aes-contact-phone-menu-width',Math.max(0,phone.getBoundingClientRect().width-2)+'px');
      const popup=phone.querySelector('[class*="_dropdownContainer_"]');
      if (!popup || this.phoneMenus?.has(popup)) return;
      (this.phoneMenus ||= new WeakSet()).add(popup);
      requestAnimationFrame(()=>{
        if (!popup.isConnected || this.abort.signal.aborted) return;
        const bottom=popup.getBoundingClientRect().bottom;
        const viewportBottom=window.visualViewport?window.visualViewport.offsetTop+window.visualViewport.height:window.innerHeight;
        if (bottom>viewportBottom-16) window.scrollBy({top:bottom-viewportBottom+16,behavior:'instant'});
      });
    }
    decorate() {
      const prefix='aes-page-contact-section1',form=this.form;
      if (!form) {
        const success=this.root.querySelector('[data-testid="banner-success"]');
        if (success) this.completeSubmission(success);
        const heading=success?.querySelector('h2');
        if (heading && !heading.hasAttribute('tabindex')) { heading.tabIndex=-1; heading.focus({preventScroll:true}); }
        return;
      }
      form.dataset.aesPageContactSection1Form='';
      for (const id of ['first_name','last_name','email','phone_number','custom#country_region','custom#zip_postal_code','custom#message']) {
        const input=form.querySelector('[id="'+id+'"],[name="'+id+'"]');
        if (!input) continue;
        if (!input.id) input.id=id;
        const group=input.closest('[class*="_formFieldContainer_"]') || input.parentElement;
        group.classList.add(prefix+'-field');
        const label=group.querySelector('label');
        if (label && id==='custom#country_region' && label.textContent!=='Country/Region') label.textContent='Country/Region';
        if (label && id==='custom#zip_postal_code' && label.textContent!=='Zip/Postal Code') label.textContent='Zip/Postal Code';
        input.required=true;
        if (id==='email') { input.type='email'; input.autocomplete='email'; }
        
        group.style.setProperty('--aes-page-contact-section1-field-order',String(['first_name','last_name','email','phone_number','custom#country_region','custom#zip_postal_code','custom#message'].indexOf(id)));
        if (id==='phone_number') input.closest('[class*="_formPhoneInputContainer_"]')?.classList.add(prefix+'-phone');
        if (id==='first_name') input.autocomplete='given-name';
        if (id==='last_name') input.autocomplete='family-name';
        if (id==='custom#zip_postal_code') input.autocomplete='postal-code';
        if (id==='custom#country_region') this.decorateCountry(input,group);
        if (input.tagName==='TEXTAREA') input.maxLength=5000;
        const placeholder=this.copy.querySelector('[data-aes-page-contact-section1-placeholder="'+(id==='phone_number'?'phone':id)+'"]')?.textContent.trim() || label?.textContent.trim() || '';
        if (input.placeholder!==placeholder) input.placeholder=placeholder;
        const nativeError=group.nextElementSibling?.matches('output[role="alert"]') ? group.nextElementSibling : null;
        let errorCopy=group.querySelector('.'+prefix+'-field-error');
        const previousError=input.dataset.aesPageContactSection1Error;
        const described=new Set((input.getAttribute('aria-describedby') || '').split(/\s+/).filter(Boolean));
        if (previousError) described.delete(previousError);
        if (nativeError) {
          nativeError.classList.add(prefix+'-native-error');
          if (!nativeError.id) nativeError.id=id+'-aes-error';
          input.dataset.aesPageContactSection1Error=nativeError.id;
          described.add(nativeError.id);
          if (!errorCopy) { errorCopy=document.createElement('span'); errorCopy.className=prefix+'-field-error'; errorCopy.setAttribute('aria-hidden','true'); group.append(errorCopy); }
          if (errorCopy.textContent!==nativeError.textContent) errorCopy.textContent=nativeError.textContent;
        } else {
          errorCopy?.remove();
          delete input.dataset.aesPageContactSection1Error;
        }
        if (described.size) input.setAttribute('aria-describedby',Array.from(described).join(' ')); else input.removeAttribute('aria-describedby');
        if (id==='custom#country_region') this.decorateCountry(input,group);
      }
      this.positionPhoneMenu();
      this.decorateCart();
      const button=form.querySelector('[data-testid="btn-form-submit"]');
      if (button && !button.querySelector('[data-aes-page-contact-section1-arrow]')) button.append(this.copy.querySelector('[data-aes-page-contact-section1-arrow]').cloneNode(true));
      let status=form.querySelector('[data-aes-page-contact-section1-status]');
      if (!status) { status=document.createElement('p'); status.className=prefix+'-status'; status.dataset.aesPageContactSection1Status=''; status.setAttribute('role','status'); status.setAttribute('aria-live','polite'); status.hidden=true; form.append(status); }
      const nativeDisclaimer=form.parentElement.querySelector('[class*="_formDisclaimer_"]');
      if (nativeDisclaimer) nativeDisclaimer.hidden=true;
      this.restoreSuccessForm();
    }

    setNativeValue(input,value) {
      const prototype=input.tagName==='TEXTAREA' ? HTMLTextAreaElement.prototype : HTMLInputElement.prototype;
      Object.getOwnPropertyDescriptor(prototype,'value').set.call(input,value);
      input.dispatchEvent(new Event('input',{bubbles:true}));
      input.dispatchEvent(new Event('change',{bubbles:true}));
    }
    decorateCountry(input,group) {
      input.dataset.aesPageContactSection1NativeCountry='';
      input.tabIndex=-1;
      let wrapper=group.querySelector('.aes-page-contact-section1-country');
      if (!wrapper) {
        wrapper=this.copy.querySelector('.aes-page-contact-section1-country').cloneNode(true);
        const select=wrapper.querySelector('select');
        select.id=this.id+'-country';
        const label=group.querySelector('label'); if (label) label.htmlFor=select.id;
        select.addEventListener('change',()=>this.setNativeValue(input,select.value),{signal:this.abort.signal});
        group.append(wrapper);
      }
      const select=wrapper.querySelector('select');
      if (select.value!==input.value) select.value=input.value;
      select.setAttribute('aria-invalid',input.getAttribute('aria-invalid')||'false');
      const described=input.getAttribute('aria-describedby'); if (described) select.setAttribute('aria-describedby',described); else select.removeAttribute('aria-describedby');
    }
    decorateCart() {
      const form=this.form;
      if (!form) return;
      const snapshot=form.querySelector('[id="custom#shopping_cart_snapshot"],[name="custom#shopping_cart_snapshot"]');
      const group=snapshot?.closest('[class*="_formFieldContainer_"]');
      group?.classList.add('aes-page-contact-section1-snapshot');
      if (!form.querySelector('[data-aes-page-contact-section1-cart]')) form.append(this.copy.querySelector('[data-aes-page-contact-section1-cart]').cloneNode(true));
    }
    cartSnapshot(cart,attach) {
      const snapshot={version:1,sourcePage:'Contact Us',sourceUrl:new URL(this.dataset.sourcePath,location.origin).href,submittedAt:new Date().toISOString(),attachCart:attach,items:[]};
      if (!attach) return snapshot;
      if (!cart || !Array.isArray(cart.items)) throw new Error('Your shopping cart could not be verified. Please try again.');
      snapshot.items=cart.items.map(item=>{
        if (!Number.isInteger(item.quantity) || item.quantity<1 || !String(item.product_title||item.title||'').trim()) throw new Error('Your shopping cart could not be verified. Please try again.');
        const url=new URL(item.url,location.origin);
        if (url.origin!==location.origin || !url.pathname.includes('/products/')) throw new Error('A shopping cart product link could not be verified. Please try again.');
        let image=''; const candidate=item.featured_image?.url || item.image;
        if (candidate) { const parsed=new URL(candidate,location.origin); if (parsed.protocol!=='https:') throw new Error('A shopping cart image could not be verified. Please try again.'); image=parsed.href; }
        return {title:String(item.product_title||item.title),sku:String(item.sku||''),variant:item.variant_title==='Default Title'?'':String(item.variant_title||''),quantity:item.quantity,url:url.href,image};
      });
      return snapshot;
    }
    cartError(message) {
      let error=this.form?.querySelector('[data-aes-page-contact-section1-cart-error]');
      if (!message) { error?.remove(); return; }
      if (!error) { error=document.createElement('p'); error.dataset.aesPageContactSection1CartError=''; error.className='aes-page-contact-section1-cart-error'; error.setAttribute('role','alert'); this.form.append(error); }
      error.textContent=message;
    }
    async prepareSubmission() {
      const form=this.form,field=form.querySelector('[id="custom#shopping_cart_snapshot"],[name="custom#shopping_cart_snapshot"]');
      if (!field) { this.cartError('This form is not ready. Please reload the page and try again.'); return; }
      this.cartError('');
      this.preparing=true; const controller=new AbortController(); this.prepareAbort=controller;
      const button=form.querySelector('[data-testid="btn-form-submit"]');
      button?.style.setProperty('--aes-page-contact-section1-submit-width',button.getBoundingClientRect().width+'px');
      this.syncBusy();
      const timeout=setTimeout(()=>controller.abort(),15000);
      try {
        const attach=form.querySelector('[data-aes-page-contact-section1-cart] input').checked;
        let cart=null;
        if (attach) {
          const response=await fetch(this.dataset.cartUrl,{credentials:'same-origin',cache:'no-store',signal:controller.signal});
          if (!response.ok) throw new Error('Your shopping cart could not be loaded. Please try again.');
          cart=await response.json();
        }
        if (!this.isConnected || this.form!==form) return;
        const serialized=JSON.stringify(this.cartSnapshot(cart,attach));
        if (serialized.length>Math.min(field.maxLength>0?field.maxLength:60000,60000)) throw new Error('Your shopping cart is too large to attach. Please reduce it or uncheck Attach My Shopping Cart before sending.');
        this.setNativeValue(field,serialized);
        await new Promise(resolve=>requestAnimationFrame(()=>requestAnimationFrame(resolve)));
        if (!this.isConnected || this.form!==form) return;
        this.prepared=true;
        form.requestSubmit();
      } catch(error) {
        if (!this.isConnected || this.form!==form) return;
        this.prepared=false; this.preparing=false; this.attempted=false; this.release();
        this.cartError(error.name==='AbortError'?'Your shopping cart could not be loaded in time. Please try again.':error.message);
      } finally { clearTimeout(timeout); if (this.prepareAbort===controller) this.prepareAbort=null; }
    }
    syncBusy() {
      const form=this.form;
      if (!form || !this.root.contains(form)) return;
      const button=form.querySelector('[data-testid="btn-form-submit"]');
      if (this.successCooling()) { this.release(); this.syncSuccessButton(); return; }
      this.syncSuccessButton();
      const nativeBusy=!!(button?.disabled || button?.getAttribute('aria-disabled')==='true');
      if (this.awaitingNative && (nativeBusy || form.querySelector('[aria-invalid="true"],output[role="alert"]'))) this.awaitingNative=false;
      const busy=this.preparing || this.awaitingNative || (this.attempted && nativeBusy);
      if (this.busy && !busy) this.attempted=false;
      this.busy=busy;
      form.toggleAttribute('data-aes-page-contact-section1-busy',busy);
      form.setAttribute('aria-busy',String(busy));
      button?.toggleAttribute('data-aes-page-contact-section1-busy',busy);
      if (busy) {
        this.pendingStarted ||= Date.now();
        for (const control of form.querySelectorAll('input,textarea,select,button')) {
          if (!this.locked.has(control)) this.locked.set(control,control.inert);
          control.inert=true;
        }
      } else this.release();
      const status=form.querySelector('[data-aes-page-contact-section1-status]');
      if (status) {
        status.hidden=!busy || Date.now()-this.pendingStarted<1500;
        const message=Date.now()-this.pendingStarted>90000 ? this.copy.querySelector('[data-aes-page-contact-section1-slow-message]').textContent.trim() || 'Your submission is taking longer than expected. Check any verification or error message before trying again.' : this.copy.querySelector('[data-aes-page-contact-section1-pending]').textContent.trim();
        if (busy && status.textContent!==message) status.textContent=message;
      }
    }
    release() {
      this.awaitingNative=false;
      for (const [control,inert] of this.locked || []) control.inert=inert;
      this.locked?.clear();
      this.busy=false;
      this.pendingStarted=0;
      this.form?.removeAttribute('data-aes-page-contact-section1-busy');
      this.form?.setAttribute('aria-busy','false');
      this.form?.querySelector('[data-testid="btn-form-submit"]')?.removeAttribute('data-aes-page-contact-section1-busy');
      this.form?.querySelector('[data-testid="btn-form-submit"]')?.style.removeProperty('--aes-page-contact-section1-submit-width');
      const status=this.form?.querySelector('[data-aes-page-contact-section1-status]');
      if (status) status.hidden=true;
    }
  });
}


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["aes-page-contact-section2"] && !Shopify.designMode) return;
  try {
    

if (!customElements.get('aes-page-contact-section2')) {
  class AesPageContactSection2 extends HTMLElement {
    connectedCallback() {
      if (this.dataset.aesRecommendationsState === 'pending') {
        this.observeRecommendations();
        return;
      }
      if (this.controller) return;
      this.track = this.querySelector('.aes-page-contact-section2-track');
      if (!this.track) return;
      this.cards = Array.from(this.track.children);
      this.previous = this.querySelector('[data-aes-page-contact-section2-previous]');
      this.next = this.querySelector('[data-aes-page-contact-section2-next]');
      this.controls = this.querySelector('.aes-page-contact-section2-controls');
      this.current = this.querySelector('[data-aes-page-contact-section2-current]');
      this.motion = matchMedia('(prefers-reduced-motion: reduce)');
      this.controller = new AbortController();
      const signal = this.controller.signal;
      this.activeIndex = 0;
      this.targetIndex = null;
      this.targets = [];
      this.previous?.addEventListener('click', () => this.move((this.targetIndex ?? this.activeIndex) - 1), { signal });
      this.next?.addEventListener('click', () => this.move((this.targetIndex ?? this.activeIndex) + 1), { signal });
      this.track.addEventListener('keydown', event => {
        if (event.target !== this.track || !this.overflow || !['ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(event.key)) return;
        event.preventDefault();
        if (event.key === 'Home') this.move(0);
        else if (event.key === 'End') this.move(this.targets.length - 1);
        else this.move((this.targetIndex ?? this.activeIndex) + ((event.key === 'ArrowRight') !== this.rtl ? 1 : -1));
      }, { signal });
      this.track.addEventListener('scroll', () => {
        if (this.scrollFrame) return;
        this.scrollFrame = requestAnimationFrame(() => { this.scrollFrame = null; this.sync(); });
      }, { passive: true, signal });
      this.track.addEventListener('scrollend', () => this.sync(), { signal });
      this.track.addEventListener('wheel', () => this.cancelMove(), { passive: true, signal });
      this.track.addEventListener('pointerdown', event => {
        if (event.button !== 0 || event.target.closest('button,input,textarea,select,video,iframe')) return;
        this.cancelMove();
        this.sync();
        this.suppressClick = false;
        if (event.pointerType === 'mouse' && this.overflow) this.drag = { id: event.pointerId, x: event.clientX, y: event.clientY, start: this.track.scrollLeft, moved: false };
      }, { passive: true, signal });
      window.addEventListener('pointermove', event => {
        const drag = this.drag;
        if (!drag || event.pointerId !== drag.id) return;
        const dx = event.clientX - drag.x, dy = event.clientY - drag.y;
        if (!drag.moved) {
          if (Math.abs(dx) < 6) return;
          if (Math.abs(dy) > Math.abs(dx)) { this.drag = null; return; }
          drag.moved = true;
          this.track.setPointerCapture(drag.id);
          this.track.setAttribute('data-aes-page-contact-section2-dragging', '');
          this.track.setAttribute('data-aes-page-contact-section2-moving', '');
        }
        event.preventDefault();
        this.track.scrollLeft = drag.start - dx;
      }, { signal });
      const endDrag = event => {
        if (!this.drag || event.pointerId !== this.drag.id) return;
        const moved = this.drag.moved;
        this.releaseDrag();
        if (moved) {
          this.suppressClick = true;
          clearTimeout(this.clickTimer);
          this.clickTimer = setTimeout(() => { this.suppressClick = false; }, 0);
          this.sync();
          this.move(this.activeIndex);
        }
      };
      window.addEventListener('pointerup', endDrag, { signal });
      window.addEventListener('pointercancel', endDrag, { signal });
      this.track.addEventListener('lostpointercapture', event => { if (this.drag?.id === event.pointerId) endDrag(event); }, { signal });
      this.track.addEventListener('click', event => { if (this.suppressClick) { event.preventDefault(); event.stopPropagation(); } }, { capture: true, signal });
      this.track.addEventListener('dragstart', event => event.preventDefault(), { signal });
      this.track.addEventListener('focusin', event => {
        if (this.drag?.moved || !this.overflow) return;
        const card = event.target.closest('.aes-page-contact-section2-card');
        const rect = card?.getBoundingClientRect(), bounds = this.track.getBoundingClientRect();
        if (rect && (rect.left < bounds.left - 1 || rect.right > bounds.right + 1)) this.reveal(card);
      }, { signal });
      this.addEventListener('shopify:block:select', event => {
        const card = this.cards.find(card => card.getAttribute('data-aes-page-contact-section2-block') === event.detail?.blockId);
        if (card) this.reveal(card);
      }, { signal });
      this.motion.addEventListener('change', () => { const target = this.targetIndex; this.cancelMove(); if (target !== null) this.move(target, false); }, { signal });
      this.observer = new ResizeObserver(() => {
        cancelAnimationFrame(this.measureFrame);
        this.measureFrame = requestAnimationFrame(() => { this.measureFrame = null; this.measure(); });
      });
      this.observer.observe(this.track);
      this.cards.forEach(card => this.observer.observe(card));
      this.measure();
    }
    observeRecommendations() {
      if (this.requestEvents) return;
      this.requestEvents = new AbortController();
      this.querySelector('[data-aes-recommendations-retry]')?.addEventListener('click', () => this.loadRecommendations(), { signal: this.requestEvents.signal });
      if (!('IntersectionObserver' in window)) { this.loadRecommendations(); return; }
      this.requestObserver = new IntersectionObserver(entries => {
        if (!entries.some(entry => entry.isIntersecting)) return;
        this.requestObserver.disconnect();
        this.loadRecommendations();
      }, { rootMargin: '200px 0px' });
      this.requestObserver.observe(this);
    }
    setRequestState(loading, failed = false) {
      this.setAttribute('aria-busy', String(loading));
      const request = this.querySelector('[data-aes-recommendations-request]');
      if (request) request.hidden = !loading && !failed;
      const placeholders = this.querySelector('[data-aes-recommendations-placeholders]');
      if (placeholders) placeholders.hidden = !loading;
      this.querySelectorAll('.aes-page-contact-section2-placeholder [data-aes-global-loading]').forEach(loader => { loader.hidden = !loading; });
      const error = this.querySelector('[data-aes-recommendations-error]');
      if (error) error.hidden = !failed;
      const status = this.querySelector('[data-aes-recommendations-status]');
      if (status) status.textContent = loading ? status.dataset.loadingText : failed ? status.dataset.errorText : '';
    }
    async loadRecommendations() {
      if (this.request || !this.dataset.aesRecommendationsUrl) return;
      const retryFocused = this.querySelector('[data-aes-recommendations-retry]') === document.activeElement;
      const request = new AbortController();
      this.request = request;
      this.setRequestState(true);
      const timeout = setTimeout(() => request.abort(), 12000);
      try {
        const response = await fetch(this.dataset.aesRecommendationsUrl, { signal: request.signal });
        if (!response.ok) throw new Error('Recommendations request failed');
        const document = new DOMParser().parseFromString(await response.text(), 'text/html');
        if (request.signal.aborted || this.request !== request || !this.isConnected) return;
        const result = document.getElementById(this.id);
        if (!result) {
          if (!document.getElementById('shopify-section-' + this.id.replace('aes-page-contact-section2-', ''))) throw new Error('Invalid recommendations response');
          this.setRequestState(false);
          this.dataset.aesRecommendationsState = 'empty';
          this.hidden = true;
          return;
        }
        if (result.dataset.aesRecommendationsState !== 'ready') throw new Error('Recommendations are not ready');
        this.setRequestState(false);
        this.requestEvents?.abort();
        this.requestEvents = null;
        this.innerHTML = result.innerHTML;
        this.dataset.aesProductCount = result.dataset.aesProductCount;
        this.dataset.aesRecommendationsState = 'ready';
        this.connectedCallback();
        if (retryFocused) this.track?.focus({ preventScroll: true });
      } catch (error) {
        if (this.isConnected && this.request === request) {
          this.setRequestState(false, true);
          if (retryFocused) this.querySelector('[data-aes-recommendations-retry]')?.focus({ preventScroll: true });
        }
      } finally {
        clearTimeout(timeout);
        if (this.request === request) this.request = null;
      }
    }
    measure() {
      const card = this.targets?.[this.targetIndex ?? this.activeIndex]?.card;
      this.cancelMove();
      this.releaseDrag();
      const style = getComputedStyle(this.track), bounds = this.track.getBoundingClientRect();
      this.rtl = style.direction === 'rtl';
      this.maximum = Math.max(0, this.track.scrollWidth - this.track.clientWidth);
      this.overflow = this.maximum > 1;
      this.track.tabIndex = this.overflow ? 0 : -1;
      if (this.controls) this.controls.hidden = !this.overflow;
      const padding = parseFloat(this.rtl ? style.scrollPaddingRight : style.scrollPaddingLeft) || 0;
      this.targets = [];
      this.cards.forEach((card, cardIndex) => {
        const rect = card.getBoundingClientRect();
        const position = this.track.scrollLeft + (this.rtl ? rect.right - bounds.right + padding : rect.left - bounds.left - padding);
        const value = this.rtl ? Math.max(-this.maximum, Math.min(0, position)) : Math.max(0, Math.min(this.maximum, position));
        if (!this.targets.some(target => Math.abs(target.value - value) < 1)) this.targets.push({ value, card, cardIndex });
      });
      if (card) this.reveal(card); else this.sync();
    }
    sync() {
      let nearest = 0, distance = Infinity;
      this.targets.forEach((target, index) => { const delta = Math.abs(target.value - this.track.scrollLeft); if (delta < distance) { nearest = index; distance = delta; } });
      this.activeIndex = nearest;
      const state = this.targetIndex ?? nearest;
      if (this.previous) this.previous.disabled = !this.overflow || state <= 0;
      if (this.next) this.next.disabled = !this.overflow || state >= this.targets.length - 1;
      if (this.current && this.targetIndex === null) {
        const text = String((this.targets[nearest]?.cardIndex ?? 0) + 1);
        if (this.current.textContent !== text) this.current.textContent = text;
      }
    }
    reveal(card) {
      let nearest = 0, distance = Infinity;
      const cardIndex = this.cards.indexOf(card);
      this.targets.forEach((target, index) => { const delta = Math.abs(target.cardIndex - cardIndex); if (delta < distance) { nearest = index; distance = delta; } });
      this.move(nearest, false);
    }
    cancelMove() {
      cancelAnimationFrame(this.animationFrame);
      this.animationFrame = null;
      this.targetIndex = null;
      this.track?.removeAttribute('data-aes-page-contact-section2-moving');
    }
    releaseDrag() {
      const drag = this.drag;
      this.drag = null;
      if (drag && this.track.hasPointerCapture(drag.id)) this.track.releasePointerCapture(drag.id);
      this.track?.removeAttribute('data-aes-page-contact-section2-dragging');
      this.track?.removeAttribute('data-aes-page-contact-section2-moving');
    }
    move(index, animate = true) {
      if (!this.targets.length) return;
      this.cancelMove();
      const next = Math.max(0, Math.min(this.targets.length - 1, index));
      const start = this.track.scrollLeft, end = this.targets[next].value;
      const token = getComputedStyle(this).getPropertyValue('--aes-duration').trim();
      const duration = animate && !this.motion.matches ? parseFloat(token) * (token.endsWith('ms') ? 1 : 1000) : 0;
      if (!Number.isFinite(duration) || duration <= 1 || Math.abs(end - start) < 1) { this.track.scrollLeft = end; this.sync(); return; }
      this.targetIndex = next;
      this.track.setAttribute('data-aes-page-contact-section2-moving', '');
      this.sync();
      let began;
      const tick = time => {
        began ??= time;
        const progress = Math.min((time - began) / duration, 1);
        this.track.scrollLeft = start + (end - start) * (1 - Math.pow(1 - progress, 3));
        if (progress < 1) this.animationFrame = requestAnimationFrame(tick);
        else { this.track.scrollLeft = end; this.cancelMove(); this.sync(); }
      };
      this.animationFrame = requestAnimationFrame(tick);
    }
    disconnectedCallback() {
      this.requestObserver?.disconnect();
      this.requestEvents?.abort();
      this.requestEvents = null;
      this.request?.abort();
      this.request = null;
      this.cancelMove();
      this.releaseDrag();
      cancelAnimationFrame(this.scrollFrame);
      cancelAnimationFrame(this.measureFrame);
      clearTimeout(this.clickTimer);
      this.observer?.disconnect();
      this.controller?.abort();
      this.controller = null;
    }
  }
  customElements.define('aes-page-contact-section2', AesPageContactSection2);
}


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["aes-page-design-services-section3"] && !Shopify.designMode) return;
  try {
    

  if (!customElements.get('aes-page-design-services-section3-viewer')) {
    customElements.define('aes-page-design-services-section3-viewer', class extends HTMLElement {
      connectedCallback() {
        if (this.events) return;
        this.dialog = this.querySelector('[data-aes-page-design-services-section3-viewer-dialog]');
        if (!this.dialog) return;
        this.stage = this.querySelector('[data-aes-page-design-services-section3-viewer-stage]');
        this.image = this.querySelector('[data-aes-page-design-services-section3-viewer-image]');
        this.error = this.querySelector('[data-aes-page-design-services-section3-viewer-error]');
        this.loading = this.querySelector('[data-aes-global-loading]');
        this.closeButton = this.querySelector('[data-aes-page-design-services-section3-viewer-close]');
        this.steps = [...this.querySelectorAll('[data-aes-page-design-services-section3-viewer-step]')];
        this.events = new AbortController();
        const signal = this.events.signal;
        this.dialog.addEventListener('cancel', event => { event.preventDefault(); this.close(); }, { signal });
        this.dialog.addEventListener('close', () => this.cleanup(), { signal });
        this.dialog.addEventListener('click', event => {
          const button = event.target.closest('button');
          if (button?.hasAttribute('data-aes-page-design-services-section3-viewer-close')) this.close();
          else if (button?.hasAttribute('data-aes-page-design-services-section3-viewer-step')) this.step(Number(button.dataset.aesPageDesignServicesSection3ViewerStep));
          else if (button?.hasAttribute('data-aes-page-design-services-section3-viewer-retry')) this.load(this.hdLoaded);
          else if (event.target === this.dialog) {
            const r = this.dialog.getBoundingClientRect();
            if (event.clientX < r.left || event.clientX > r.right || event.clientY < r.top || event.clientY > r.bottom) this.close();
          }
        }, { signal });
      }
      disconnectedCallback() {
        if (this.dialog?.open) this.dialog.close();
        this.cleanup(false);
        this.events?.abort();
        this.events = null;
      }
      open(items, index = 0, trigger) {
        this.connectedCallback();
        if (!this.dialog || !Array.isArray(items)) return false;
        const nextItems = items.filter(item => item && typeof item.src === 'string' && item.src.trim());
        if (!nextItems.length) return false;
        clearTimeout(this.closeTimer);
        this.dialog.removeAttribute('data-closing');
        this.items = nextItems;
        this.index = Math.max(0, Math.min(nextItems.length - 1, Number.isFinite(index) ? Math.trunc(index) : 0));
        this.returnFocus = trigger || document.activeElement;
        this.openEvents?.abort();
        this.openEvents = new AbortController();
        const signal = this.openEvents.signal;
        this.dialog.addEventListener('keydown', event => this.keyDown(event), { signal });
        this.stage.addEventListener('dblclick', event => {
          if (event.target.closest('button') || performance.now() - (this.lastTouchTime || -1000) < 600) return;
          event.preventDefault();
          this.setScale(this.scale > 1 ? 1 : 2.5, event);
        }, { signal });
        this.stage.addEventListener('wheel', event => {
          if (event.target.closest('button') || !event.deltaY) return;
          event.preventDefault();
          this.setScale(this.scale + (event.deltaY < 0 ? .25 : -.25), event);
        }, { signal, passive:false });
        this.stage.addEventListener('pointerdown', event => this.pointerDown(event), { signal });
        this.stage.addEventListener('pointermove', event => this.pointerMove(event), { signal });
        this.stage.addEventListener('pointerup', event => this.pointerEnd(event), { signal });
        this.stage.addEventListener('pointercancel', () => this.cancelGesture(), { signal });
        this.stage.addEventListener('lostpointercapture', event => { if (this.pointers?.has(event.pointerId)) this.cancelGesture(); }, { signal });
        this.stage.addEventListener('dragstart', event => event.preventDefault(), { signal });
        window.addEventListener('resize', () => { if (!this.hdLoaded) this.image.sizes = `${Math.ceil(this.stage.clientWidth)}px`; this.transform(); }, { signal });
        if (!this.dialog.open) this.dialog.showModal();
        this.select(this.index);
        this.closeButton.focus({ preventScroll:true });
        return true;
      }
      close() {
        if (!this.dialog?.open || this.dialog.hasAttribute('data-closing')) return;
        this.openEvents?.abort();
        this.cancelLoad?.();
        this.cancelGesture();
        this.dialog.setAttribute('data-closing', '');
        const duration = matchMedia('(prefers-reduced-motion: reduce)').matches ? 0 : parseFloat(getComputedStyle(this.dialog).animationDuration) * 1000;
        this.closeTimer = setTimeout(() => this.dialog.open && this.dialog.close(), Number.isFinite(duration) ? duration : 400);
      }
      cleanup(restoreFocus = true) {
        clearTimeout(this.closeTimer);
        this.openEvents?.abort();
        this.openEvents = null;
        this.cancelLoad?.();
        this.cancelLoad = null;
        this.cancelGesture();
        this.image?.removeAttribute('srcset');
        this.image?.removeAttribute('src');
        this.image?.removeAttribute('sizes');
        this.dialog?.removeAttribute('data-closing');
        if (this.image) this.image.alt = '';
        if (this.error) this.error.hidden = true;
        this.items = [];
        this.hdLoaded = false;
        if (restoreFocus && this.returnFocus?.isConnected && !document.querySelector('dialog[open]')) this.returnFocus.focus({ preventScroll:true });
        this.returnFocus = null;
      }
      keyDown(event) {
        if (event.altKey || event.ctrlKey || event.metaKey || event.target.closest('input,textarea,select,[contenteditable=true]')) return;
        if (event.key === 'ArrowRight' || event.key === 'ArrowLeft') { event.preventDefault(); this.step(event.key === 'ArrowRight' ? 1 : -1); }
        else if (['+', '=', '-', '0'].includes(event.key)) { event.preventDefault(); this.setScale(event.key === '0' ? 1 : this.scale + (event.key === '-' ? -.5 : .5)); }
      }
      select(index) {
        this.index = Math.max(0, Math.min(this.items.length - 1, index));
        this.cancelGesture();
        this.scale = 1;
        this.panX = this.panY = 0;
        this.imageRatio = 1;
        this.hdLoaded = false;
        const item = this.items[this.index];
        this.querySelector('[data-aes-page-design-services-section3-viewer-counter]').textContent = `${this.index + 1} / ${this.items.length}`;
        this.querySelector('[data-aes-page-design-services-section3-viewer-label]').textContent = item.label || '';
        this.steps.forEach(button => { button.hidden = this.items.length < 2; button.disabled = Number(button.dataset.aesPageDesignServicesSection3ViewerStep) < 0 ? this.index === 0 : this.index === this.items.length - 1; });
        this.transform();
        this.load(false);
        this.dispatchEvent(new CustomEvent('aes:image-viewer-change', { detail:{ index:this.index } }));
      }
      step(direction) {
        const next = this.index + direction;
        if (!this.dialog.open || next < 0 || next >= this.items.length) return;
        this.select(next);
      }
      busy(value) {
        this.stage?.setAttribute('aria-busy', String(value));
        if (this.loading) this.loading.hidden = !value;
      }
      load(highDefinition) {
        this.cancelLoad?.();
        const item = this.items[this.index];
        if (!item || !this.dialog.open) return;
        const source = highDefinition && item.hdSrc ? item.hdSrc : item.src;
        const image = this.image;
        let done = false, delay, timer;
        const finish = ok => {
          if (done) return;
          cancel();
          this.error.hidden = ok;
          if (ok) { this.imageRatio = (image.naturalWidth || 1) / (image.naturalHeight || 1); this.transform(); }
        };
        const loaded = () => finish(true), failed = () => finish(false);
        const cancel = () => {
          done = true;
          clearTimeout(delay);
          clearTimeout(timer);
          image.removeEventListener('load', loaded);
          image.removeEventListener('error', failed);
          this.busy(false);
        };
        this.cancelLoad = cancel;
        this.error.hidden = true;
        image.removeAttribute('srcset');
        image.removeAttribute('src');
        image.alt = item.alt || item.label || '';
        image.sizes = `${Math.ceil(this.stage.clientWidth)}px`;
        image.addEventListener('load', loaded, { once:true });
        image.addEventListener('error', failed, { once:true });
        delay = setTimeout(() => { if (!done) this.busy(true); }, 120);
        timer = setTimeout(failed, 12000);
        if (!highDefinition && item.srcset) image.srcset = item.srcset;
        image.src = source;
        if (image.complete) queueMicrotask(() => { if (!done) finish(image.naturalWidth > 0); });
      }
      ensureHD() {
        if (this.scale <= 1 || this.hdLoaded || !this.items[this.index]?.hdSrc) return;
        this.hdLoaded = true;
        this.load(true);
      }
      setScale(scale, point) {
        const previous = this.scale || 1;
        this.scale = Math.max(1, Math.min(4, scale));
        if (point) {
          const r = this.stage.getBoundingClientRect(), x = point.clientX - r.left - r.width / 2, y = point.clientY - r.top - r.height / 2, ratio = this.scale / previous;
          this.panX = x - (x - this.panX) * ratio;
          this.panY = y - (y - this.panY) * ratio;
        }
        if (this.scale === 1) this.panX = this.panY = 0;
        this.ensureHD();
        this.transform();
      }
      transform() {
        if (!this.stage || !this.image) return;
        const r = this.stage.getBoundingClientRect(), ratio = this.imageRatio || 1;
        let width = r.width, height = width / ratio;
        if (height > r.height) { height = r.height; width = height * ratio; }
        const limitX = Math.max(0, (width * (this.scale || 1) - r.width) / 2), limitY = Math.max(0, (height * (this.scale || 1) - r.height) / 2);
        this.panX = Math.min(limitX, Math.max(-limitX, this.panX || 0));
        this.panY = Math.min(limitY, Math.max(-limitY, this.panY || 0));
        this.image.style.transform = `translate(${this.panX + (this.swipeOffset || 0)}px,${this.panY}px) scale(${this.scale || 1})`;
        this.stage.dataset.zoomed = String(this.scale > 1);
      }
      pointerDown(event) {
        if (event.button > 0 || event.target.closest('button') || !this.error.hidden) return;
        if (event.pointerType !== 'mouse') this.lastTouchTime = performance.now();
        this.pointers ||= new Map();
        this.stage.setPointerCapture(event.pointerId);
        this.pointers.set(event.pointerId, { x:event.clientX, y:event.clientY });
        const points = [...this.pointers.values()];
        if (points.length === 1) this.gesture = { mode:this.scale > 1 ? 'pan' : event.pointerType === 'mouse' ? '' : 'swipe', x:event.clientX, y:event.clientY, panX:this.panX, panY:this.panY, time:performance.now(), multi:false, moved:false };
        else if (points.length === 2) {
          this.lastTap = null;
          this.swipeOffset = 0;
          this.gesture = { mode:'pinch', scale:this.scale, panX:this.panX, panY:this.panY, distance:Math.max(1, Math.hypot(points[0].x - points[1].x, points[0].y - points[1].y)), centerX:(points[0].x + points[1].x) / 2, centerY:(points[0].y + points[1].y) / 2, multi:true, moved:true };
        }
      }
      pointerMove(event) {
        if (!this.pointers?.has(event.pointerId) || !this.gesture) return;
        this.pointers.set(event.pointerId, { x:event.clientX, y:event.clientY });
        const g = this.gesture, points = [...this.pointers.values()];
        if (g.mode === 'pinch' && points.length >= 2) {
          const r = this.stage.getBoundingClientRect(), cx = r.left + r.width / 2, cy = r.top + r.height / 2;
          this.scale = Math.max(1, Math.min(4, g.scale * Math.hypot(points[0].x - points[1].x, points[0].y - points[1].y) / g.distance));
          const ratio = this.scale / g.scale;
          this.panX = (points[0].x + points[1].x) / 2 - cx - (g.centerX - cx - g.panX) * ratio;
          this.panY = (points[0].y + points[1].y) / 2 - cy - (g.centerY - cy - g.panY) * ratio;
          this.ensureHD();
          this.transform();
          return;
        }
        const dx = event.clientX - g.x, dy = event.clientY - g.y;
        if (Math.abs(dx) > 5 || Math.abs(dy) > 5) g.moved = true;
        if (g.mode === 'pan') { this.panX = g.panX + dx; this.panY = g.panY + dy; }
        else if (g.mode === 'swipe') {
          if (Math.abs(dx) < 8 && Math.abs(dy) < 8) return;
          if (Math.abs(dy) > Math.abs(dx)) { g.mode = ''; this.swipeOffset = 0; }
          else this.swipeOffset = dx * .22;
        }
        this.transform();
      }
      pointerEnd(event) {
        if (!this.pointers?.has(event.pointerId)) return;
        const g = this.gesture;
        this.pointers.delete(event.pointerId);
        if (this.stage.hasPointerCapture(event.pointerId)) this.stage.releasePointerCapture(event.pointerId);
        if (!g) return;
        if (g.mode === 'pinch') this.setScale(this.scale < 1.05 ? 1 : this.scale);
        if (this.pointers.size) {
          const p = this.pointers.values().next().value;
          this.gesture = { mode:this.scale > 1 ? 'pan' : '', x:p.x, y:p.y, panX:this.panX, panY:this.panY, time:performance.now(), multi:true, moved:true };
          return;
        }
        this.gesture = null;
        this.swipeOffset = 0;
        this.transform();
        if (g.multi) return;
        const dx = event.clientX - g.x, dy = event.clientY - g.y, duration = Math.max(1, performance.now() - g.time);
        if (g.mode === 'swipe' && Math.abs(dx) > Math.abs(dy) && (Math.abs(dx) >= Math.max(48, this.stage.clientWidth * .12) || (Math.abs(dx) >= 24 && Math.abs(dx) / duration >= .45))) { this.lastTap = null; this.step(dx < 0 ? 1 : -1); return; }
        if (this.scale === 1 && !g.moved && Math.hypot(dx, dy) < 8 && duration < 300 && this.image.complete && this.image.naturalWidth && this.imageRatio) {
          const r = this.stage.getBoundingClientRect();
          const width = Math.min(r.width, r.height * this.imageRatio), height = width / this.imageRatio;
          const left = r.left + (r.width - width) / 2, top = r.top + (r.height - height) / 2;
          if (event.clientX < left || event.clientX > left + width || event.clientY < top || event.clientY > top + height) { this.close(); return; }
        }
        if (event.pointerType !== 'mouse' && !g.moved && Math.hypot(dx, dy) < 8 && duration < 300) {
          const now = performance.now();
          if (this.lastTap && now - this.lastTap.time <= 320 && Math.hypot(event.clientX - this.lastTap.x, event.clientY - this.lastTap.y) <= 24) { this.setScale(this.scale > 1 ? 1 : 2.5, event); this.lastTap = null; }
          else this.lastTap = { time:now, x:event.clientX, y:event.clientY };
        }
      }
      cancelGesture() {
        const ids = [...(this.pointers?.keys() || [])];
        this.pointers?.clear();
        ids.forEach(id => { if (this.stage?.hasPointerCapture(id)) this.stage.releasePointerCapture(id); });
        this.gesture = null;
        this.lastTap = null;
        this.swipeOffset = 0;
        this.transform();
      }
    });
  }


if (!customElements.get('aes-page-design-services-section3')) {
  class AesPageDesignServicesSection3 extends HTMLElement {
    connectedCallback() {
      if (this.controller) return;
      this.track = this.querySelector('.aes-page-design-services-section3-track');
      if (!this.track) return;
      this.cards = Array.from(this.track.children);
      this.previous = this.querySelector('[data-aes-page-design-services-section3-previous]');
      this.next = this.querySelector('[data-aes-page-design-services-section3-next]');
      this.controls = this.querySelector('.aes-page-design-services-section3-controls');
      this.current = this.querySelector('[data-aes-page-design-services-section3-current]');
      this.viewer = this.querySelector('aes-page-design-services-section3-viewer');
      this.motion = matchMedia('(prefers-reduced-motion: reduce)');
      this.controller = new AbortController();
      const signal = this.controller.signal;
      this.activeIndex = 0;
      this.targetIndex = null;
      this.interacting = false;
      this.slides = [];
      const copy = (card, index) => {
        const clone = card.cloneNode(true);
        clone.setAttribute('data-aes-page-design-services-section3-clone', '');
        clone.setAttribute('aria-hidden', 'true');
        clone.removeAttribute('data-shopify-editor-block');
        clone.removeAttribute('id');
        clone.querySelectorAll('[id]').forEach(element => element.removeAttribute('id'));
        clone.querySelectorAll('a,button,input,select,textarea,[tabindex],[contenteditable]').forEach(element => { element.tabIndex = -1; });
        clone.querySelectorAll('img').forEach(image => { image.loading = 'lazy'; image.fetchPriority = 'auto'; });
        return { element: clone, index };
      };
      if (this.cards.length > 1) {
        const before = this.cards.map(copy), after = this.cards.map(copy);
        this.track.prepend(...before.map(slide => slide.element));
        this.track.append(...after.map(slide => slide.element));
        this.slides = [...before, ...this.cards.map((element, index) => ({ element, index })), ...after];
      } else this.slides = this.cards.map((element, index) => ({ element, index }));
      this.setAttribute('data-aes-page-design-services-section3-ready', '');
      this.previous?.addEventListener('click', () => this.move((this.targetIndex ?? this.activeIndex) - 1, true, -1), { signal });
      this.next?.addEventListener('click', () => this.move((this.targetIndex ?? this.activeIndex) + 1, true, 1), { signal });
      this.track.addEventListener('keydown', event => {
        if (event.target !== this.track || !this.loop || !['ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(event.key)) return;
        event.preventDefault();
        if (event.key === 'Home') this.move(0);
        else if (event.key === 'End') this.move(this.cards.length - 1);
        else {
          const direction = (event.key === 'ArrowRight') !== this.rtl ? 1 : -1;
          this.move((this.targetIndex ?? this.activeIndex) + direction, true, direction);
        }
      }, { signal });
      this.track.addEventListener('scroll', () => {
        if (this.targetIndex !== null || this.rebasing || this.scrollFrame) return;
        this.scrollFrame = requestAnimationFrame(() => {
          this.scrollFrame = null;
          this.normalize();
          this.sync();
          this.scheduleSettle();
        });
      }, { passive: true, signal });
      this.track.addEventListener('scrollend', () => this.settle(), { passive: true, signal });
      this.track.addEventListener('wheel', () => { this.cancelMove(); this.scheduleSettle(); }, { passive: true, signal });
      this.track.addEventListener('touchstart', () => { this.interacting = true; this.cancelMove(); }, { passive: true, signal });
      const endTouch = event => { if (!event.touches.length) { this.interacting = false; this.scheduleSettle(); } };
      this.track.addEventListener('touchend', endTouch, { passive: true, signal });
      this.track.addEventListener('touchcancel', endTouch, { passive: true, signal });
      this.track.addEventListener('pointerdown', event => {
        if (event.button !== 0 || event.target.closest('button,input,textarea,select,video,iframe')) return;
        this.cancelMove();
        this.normalize();
        this.sync();
        this.interacting = true;
        this.suppressClick = false;
        if (event.pointerType === 'mouse' && this.loop) this.drag = { id: event.pointerId, x: event.clientX, y: event.clientY, start: this.track.scrollLeft, moved: false };
      }, { passive: true, signal });
      window.addEventListener('pointermove', event => {
        const drag = this.drag;
        if (!drag || event.pointerId !== drag.id) return;
        const dx = event.clientX - drag.x, dy = event.clientY - drag.y;
        if (!drag.moved) {
          if (Math.abs(dx) < 6) return;
          if (Math.abs(dy) > Math.abs(dx)) { this.drag = null; return; }
          drag.moved = true;
          this.track.setPointerCapture(drag.id);
          this.track.setAttribute('data-aes-page-design-services-section3-dragging', '');
          this.track.setAttribute('data-aes-page-design-services-section3-moving', '');
        }
        event.preventDefault();
        this.track.scrollLeft = drag.start - dx;
        this.normalize();
      }, { signal });
      const endPointer = event => {
        if (this.drag && event.pointerId !== this.drag.id) return;
        this.interacting = false;
        const moved = this.drag?.moved;
        this.releaseDrag();
        if (moved) {
          this.suppressClick = true;
          clearTimeout(this.clickTimer);
          this.clickTimer = setTimeout(() => { this.suppressClick = false; }, 0);
          this.sync();
          this.move(this.activeIndex);
        } else this.scheduleSettle();
      };
      window.addEventListener('pointerup', endPointer, { passive: true, signal });
      window.addEventListener('pointercancel', endPointer, { passive: true, signal });
      this.track.addEventListener('lostpointercapture', event => { if (this.drag?.id === event.pointerId) endPointer(event); }, { signal });
      this.track.addEventListener('click', event => { if (this.suppressClick) { event.preventDefault(); event.stopPropagation(); } }, { capture: true, signal });
      this.track.addEventListener('dragstart', event => event.preventDefault(), { signal });
      this.track.addEventListener('click', event => {
        const trigger = event.target.closest('[data-aes-page-design-services-section3-open]');
        if (!trigger || event.defaultPrevented || event.button > 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
        const card = trigger.closest('.aes-page-design-services-section3-card');
        const slide = this.slides.find(item => item.element === card);
        if (!slide || !this.viewer) return;
        event.preventDefault();
        this.openViewer(slide.index, trigger);
      }, { signal });
      this.viewer?.addEventListener('aes:image-viewer-change', event => {
        this.syncViewer(event.detail.index);
      }, { signal });
      this.track.addEventListener('focusin', event => {
        if (this.interacting || !this.loop || event.target === this.track) return;
        const card = event.target.closest('.aes-page-design-services-section3-card');
        const index = this.cards.indexOf(card);
        if (index >= 0) this.reveal(index);
      }, { signal });
      this.addEventListener('shopify:block:select', event => {
        const index = this.cards.findIndex(card => card.getAttribute('data-aes-page-design-services-section3-block') === event.detail?.blockId);
        if (index >= 0) this.reveal(index);
      }, { signal });
      this.motion.addEventListener('change', () => { const target = this.targetIndex; this.cancelMove(); if (target !== null) this.move(target, false); }, { signal });
      this.observer = new ResizeObserver(() => {
        cancelAnimationFrame(this.measureFrame);
        this.measureFrame = requestAnimationFrame(() => { this.measureFrame = null; this.measure(); });
      });
      this.observer.observe(this.track);
      this.cards.forEach(card => this.observer.observe(card));
      this.measure();
    }
    async openViewer(index, trigger) {
      await customElements.whenDefined('aes-page-design-services-section3-viewer');
      if (!this.isConnected || this.controller?.signal.aborted || !this.viewer) return;
      this.viewerIndices = [];
      const items = this.cards.flatMap((card, cardIndex) => {
        const image = card.querySelector('img'), sources = [...card.querySelectorAll('source')];
        const source = sources.find(item => matchMedia(item.media).matches);
        const device = matchMedia('(width < 768px)').matches ? 'Mobile' : matchMedia('(width < 1440px)').matches ? 'Tablet' : 'Desktop';
        const hdSrc = card.dataset['aesPageDesignServicesSection3' + device + 'Hd'];
        if (!image || !hdSrc) return [];
        this.viewerIndices.push(cardIndex);
        return [{ src:image.currentSrc || image.src, srcset:source?.srcset || image.srcset, hdSrc, alt:image.alt, label:card.querySelector('.aes-page-design-services-section3-caption')?.textContent.trim() || '' }];
      });
      const viewerIndex = this.viewerIndices.indexOf(index);
      if (viewerIndex < 0) return;
      const card = trigger.closest('.aes-page-design-services-section3-card');
      this.viewerFocusSelector = trigger.classList.contains('aes-page-design-services-section3-enlarge') ? '.aes-page-design-services-section3-enlarge' : '.aes-page-design-services-section3-frame';
      const returnFocus = this.cards.includes(card) ? trigger : this.cards[index].querySelector(this.viewerFocusSelector);
      this.viewer.open(items, viewerIndex, returnFocus);
    }
    syncViewer(index) {
      const blockIndex = this.viewerIndices?.[index];
      if (blockIndex === undefined) return;
      this.reveal(blockIndex);
      const target = this.cards[blockIndex].querySelector(this.viewerFocusSelector || '.aes-page-design-services-section3-enlarge');
      if (target) this.viewer.returnFocus = target;
    }
    position() { return this.rtl ? -this.track.scrollLeft : this.track.scrollLeft; }
    setPosition(value) { this.track.scrollLeft = this.rtl ? -value : value; }
    measure() {
      if (!this.track.clientWidth) return;
      const index = this.targetIndex ?? this.activeIndex;
      this.cancelMove();
      this.releaseDrag();
      this.interacting = false;
      this.rtl = getComputedStyle(this.track).direction === 'rtl';
      const bounds = this.track.getBoundingClientRect();
      this.centres = this.slides.map(slide => {
        const rect = slide.element.getBoundingClientRect();
        const centreOffset = (bounds.width - rect.width) / 2;
        return (this.rtl ? -this.track.scrollLeft + bounds.right - rect.right : this.track.scrollLeft + rect.left - bounds.left) - centreOffset;
      });
      this.loop = this.cards.length > 1;
      this.cycle = this.loop ? this.centres[this.cards.length * 2] - this.centres[this.cards.length] : 0;
      this.loop = this.loop && this.cycle > 1;
      this.track.tabIndex = this.loop ? 0 : -1;
      if (this.controls) this.controls.hidden = !this.loop;
      if (this.previous) this.previous.disabled = !this.loop;
      if (this.next) this.next.disabled = !this.loop;
      this.jump(this.centres[(this.loop ? this.cards.length : 0) + index] ?? 0);
      this.sync();
    }
    jump(value) {
      cancelAnimationFrame(this.rebaseFrame);
      this.rebasing = true;
      this.track.setAttribute('data-aes-page-design-services-section3-moving', '');
      this.setPosition(value);
      this.rebaseFrame = requestAnimationFrame(() => {
        this.rebaseFrame = null;
        this.rebasing = false;
        if (this.targetIndex === null && !this.drag?.moved) this.track.removeAttribute('data-aes-page-design-services-section3-moving');
      });
    }
    normalize() {
      if (!this.loop || this.targetIndex !== null) return;
      const value = this.position();
      const lower = this.centres[this.cards.length] - this.cycle / this.cards.length / 2;
      const offset = -Math.floor((value - lower) / this.cycle) * this.cycle;
      if (Math.abs(offset) < 1) return;
      if (this.drag) this.drag.start += this.rtl ? -offset : offset;
      this.jump(value + offset);
    }
    sync() {
      if (!this.centres?.length) return;
      const value = this.position();
      let nearest = 0, distance = Infinity;
      this.centres.forEach((centre, index) => { const delta = Math.abs(centre - value); if (delta < distance) { nearest = index; distance = delta; } });
      this.activeIndex = this.slides[nearest].index;
      if (this.current && this.targetIndex === null) {
        const text = String(this.activeIndex + 1);
        if (this.current.textContent !== text) this.current.textContent = text;
      }
    }
    reveal(index) {
      this.cancelMove();
      clearTimeout(this.settleTimer);
      this.jump(this.centres[(this.loop ? this.cards.length : 0) + index] ?? 0);
      this.sync();
    }
    scheduleSettle() { clearTimeout(this.settleTimer); this.settleTimer = setTimeout(() => this.settle(), 160); }
    settle() {
      if (this.targetIndex !== null || this.rebasing || this.interacting || this.drag?.moved) return;
      clearTimeout(this.settleTimer);
      this.normalize();
      this.sync();
      this.move(this.activeIndex);
    }
    cancelMove() {
      cancelAnimationFrame(this.animationFrame);
      this.animationFrame = null;
      this.targetIndex = null;
      if (!this.drag?.moved && !this.rebasing) this.track?.removeAttribute('data-aes-page-design-services-section3-moving');
    }
    releaseDrag() {
      const drag = this.drag;
      this.drag = null;
      if (drag && this.track.hasPointerCapture(drag.id)) this.track.releasePointerCapture(drag.id);
      this.track?.removeAttribute('data-aes-page-design-services-section3-dragging');
      if (this.targetIndex === null && !this.rebasing) this.track?.removeAttribute('data-aes-page-design-services-section3-moving');
    }
    move(index, animate = true, direction = 0) {
      if (!this.centres?.length) return;
      this.cancelMove();
      clearTimeout(this.settleTimer);
      this.normalize();
      const next = ((index % this.cards.length) + this.cards.length) % this.cards.length;
      const start = this.position();
      const candidates = this.slides.flatMap((slide, i) => slide.index === next ? [this.centres[i]] : []);
      const same = candidates.find(value => Math.abs(value - start) < 1);
      const directed = direction ? candidates.filter(value => (value - start) * direction > 0) : candidates;
      const choices = directed.length ? directed : candidates;
      const end = same ?? choices.reduce((nearest, value) => Math.abs(value - start) < Math.abs(nearest - start) ? value : nearest);
      const token = getComputedStyle(this).getPropertyValue('--aes-duration').trim();
      const duration = animate && !this.motion.matches ? parseFloat(token) * (token.endsWith('ms') ? 1 : 1000) : 0;
      if (!Number.isFinite(duration) || duration <= 1 || Math.abs(end - start) < 1) {
        this.setPosition(end);
        this.normalize();
        this.sync();
        return;
      }
      this.targetIndex = next;
      this.track.setAttribute('data-aes-page-design-services-section3-moving', '');
      let began;
      const tick = time => {
        began ??= time;
        const progress = Math.min((time - began) / duration, 1);
        this.setPosition(start + (end - start) * (1 - Math.pow(1 - progress, 3)));
        if (progress < 1) this.animationFrame = requestAnimationFrame(tick);
        else {
          this.setPosition(end);
          this.cancelMove();
          this.normalize();
          this.sync();
        }
      };
      this.animationFrame = requestAnimationFrame(tick);
    }
    disconnectedCallback() {
      this.cancelMove();
      this.releaseDrag();
      cancelAnimationFrame(this.scrollFrame);
      cancelAnimationFrame(this.measureFrame);
      cancelAnimationFrame(this.rebaseFrame);
      this.scrollFrame = this.measureFrame = this.rebaseFrame = null;
      clearTimeout(this.clickTimer);
      clearTimeout(this.settleTimer);
      this.observer?.disconnect();
      this.controller?.abort();
      this.slides?.filter(slide => !this.cards.includes(slide.element)).forEach(slide => slide.element.remove());
      this.controller = null;
      this.rebasing = false;
      this.removeAttribute('data-aes-page-design-services-section3-ready');
    }
  }
  customElements.define('aes-page-design-services-section3', AesPageDesignServicesSection3);
}


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["aes-page-design-services-section5"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('aes-page-design-services-section5')) {
  customElements.define('aes-page-design-services-section5',class extends HTMLElement {
    initLoading() {
      this.loadingRegion=this.querySelector('[data-aes-form-mount]');
      this.loadingLogo=this.loadingRegion?.querySelector('[data-aes-global-loading]');
      this.loadingStatus=this.loadingRegion?.querySelector('[data-aes-form-load-status]');
      this.loadingRetry=this.loadingRegion?.querySelector('[data-aes-form-load-retry]');
      this.loadingLocks=new Map();
      this.loadingAbort?.abort(); this.loadingAbort=new AbortController();
      this.loadingRetry?.addEventListener('click',()=>{
        clearInterval(this.locateTimer); this.attempts=0; this.setLoading(true); this.locate();
        if (!this.root) this.locateTimer=setInterval(this.locate,250);
      },{signal:this.loadingAbort.signal});
      this.setLoading(true);
    }
    setLoading(loading,failed=false) {
      if (!this.loadingLogo) return;
      const region=this.loadingRegion;
      if (loading) {
        if (region.contains(document.activeElement)) { this.loadingStatus.tabIndex=-1; this.loadingStatus.focus({preventScroll:true}); }
        region.querySelectorAll('.shopify-block,shopify-forms-embed').forEach(node=>{
          if (!this.loadingLocks.has(node)) this.loadingLocks.set(node,node.inert);
          node.inert=true;
        });
      } else { this.loadingLocks.forEach((inert,node)=>{node.inert=inert}); this.loadingLocks.clear(); }
      region.toggleAttribute('data-aes-form-loading',loading);
      region.setAttribute('aria-busy',String(loading));
      this.loadingLogo.hidden=!loading;
      this.loadingStatus.hidden=!loading&&!failed;
      this.loadingStatus.setAttribute('role',failed?'alert':'status');
      this.loadingStatus.textContent=failed?'The form could not be loaded. Please retry or refresh the page.':'Loading form. Please wait.';
      this.loadingRetry.hidden=!failed;
    }
    connectedCallback() {
      if (this.connected) return;
      this.connected=true;
      this.initConsultationAnchor();
      this.uploadCopy=JSON.parse(this.querySelector('[data-aes-inquiry-upload-copy]').textContent);
      this.uploaderReady=import(this.dataset.uploadClient).then(module=>{
        if (!this.isConnected) return;
        this.fileCardsModule=module.AesInquiryFileCards;
        if (this.root) this.fileCards=new module.AesInquiryFileCards(this.root);
        if (this.dataset.uploadEndpoint) this.uploader=new module.AesInquiryUpload({endpoint:this.dataset.uploadEndpoint,page:this.dataset.uploadPage,siteKey:this.dataset.uploadSiteKey,copy:this.uploadCopy});
        if (this.root) this.decorate();
      }).catch(()=>{ this.uploadSetupError=this.uploadCopy.service_refresh; });
      this.attempts=0;
      this.initLoading();
      this.initSuccess();
      this.locate=()=>{
        const root=this.querySelector('shopify-forms-embed')?.shadowRoot;
        if (root && (root.querySelector('[data-testid="banner-success"]') || (root.querySelector('[data-testid="btn-form-submit"]') && root.querySelectorAll('#first_name,#email,[id="custom#project_location"],[name="custom#project_location"],[name="custom#tell_us_about_your_project"]').length===4))) {
          clearInterval(this.locateTimer);
          this.attach(root);
        } else if (++this.attempts>=120) { clearInterval(this.locateTimer); this.setLoading(false,true); }
      };
      this.locate();
      if (!this.root) this.locateTimer=setInterval(this.locate,250);
    }
    disconnectedCallback() {
      this.consultationAnchorAbort?.abort();
      this.disposeSuccess();
      this.fileCards?.dispose();
      this.prepareAbort?.abort();
      this.setLoading(false); this.loadingAbort?.abort();
      clearInterval(this.locateTimer);
      clearInterval(this.pendingTimer);
      this.observer?.disconnect();
      this.release();
      this.abort?.abort();
      this.connected=false;
      this.root=null;
    }
    initConsultationAnchor() {
      const consultationHash = this.dataset.uploadPage === 'custom-service' ? '#custom-consultation' : '#design-consultation';
      if (!['design-service', 'custom-service'].includes(this.dataset.uploadPage) || !this.querySelector(consultationHash)) return;
      this.consultationAnchorAbort?.abort();
      this.consultationAnchorAbort = new AbortController();
      const signal = this.consultationAnchorAbort.signal;
      document.addEventListener('click', event => {
        if (event.defaultPrevented || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
        const link = event.target.closest('a[href]');
        if (!link || (link.target && link.target !== '_self') || link.hasAttribute('download')) return;
        const destination = new URL(link.href, location.href);
        if (destination.origin !== location.origin || destination.pathname !== location.pathname || destination.search !== location.search || destination.hash !== consultationHash) return;
        event.preventDefault();
        if (location.hash !== destination.hash) history.pushState(history.state, '', destination.hash);
        this.scrollToConsultation();
      }, { signal });
      window.addEventListener('hashchange', () => { if (location.hash === consultationHash) this.scrollToConsultation(); }, { signal });
      if (location.hash === consultationHash) this.scrollToConsultation();
    }
    scrollToConsultation() {
      const anchor = this.querySelector(this.dataset.uploadPage === 'custom-service' ? '#custom-consultation' : '#design-consultation');
      if (!anchor) return;
      const headerHeight = document.querySelector('.aes-header-section1-host')?.getBoundingClientRect().height || 0;
      anchor.style.setProperty('--aes-design-consultation-header-height', headerHeight + 'px');
      anchor.focus({ preventScroll:true });
      window.scrollTo({ top:Math.max(0, window.scrollY + anchor.getBoundingClientRect().top - headerHeight - 16), behavior:matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth' });
    }
    attach(root) {
      this.prepareAbort?.abort(); this.uploading=false; this.prepared=false;
      this.observer?.disconnect();
      clearInterval(this.pendingTimer);
      this.release();
      this.abort?.abort();
      this.abort=new AbortController();
      this.root=root;
      this.fileCards?.dispose();
      if (this.fileCardsModule) this.fileCards=new this.fileCardsModule(root);
      this.copy=this.querySelector('template[data-aes-page-design-services-section5-copy]').content;
      this.form=root.querySelector('form');
      this.attempted=false;
      this.awaitingNative=false;
      this.locked=new Map();
      this.uploadErrors=new Map();
      this.busy=false;
      const prefix='aes-page-design-services-section5';
      let style=root.querySelector('style[data-aes-page-design-services-section5-style]');
      if (!style) {
        style=document.createElement('style');
        style.dataset.aesPageDesignServicesSection5Style='';
        style.textContent=`
@layer aes-focus-policy {
  :is(:focus, :focus-visible, .focused) { outline: none !important; box-shadow: none !important; }
  :focus-within { outline: none !important; }
}

          :host{--inline-container-max-width:100%!important;--container-max-w:100%!important;--forms-body-font:normal 400 14px var(--aes-font-body)!important;--form-field-border-radius:0px!important;--button-border-radius:0px!important;--container-text-alignment:left!important}
          [data-form-root],[data-testid="app-router"],#form-container-ref,section[role="dialog"],[class*="_formContainer_"],[class*="_inline_"]{width:100%!important;max-width:none!important;padding:0!important;margin:0!important;background:transparent!important;border:0!important;box-shadow:none!important}
          :host(:focus),section[role="dialog"]:focus,form:focus{outline:none!important;box-shadow:none!important}
          [class*="_gridItemContent_"]{padding:0!important;min-width:0!important}
          [class*="_formHeader_"],form>div:has(shop-lead-capture){display:none!important}
          form[data-aes-page-design-services-section5-form]{display:grid!important;grid-template-columns:minmax(0,1fr)!important;gap:24px!important;margin:0!important;padding:0!important;border:0!important;box-shadow:none!important;outline:none!important}
          form[data-aes-page-design-services-section5-form],form[data-aes-page-design-services-section5-form] *{box-sizing:border-box!important}
          .${prefix}-field{display:flex!important;flex-direction:column!important;gap:8px!important;position:relative!important;min-width:0!important}
          .${prefix}-field::before{content:none!important}
          .${prefix}-field label{position:static!important;order:-1!important;padding:0!important;margin:0!important;transform:none!important;color:var(--aes-text-primary)!important;font:400 14px/22px var(--aes-font-body)!important;text-transform:uppercase!important;letter-spacing:0!important}
          .${prefix}-field label::after{content:' *';font:400 16px/26px var(--aes-font-body)}
          .${prefix}-field :is(input,textarea){box-sizing:border-box!important;display:block!important;width:100%!important;max-width:none!important;min-height:48px!important;height:48px!important;padding:0 16px!important;margin:0!important;border:1px solid var(--aes-page-design-services-section5-control-border)!important;border-radius:2px!important;background:var(--aes-bg-primary)!important;color:var(--aes-text-secondary)!important;font:400 14px/22px var(--aes-font-body)!important;letter-spacing:0!important;box-shadow:none!important;outline:none!important;transition:border-color var(--aes-duration) var(--aes-ease)}
          .${prefix}-field textarea{height:96px!important;min-height:96px!important;resize:vertical!important;padding:12px 16px!important}
          .${prefix}-field :is(input,textarea)::placeholder{color:var(--aes-text-muted)!important;opacity:1!important}
          .${prefix}-field :is(input,textarea):is(:focus,:focus-visible){border-color:var(--aes-page-design-services-section5-control-active)!important;outline:0!important;box-shadow:none!important}
          @media(hover:hover) and (pointer:fine){.${prefix}-field :is(input,textarea):hover:where(:not(:disabled)){border-color:var(--aes-page-design-services-section5-control-active)!important}}
          .${prefix}-field :is(input,textarea)[aria-invalid="true"],.${prefix}-field[class*="_withError_"]>textarea,.${prefix}-field:has(+output[role="alert"]) :is(input,textarea){border-color:var(--aes-page-design-services-section5-control-error)!important}
          output[role="alert"],[role="alert"]{grid-column:1/-1!important;margin:0!important;font:400 12px/1.6 var(--aes-font-body)!important;color:var(--aes-page-design-services-section5-control-error)!important;text-transform:none!important;overflow-wrap:anywhere}
          .${prefix}-native-error{position:absolute!important;width:1px!important;height:1px!important;padding:0!important;margin:-1px!important;overflow:hidden!important;clip-path:inset(50%)!important;white-space:nowrap!important}
          .${prefix}-field-error{order:1!important;display:block;margin:0!important;color:var(--aes-page-design-services-section5-control-error)!important;font:400 12px/1.6 var(--aes-font-body)!important;text-transform:none!important}
          .${prefix}-native-upload,.${prefix}-upload-picker{display:none!important}
          .${prefix}-upload{grid-column:1/-1;min-width:0;display:flex!important;flex-direction:column;align-items:flex-start;gap:12px}
          .${prefix}-upload[data-aes-has-files]{padding:12px;border:2px dashed var(--aes-page-design-services-section5-control-border)}
          .${prefix}-upload[data-aes-has-files]:focus-within{border-color:var(--aes-page-design-services-section5-control-active)}
          .${prefix}-upload:has([data-aes-page-design-services-section5-file-error]){border-color:var(--aes-page-design-services-section5-control-error)}
          .${prefix}-upload-button{box-sizing:border-box;display:inline-flex;align-items:center;gap:12px;max-width:100%;min-height:28px;padding:0;margin:0;border:0;background:transparent;color:var(--aes-text-primary);font:400 14px/22px var(--aes-font-body);text-align:left;cursor:pointer}
          .${prefix}-add{display:flex;align-items:center;justify-content:center;flex:none;width:28px;height:28px;border:1px solid currentColor;color:#201d1a}
          .${prefix}-add svg{display:block;width:12px;height:12px;transform:none}
          .${prefix}-add [stroke]{stroke:currentColor;stroke-width:1.5px;vector-effect:non-scaling-stroke}
          .${prefix}-upload[data-aes-has-files] .${prefix}-add{display:none}
          .${prefix}-upload[data-aes-has-files] .${prefix}-upload-button{align-self:center;min-height:32px;color:var(--aes-bg-brand);font-size:14px}
          .${prefix}-upload-button:disabled{color:var(--aes-text-muted);cursor:default}
          .${prefix}-upload[data-aes-has-files] .${prefix}-upload-button:disabled{display:none}
          .${prefix}-upload-list{display:grid;gap:8px;list-style:none;width:100%;margin:0;padding:0}
          .${prefix}-upload-limits{margin:0;color:var(--aes-text-muted);font:400 12px/1.6 var(--aes-font-body)}
          .${prefix}-filename{display:flex;align-items:center;gap:12px;justify-content:space-between;width:100%;min-height:32px;margin:0;font:400 14px/22px var(--aes-font-body);overflow-wrap:anywhere}
          .${prefix}-filename[hidden]{display:none}
          .${prefix}-filename>span{flex:1;min-width:0}
          .${prefix}-remove{display:inline-flex;align-items:center;justify-content:center;flex:0 0 32px;width:32px;height:32px;padding:0;border:0;background:transparent;color:var(--aes-bg-brand);cursor:pointer}
          .${prefix}-remove svg{display:block;width:20px;height:20px}
          .${prefix}-remove [stroke]{stroke:currentColor}
          .${prefix}-remove [fill]:not([fill="none"]){fill:currentColor}
          .${prefix}-upload-button:focus-visible,.${prefix}-remove:focus-visible{outline:none!important;box-shadow:inset 0 0 0 1px var(--aes-page-design-services-section5-control-active)}
          .${prefix}-disclaimer,[data-testid="form"]>p{grid-column:1/-1;margin:0!important;color:var(--aes-text-muted)!important;font:400 14px/22px var(--aes-font-body)!important;line-height:round(nearest,22.4px,1px)!important;letter-spacing:0!important}
          .${prefix}-disclaimer a{color:inherit;text-underline-offset:3px}
          [data-testid="btn-form-submit"]{position:relative!important;display:inline-flex!important;align-items:center!important;justify-content:center!important;gap:12px!important;justify-self:center!important;grid-column:1/-1!important;box-sizing:border-box!important;min-height:41px!important;height:41px!important;width:max-content!important;max-width:100%!important;margin:0!important;padding:0 8px!important;border:1px solid var(--aes-text-primary)!important;border-radius:0!important;box-shadow:none!important;background:transparent!important;color:var(--aes-text-primary)!important;font:400 var(--aes-inquiry-submit-size,16px)/1.35 var(--aes-font-heading)!important;letter-spacing:0!important;text-transform:uppercase;transition:background var(--aes-duration),color var(--aes-duration)}
          [data-testid="btn-form-submit"]::after{content:'';position:absolute;inset:4px;border:var(--aes-button-inset-border-width) solid currentColor;opacity:0;pointer-events:none;transition:opacity var(--aes-duration)}
          [data-testid="btn-form-submit"]:is(:active,:focus-visible){background:#897266!important;border-color:#897266!important;color:var(--aes-text-inverse)!important}
          [data-testid="btn-form-submit"]:is(:active,:focus-visible)::after{opacity:1}
          [data-testid="btn-form-submit"]:focus{outline:none!important;box-shadow:none!important}
          .${prefix}-arrow{display:flex;align-items:center;justify-content:center;position:relative;width:8px;height:8px;flex:none}
          .${prefix}-arrow svg{display:block;width:24px;height:24px;flex:none;transform:rotate(-45deg) scale(calc(8px / 13.5px))}
          .${prefix}-arrow [fill]:not([fill="none"]){fill:currentColor}
          [data-aes-page-design-services-section5-busy] .${prefix}-arrow svg{visibility:hidden}
          [data-aes-page-design-services-section5-busy] .${prefix}-arrow::after{content:'';position:absolute;inset:0;border:2px solid currentColor;border-right-color:transparent;border-radius:50%;animation:aes-page-design-services-section5-submit 1s linear infinite}
          [data-aes-page-design-services-section5-busy]>svg{display:none!important}
          [data-aes-page-design-services-section5-busy] [data-testid="spinner-icon"]{display:none!important}
          [data-aes-page-design-services-section5-busy] [class*="_visuallyHidden_"]{position:static!important;width:auto!important;height:auto!important;padding:0!important;margin:0!important;overflow:visible!important;clip:auto!important;clip-path:none!important;white-space:normal!important}
          [data-testid="btn-form-submit"][data-aes-page-design-services-section5-busy]{min-width:var(--aes-page-design-services-section5-submit-width,0px)!important}
          .${prefix}-status{grid-column:1/-1;margin:0;font:400 14px/22px var(--aes-font-body);color:var(--aes-text-secondary)}
          .${prefix}-status[hidden]{display:none!important}
          form[data-aes-page-design-services-section5-busy] :is(input,textarea,button){cursor:wait}
          [data-testid="banner-success"]{position:relative!important;display:block!important;box-sizing:border-box!important;width:100%!important;min-height:80px;padding:20px 56px 20px 24px!important;border:1px solid #e5e5e5!important;border-radius:0!important;background:#f7f7f7!important;box-shadow:none!important;color:var(--aes-text-primary);text-align:left!important}
          [data-testid="banner-success"] h2{margin:0 0 4px!important;font:400 16px/1.35 var(--aes-font-heading)!important;outline:none}
          [data-testid="banner-success"] p{margin:0!important;font:400 14px/22px var(--aes-font-body)!important;color:var(--aes-text-secondary)!important}
          .${prefix}-success-close{position:absolute;top:16px;right:16px;display:inline-flex;align-items:center;justify-content:center;width:24px;height:24px;padding:0;border:0;border-radius:0;background:transparent;color:var(--aes-text-muted);cursor:pointer;box-shadow:none}
          .${prefix}-success-close svg{display:block;width:20px;height:20px}
          .${prefix}-success-close [stroke]{stroke:currentColor}
          .${prefix}-success-close:focus-visible{outline:1px solid var(--aes-page-design-services-section5-control-active);outline-offset:3px}
          @keyframes aes-page-design-services-section5-submit{to{transform:rotate(360deg)}}
          @media(hover:hover) and (pointer:fine){[data-testid="btn-form-submit"]:hover:not(:disabled):not([aria-disabled="true"]){background:#897266!important;border-color:#897266!important;color:var(--aes-text-inverse)!important}[data-testid="btn-form-submit"]:hover:not(:disabled):not([aria-disabled="true"])::after{opacity:1}}
          @media(min-width:768px){form[data-aes-page-design-services-section5-form]{grid-template-columns:minmax(0,1fr) minmax(0,1fr)!important;column-gap:32px!important}.${prefix}-field{gap:12px!important}.${prefix}-field:has(:is([id="custom#project_location"],textarea)){grid-column:1/-1}}
          @media(prefers-reduced-motion:reduce){[data-testid="btn-form-submit"],[data-testid="btn-form-submit"]::after{transition:none!important}[data-aes-page-design-services-section5-busy] .${prefix}-arrow::after{animation:none}}
[data-testid="btn-form-submit"][data-aes-form-sent],[data-testid="btn-form-submit"][data-aes-form-sent]:is(:hover,:active,:focus){position:relative!important;box-sizing:border-box!important;inline-size:79px!important;block-size:49px!important;min-inline-size:0!important;border:1px solid #d3d3d1!important;background:transparent!important;color:transparent!important;font-size:0!important;box-shadow:none!important;cursor:default!important;transition:none!important}
[data-testid="btn-form-submit"][data-aes-form-sent]>:not([data-aes-form-sent-copy]){visibility:hidden!important}
[data-testid="btn-form-submit"][data-aes-form-sent]::before,[data-testid="btn-form-submit"][data-aes-form-sent]::after{display:none!important;content:none!important}
[data-testid="btn-form-submit"][data-aes-form-sent]>[data-aes-form-sent-copy]{position:absolute!important;inset:0!important;display:flex!important;align-items:center!important;justify-content:center!important;visibility:visible!important;margin:0!important;padding:0!important;color:#8c8c8c!important;font-family:var(--aes-form-sent-font-family,inherit)!important;font-size:var(--aes-form-sent-font-size,14px)!important;font-weight:400!important;line-height:1.6!important;letter-spacing:inherit!important;pointer-events:none!important}
        `;
        root.append(style);
      }
      this.decorate();
      this.setLoading(false);
      this.restoreSuccessForm();
      if (this.form) {
        this.form.addEventListener('submit',event=>{
          if (this.successCooling()) { event.preventDefault(); event.stopImmediatePropagation(); return; }
          const prepared=this.prepared;
          this.prepared=false;
          if (this.busy) { event.preventDefault(); event.stopImmediatePropagation(); return; }
          if (!this.validateUploads()) { event.preventDefault(); event.stopImmediatePropagation(); this.form.querySelector('[data-aes-page-design-services-section5-upload]')?.focus(); return; }
          if (this.dataset.uploadEndpoint && !prepared && [...this.form.querySelectorAll('.aes-page-design-services-section5-field input,.aes-page-design-services-section5-field textarea')].every(input=>input.validity.valid)) {
            event.preventDefault(); event.stopImmediatePropagation(); this.prepareUploads(); return;
          }
          const button=this.form.querySelector('[data-testid="btn-form-submit"]');
          if (button) button.style.setProperty('--aes-page-design-services-section5-submit-width',button.getBoundingClientRect().width+'px');
          this.attempted=true;
          this.awaitingNative=[...this.form.querySelectorAll('.aes-page-design-services-section5-field input,.aes-page-design-services-section5-field textarea')].every(input=>input.validity.valid);
          if (this.awaitingNative) this.submittedHeight=this.loadingRegion.getBoundingClientRect().height;
          this.syncBusy();
          queueMicrotask(()=>this.syncBusy());
        },{capture:true,signal:this.abort.signal});
        this.form.addEventListener('input',event=>{
          if (!this.busy) this.attempted=false;
          if (event.target.matches('input:not([type="file"]),textarea')) event.target.setCustomValidity('');
        },{signal:this.abort.signal});
        this.form.addEventListener('change',event=>{
          if (!event.target.matches('input[type="file"]')) return;
          if (!this.busy) this.attempted=false;
          if (event.target.hasAttribute('data-aes-page-design-services-section5-picker')) {
            event.stopImmediatePropagation();
            this.selectUploads(event.target);
            return;
          }
          const message=this.filesError(Array.from(event.target.files || []));
          if (message || event.target.files?.length>1) {
            event.stopImmediatePropagation();
            this.clearUpload(event.target);
            this.uploadErrors.set(event.target.id,message || 'Choose files using the upload area.');
          } else {
            this.uploadErrors.delete(event.target.id);
          }
          queueMicrotask(()=>this.decorate());
        },{capture:true,signal:this.abort.signal});
        this.pendingTimer=setInterval(()=>this.syncBusy(),250);
      }
      this.observer=new MutationObserver(()=>{
        this.observer.disconnect();
        if (this.form!==root.querySelector('form')) { this.attach(root); return; }
        this.decorate();
        this.syncBusy();
        this.observer.observe(root,{childList:true,subtree:true,characterData:true,attributes:true,attributeFilter:['disabled','aria-disabled','aria-invalid']});
      });
      this.observer.observe(root,{childList:true,subtree:true,characterData:true,attributes:true,attributeFilter:['disabled','aria-disabled','aria-invalid']});
    }
    initSuccess() {
      this.successLifecycleAbort?.abort();
      this.successLifecycleAbort=new AbortController();
      this.successKey ||= (this.tagName.toLowerCase()==='aes-page-contact-section1'?'aes-contact-success:':'aes-inquiry-success:')+location.pathname+':'+this.id;
      const valid=notice=>notice && Number.isFinite(notice.at) && Date.now()-notice.at>=0 && Date.now()-notice.at<300000;
      let received=this.successRecoveryNotice || this.receivedNotice;
      if (!valid(received)) received=null;
      let stored;
      try {
        const raw=sessionStorage.getItem(this.successKey);
        sessionStorage.removeItem(this.successKey);
        stored=raw?JSON.parse(raw):null;
      } catch {}
      if (!received && valid(stored)) received=stored;
      try {
        if (history.state?.aesInquirySuccess?.key===this.successKey) {
          if (!received && valid(history.state.aesInquirySuccess.notice)) received=history.state.aesInquirySuccess.notice;
          const state={...history.state}; delete state.aesInquirySuccess;
          history.replaceState(state,'');
        }
      } catch {}
      if (received) {
        const notice={at:received.at,heading:'Message sent',description:'Thank you for reaching out. We’ll respond within 1–2 business days.'};
        if (this.tagName.toLowerCase()==='aes-page-contact-section1' && typeof received.attachCart==='boolean') notice.attachCart=received.attachCart;
        this.successRecoveryNotice=notice;
        if (!this.successNoticeDismissed) this.showReceivedNotice(notice);
      }
      const schedule=()=>this.scheduleSuccessPosition();
      const signal=this.successLifecycleAbort.signal;
      window.addEventListener('scroll',schedule,{passive:true,signal});
      window.addEventListener('resize',schedule,{passive:true,signal});
      window.visualViewport?.addEventListener('resize',schedule,{passive:true,signal});
      window.visualViewport?.addEventListener('scroll',schedule,{passive:true,signal});
      window.addEventListener('pageshow',()=>{this.syncSuccessButton();this.scheduleSuccessPosition();},{signal});
      document.addEventListener('visibilitychange',()=>{if(!document.hidden){this.syncSuccessButton();this.scheduleSuccessPosition();}},{signal});
      this.successHeaderObserver?.disconnect();
      this.successHeaderResize?.disconnect();
      const header=document.querySelector('.aes-header-section1-host');
      if (header) {
        this.successHeaderObserver=new MutationObserver(schedule);
        this.successHeaderObserver.observe(header,{subtree:true,attributes:true,attributeFilter:['data-aes-header-hidden','data-aes-menu-open','aria-expanded']});
        if (typeof ResizeObserver!=='undefined') {
          this.successHeaderResize=new ResizeObserver(schedule);
          this.successHeaderResize.observe(header);
        }
      }
      this.scheduleSuccessPosition();
      this.syncSuccessButton();
    }
    showReceivedNotice(notice) {
      if (!this.loadingRegion) return;
      this.successNoticeAbort?.abort(); this.successNoticeAbort=new AbortController();
      this.loadingRegion.querySelector('[data-aes-form-success-notice]')?.remove();
      const banner=document.createElement('div');
      banner.className='aes-form-success-notice'; banner.dataset.aesFormSuccessNotice='';
      banner.setAttribute('role','status');
      const header=document.createElement('div'); header.className='aes-form-success-header';
      const heading=document.createElement('h2'); heading.textContent='Message sent'; heading.tabIndex=-1;
      const description=document.createElement('p'); description.textContent='Thank you for reaching out. We’ll respond within 1–2 business days.';
      const copy=this.copy || this.querySelector('template[data-aes-page-design-services-section5-copy],template[data-aes-page-contact-section1-copy]')?.content;
      const close=copy?.querySelector('[data-aes-form-success-close]')?.cloneNode(true);
      header.append(heading);
      if (close) {
        close.addEventListener('click',()=>{
          banner.remove(); this.receivedNotice=null; this.successNoticeDismissed=true;
        },{signal:this.successNoticeAbort.signal});
        header.append(close);
      }
      banner.append(header,description); this.loadingRegion.prepend(banner);
      this.receivedNotice=notice; this.successRecoveryNotice=notice;
      this.successFocusPending=true;
      this.scheduleSuccessPosition();
    }
    rememberSuccess(success) {
      if (this.restoringForm || !success?.matches?.('[data-testid="banner-success"]')) return {saved:false,notice:null};
      this.restoringForm=true;
      const notice={at:Date.now(),heading:'Message sent',description:'Thank you for reaching out. We’ll respond within 1–2 business days.'};
      if (this.tagName.toLowerCase()==='aes-page-contact-section1') {
        const choice=this.form?.querySelector('[data-aes-page-contact-section1-cart] input[type="checkbox"]');
        const captured=typeof this.successAttachCart==='boolean'?this.successAttachCart:this.successCartChoice;
        if (choice || typeof captured==='boolean') notice.attachCart=choice?choice.checked:captured;
      }
      let saved=false;
      try {sessionStorage.setItem(this.successKey,JSON.stringify(notice));saved=true;} catch {}
      if (!saved) try {history.replaceState({...history.state,aesInquirySuccess:{key:this.successKey,notice}},'');saved=true;} catch {}
      return {saved,notice};
    }
    restoreSuccessForm() {
      const form=this.form;
      if (this.tagName.toLowerCase()==='aes-page-contact-section1' && form && this.successLifecycleAbort && (this.successContactForm!==form || this.successContactSignal!==this.successLifecycleAbort.signal)) {
        const capture=()=>{
          const choice=form.querySelector('[data-aes-page-contact-section1-cart] input[type="checkbox"]');
          if (choice) this.successCartChoice=choice.checked;
        };
        this.successContactForm=form; this.successContactSignal=this.successLifecycleAbort.signal;
        form.addEventListener('change',capture,{signal:this.successContactSignal});
        form.addEventListener('submit',capture,{capture:true,signal:this.successContactSignal});
        capture();
      }
      const notice=this.successRecoveryNotice || this.receivedNotice;
      if (!notice || !form || !this.isConnected || !this.root?.contains(form) || form.hidden) return;
      if (this.loadingRegion?.hasAttribute('data-aes-form-loading')) {
        if (!this.successRestoreFrame) this.successRestoreFrame=requestAnimationFrame(()=>{
          this.successRestoreFrame=null;
          if (this.isConnected && !this.loadingRegion?.hasAttribute('data-aes-form-loading')) this.restoreSuccessForm();
        });
        return;
      }
      if (this.tagName.toLowerCase()==='aes-page-contact-section1' && !this.successCartRestored && typeof notice.attachCart==='boolean') {
        const choice=form.querySelector('[data-aes-page-contact-section1-cart] input[type="checkbox"]');
        if (!choice) return;
        choice.checked=notice.attachCart; this.successCartChoice=notice.attachCart; this.successCartRestored=true;
      }
      if (!this.successCountdownStarted) {
        this.successCountdownStarted=true; this.successSentUntil=Date.now()+3000;
      }
      this.restoringForm=false;
      this.syncSuccessButton();
      if (this.successFocusPending) {
        this.successFocusPending=false;
        this.successFocusFrame=requestAnimationFrame(()=>{
          this.successFocusFrame=null;
          if (!this.isConnected) return;
          const heading=this.loadingRegion?.querySelector('[data-aes-form-success-notice] h2');
          if (!heading) return;
          heading.focus({preventScroll:true});
          if (window.innerWidth>=768) heading.scrollIntoView({block:'center',behavior:'instant'});
        });
      }
    }
    successCooling() {
      return !!this.successCountdownStarted && Number.isFinite(this.successSentUntil) && Date.now()<this.successSentUntil;
    }
    releaseSuccessButton() {
      const state=this.successButtonState;
      if (!state) return;
      const button=state.button;
      button.removeAttribute('data-aes-form-sent');
      button.querySelector('[data-aes-form-sent-copy]')?.remove();
      button.disabled=state.disabled;
      if (state.hasAriaLabel) button.setAttribute('aria-label',state.ariaLabel); else button.removeAttribute('aria-label');
      for (const [name,value,priority] of state.properties) {
        if (value) button.style.setProperty(name,value,priority); else button.style.removeProperty(name);
      }
      this.successButtonState=null;
    }
    syncSuccessButton() {
      const button=this.form?.querySelector('[data-testid="btn-form-submit"]');
      if (this.successButtonState && this.successButtonState.button!==button) this.releaseSuccessButton();
      if (!this.successCooling()) {
        clearTimeout(this.successTimer); this.successTimer=null;
        this.releaseSuccessButton(); return false;
      }
      if (!button || !this.isConnected) return true;
      if (!this.successButtonState) {
        const names=['--aes-form-sent-width','--aes-form-sent-height','--aes-form-sent-font-size','--aes-form-sent-font-family'];
        const properties=names.map(name=>[name,button.style.getPropertyValue(name),button.style.getPropertyPriority(name)]);
        this.successButtonState={button,disabled:button.disabled,hasAriaLabel:button.hasAttribute('aria-label'),ariaLabel:button.getAttribute('aria-label'),properties};
        const rect=button.getBoundingClientRect();
        if (rect.width>0) button.style.setProperty(names[0],rect.width+'px');
        if (rect.height>0) button.style.setProperty(names[1],rect.height+'px');
        const computed=getComputedStyle(button);
        button.style.setProperty(names[2],computed.fontSize || '14px');
        button.style.setProperty(names[3],computed.fontFamily || 'inherit');
      }
      if (!button.hasAttribute('data-aes-form-sent')) button.setAttribute('data-aes-form-sent','');
      if (!button.disabled) button.disabled=true;
      if (button.getAttribute('aria-label')!=='SENT') button.setAttribute('aria-label','SENT');
      if (!button.querySelector('[data-aes-form-sent-copy]')) {
        const label=document.createElement('span'); label.dataset.aesFormSentCopy='';label.setAttribute('aria-hidden','true');label.textContent='SENT';button.append(label);
      }
      if (!this.successTimer) this.successTimer=setTimeout(()=>{
        this.successTimer=null;
        if (this.isConnected) this.syncSuccessButton();
      },Math.max(0,this.successSentUntil-Date.now()));
      return true;
    }
    scheduleSuccessPosition() {
      if (!this.isConnected || !this.loadingRegion?.querySelector('[data-aes-form-success-notice]')) return;
      this.successTrackUntil=Date.now()+260;
      if (this.successPositionFrame) return;
      const update=()=>{
        this.successPositionFrame=null;
        if (!this.isConnected) return;
        const notice=this.loadingRegion?.querySelector('[data-aes-form-success-notice]');
        if (!notice) return;
        if (window.innerWidth<768) {
          const bottom=document.querySelector('.aes-header-section1-host')?.getBoundingClientRect().bottom || 0;
          const value=Math.max(0,bottom)+8+'px';
          if (notice.style.getPropertyValue('--aes-form-success-top')!==value) notice.style.setProperty('--aes-form-success-top',value);
          if (Date.now()<this.successTrackUntil) this.successPositionFrame=requestAnimationFrame(update);
        } else notice.style.removeProperty('--aes-form-success-top');
      };
      this.successPositionFrame=requestAnimationFrame(update);
    }
    disposeSuccess() {
      this.successLifecycleAbort?.abort(); this.successNoticeAbort?.abort();
      this.successHeaderObserver?.disconnect(); this.successHeaderResize?.disconnect();
      clearTimeout(this.successTimer); this.successTimer=null;
      cancelAnimationFrame(this.successPositionFrame); this.successPositionFrame=null;
      cancelAnimationFrame(this.successRestoreFrame); this.successRestoreFrame=null;
      cancelAnimationFrame(this.successFocusFrame); this.successFocusFrame=null;
      this.releaseSuccessButton();
    }
    async completeSubmission(success) {
      const {saved,notice}=this.rememberSuccess(success);
      if (!notice) return;
      const heading=success.querySelector('h2'),description=success.querySelector('p');
      if (heading) heading.textContent=notice.heading;
      if (description) description.textContent=notice.description;
      if (saved) {
        this.showReceivedNotice(notice);
        success.style.setProperty('display','none','important');
      }
      if (this.submittedHeight) this.loadingRegion.style.minHeight=this.submittedHeight+'px';
      this.fileCards?.dispose();
      await this.uploader?.observedSuccess();
      if (!this.isConnected) return;
      if (saved) location.reload();
      else {
        const close=this.copy.querySelector('[data-aes-form-success-close]').cloneNode(true);
        close.addEventListener('click',()=>location.reload(),{signal:this.abort.signal}); success.append(close);
      }
    }
    decorate() {
      const prefix='aes-page-design-services-section5',form=this.form;
      const success=this.root.querySelector('[data-testid="banner-success"]');
      if (!form) {
        if (success) this.completeSubmission(success);
        const heading=success?.querySelector('h2');
        if (heading && !heading.hasAttribute('tabindex')) { heading.tabIndex=-1; heading.focus({preventScroll:true}); }
        return;
      }
      form.dataset.aesPageDesignServicesSection5Form='';
      const metadata=form.querySelector('[id="custom#inquiry_attachment_manifest"],[name="custom#inquiry_attachment_manifest"]');
      if (metadata) {
        const group=metadata.closest('[class*="_formFieldContainer_"]') || metadata.parentElement;
        group.hidden=true; group.style.setProperty('display','none','important'); metadata.required=false; metadata.tabIndex=-1;
      }
      for (const id of ['first_name','email','custom#project_location','custom#tell_us_about_your_project']) {
        const input=form.querySelector('[id="'+id+'"],[name="'+id+'"]');
        if (!input) continue;
        if (!input.id) input.id=id;
        const group=input.closest('[class*="_formFieldContainer_"]') || input.parentElement;
        group.classList.add(prefix+'-field');
        const label=group.querySelector('label');
        input.required=true;
        if (id==='email') { input.type='email'; input.autocomplete='email'; }
        if (id==='first_name') input.autocomplete='name';
        if (input.tagName==='TEXTAREA') input.maxLength=5000;
        const placeholder=this.copy.querySelector('[data-aes-page-design-services-section5-placeholder="'+id+'"]')?.textContent.trim() || label?.textContent.trim() || '';
        if (input.placeholder!==placeholder) input.placeholder=placeholder;
        const nativeError=group.nextElementSibling?.matches('output[role="alert"]') ? group.nextElementSibling : null;
        let errorCopy=group.querySelector('.'+prefix+'-field-error');
        const previousError=input.dataset.aesPageDesignServicesSection5Error;
        const described=new Set((input.getAttribute('aria-describedby') || '').split(/\s+/).filter(Boolean));
        if (previousError) described.delete(previousError);
        if (nativeError) {
          nativeError.classList.add(prefix+'-native-error');
          if (!nativeError.id) nativeError.id=id+'-aes-error';
          input.dataset.aesPageDesignServicesSection5Error=nativeError.id;
          described.add(nativeError.id);
          if (!errorCopy) { errorCopy=document.createElement('span'); errorCopy.className=prefix+'-field-error'; errorCopy.setAttribute('aria-hidden','true'); group.append(errorCopy); }
          if (errorCopy.textContent!==nativeError.textContent) errorCopy.textContent=nativeError.textContent;
        } else {
          errorCopy?.remove();
          delete input.dataset.aesPageDesignServicesSection5Error;
        }
        if (described.size) input.setAttribute('aria-describedby',Array.from(described).join(' ')); else input.removeAttribute('aria-describedby');
      }
      this.renderUploads();
      const button=form.querySelector('[data-testid="btn-form-submit"]');
      if (button && !button.querySelector('[data-aes-page-design-services-section5-arrow]')) button.append(this.copy.querySelector('[data-aes-page-design-services-section5-arrow]').cloneNode(true));
      const disclaimerCopy=this.copy.querySelector('[data-aes-page-design-services-section5-disclaimer]');
      let disclaimer=form.querySelector('[data-aes-page-design-services-section5-disclaimer]');
      if (!disclaimer) {
        const native=form.parentElement.querySelector('[class*="_formDisclaimer_"]') || (form.nextElementSibling?.tagName==='P' ? form.nextElementSibling : null);
        disclaimer=disclaimerCopy.textContent.trim() ? disclaimerCopy.cloneNode(true) : native?.querySelector('p')?.cloneNode(true) || native?.cloneNode(true);
        if (disclaimer) {
          disclaimer.dataset.aesPageDesignServicesSection5Disclaimer=''; disclaimer.classList.add(prefix+'-disclaimer');
          if (native && disclaimer!==native) native.hidden=true;
          form.insertBefore(disclaimer,button);
        }
      }
      if (!form.querySelector('[data-aes-page-design-services-section5-status]')) {
        const status=document.createElement('p'); status.className=prefix+'-status'; status.dataset.aesPageDesignServicesSection5Status=''; status.setAttribute('role','status'); status.setAttribute('aria-live','polite'); status.hidden=true;
        form.append(status);
      }
      this.restoreSuccessForm();
    }
    fileInputs() { return Array.from(this.form?.querySelectorAll('input[type="file"]:not([data-aes-page-design-services-section5-picker])') || []); }
    fileGroup(input) { return input.closest('[class*="_formFileInput_"]') || input.parentElement.parentElement; }
    fileName(input) { return input.files?.[0]?.name || this.fileGroup(input).querySelector('[class*="_formFileInputFileName_"]')?.textContent.trim() || ''; }
    filesError(files) {
      const types={pdf:['application/pdf'],png:['image/png'],jpg:['image/jpeg'],jpeg:['image/jpeg'],webp:['image/webp'],svg:['image/svg+xml'],heic:['image/heic','image/heif'],gif:['image/gif']};
      for (const file of files) {
        const allowed=types[file.name.split('.').pop().toLowerCase()];
        if (!allowed || (file.type && !allowed.includes(file.type.toLowerCase()))) return 'Choose a PDF, PNG, JPG, JPEG, WEBP, SVG, HEIC or GIF file. XLSX files are not supported.';
        if (file.size>20*1024*1024) return 'Each file must be 20 MB or smaller.';
      }
      return '';
    }
    clearUpload(input) {
      this.fileGroup(input).querySelector('button[class*="_formFileInputCancelButton_"]')?.click();
      input.value=''; this.uploadErrors.delete(input.id);
    }
    selectUploads(picker) {
      if (this.busy) { picker.value=''; return; }
      if (this.dataset.uploadEndpoint) {
        try {
          if (!this.uploader) throw new Error(this.uploadSetupError || this.uploadCopy.service_loading);
          this.uploader.add(Array.from(picker.files || [])); this.uploadErrors.clear();
        } catch(error) { this.uploadErrors.set(picker.id,error.message); }
        picker.value=''; this.renderUploads(); return;
      }
      const files=Array.from(picker.files || []),inputs=this.fileInputs();
      const available=inputs.filter(input=>!this.fileName(input));
      const remaining=Math.min(available.length,3-inputs.filter(input=>this.fileName(input)).length);
      const message=files.length>remaining ? this.uploadCopy.file_count : this.filesError(files);
      if (message) this.uploadErrors.set(picker.id,message);
      else {
        this.uploadErrors.delete(picker.id);
        files.forEach((file,index)=>{ const transfer=new DataTransfer(); transfer.items.add(file); available[index].files=transfer.files; available[index].dispatchEvent(new Event('change',{bubbles:true})); });
      }
      picker.value=''; queueMicrotask(()=>this.decorate());
    }
    removeUpload(target) {
      if (this.busy) return;
      const inputs=this.fileInputs(),remaining=inputs.filter(input=>input!==target).map(input=>input.files?.[0]).filter(Boolean);
      this.uploadErrors.clear(); inputs.forEach(input=>this.clearUpload(input));
      remaining.forEach((file,index)=>{ const input=this.fileInputs()[index],transfer=new DataTransfer(); transfer.items.add(file); input.files=transfer.files; input.dispatchEvent(new Event('change',{bubbles:true})); });
      queueMicrotask(()=>{ this.decorate(); this.form?.querySelector('[data-aes-page-design-services-section5-upload]')?.focus(); });
    }
    validateUploads() {
      if (this.dataset.uploadEndpoint) {
        this.uploadErrors.clear();
        const error=this.uploadSetupError || this.uploader?.validate(this.uploader.files);
        if (error) this.uploadErrors.set('service',error);
        this.renderUploads(); return !error;
      }
      this.uploadErrors.clear();
      const inputs=this.fileInputs();
      for (const input of inputs) {
        const files=Array.from(input.files || []),message=files.length>1 ? 'Choose files using the upload area.' : this.filesError(files);
        if (message) this.uploadErrors.set(input.id,message);
      }
      if (inputs.filter(input=>this.fileName(input)).length>3) this.uploadErrors.set('count',this.uploadCopy.file_count);
      this.renderUploads(); return this.uploadErrors.size===0;
    }
    renderUploads() {
      const prefix='aes-page-design-services-section5',inputs=this.fileInputs();
      if (this.dataset.uploadEndpoint) { this.renderRemoteUploads(); return; }
      if (!inputs.length) return;
      inputs.forEach(input=>{ input.accept='.pdf,.jpg,.jpeg,.png,.webp,.svg,.heic,.gif'; input.multiple=false; this.fileGroup(input).classList.add(prefix+'-native-upload'); });
      let group=this.form.querySelector('.'+prefix+'-upload');
      if (!group) {
        group=document.createElement('div'); group.className=prefix+'-upload';
        const list=document.createElement('ul'); list.className=prefix+'-upload-list'; list.setAttribute('aria-live','polite');
        const button=this.copy.querySelector('[data-aes-page-design-services-section5-upload]').cloneNode(true);
        const label=button.querySelector('[data-aes-page-design-services-section5-upload-label]');
        if (!label.textContent.trim()) label.textContent=(inputs[0].getAttribute('aria-label') || 'Upload Floor Plan')+' (Optional)';
        button.dataset.aesOriginalLabel=label.textContent;
        const picker=document.createElement('input'); picker.type='file'; picker.multiple=true; picker.accept=inputs[0].accept; picker.hidden=true; picker.className=prefix+'-upload-picker'; picker.dataset.aesPageDesignServicesSection5Picker=''; picker.id=prefix+'-picker-'+this.id;
        button.addEventListener('click',()=>{ if (!this.busy) picker.click(); },{signal:this.abort.signal});
        group.append(list,button,picker);
        this.fileGroup(inputs[0]).before(group);
      }
      const selected=inputs.filter(input=>this.fileName(input));
      const key=JSON.stringify([!!this.fileCards,selected.map(input=>[input.id,this.fileName(input),input.files?.[0]?.lastModified])]);
      if (group.dataset.aesFiles!==key) {
        group.dataset.aesFiles=key; group.toggleAttribute('data-aes-has-files',selected.length>0);
        const list=group.querySelector('.'+prefix+'-upload-list'); list.replaceChildren();
        const entries=selected.map(input=>{
          const row=document.createElement('li'); row.className=prefix+'-filename';
          const name=document.createElement('span'); name.textContent=this.fileName(input);
          const remove=this.copy.querySelector('[data-aes-page-design-services-section5-remove]').cloneNode(true); remove.setAttribute('aria-label','Remove '+name.textContent);
          const onRemove=()=>this.removeUpload(input);
          if (!this.fileCards) { remove.addEventListener('click',onRemove,{signal:this.abort.signal}); row.append(name,remove); list.append(row); }
          return {file:input.files?.[0],name:name.textContent,removeButton:remove,onRemove};
        });
        this.fileCards?.render(list,entries);
        const button=group.querySelector('[data-aes-page-design-services-section5-upload]'),label=button.querySelector('[data-aes-page-design-services-section5-upload-label]');
        label.textContent=selected.length ? selected.length>=3 ? this.uploadCopy.files_added : this.copy.querySelector('[data-aes-page-design-services-section5-replace-label]').textContent.trim() || this.uploadCopy.add_file : button.dataset.aesOriginalLabel;
        button.disabled=selected.length>=Math.min(3,inputs.length);
      }
      const nativeErrors=inputs.map(input=>{ const box=this.fileGroup(input),alert=box.querySelector('output[role="alert"]') || (box.nextElementSibling?.matches('output[role="alert"]') ? box.nextElementSibling : null); if (alert) alert.classList.add(prefix+'-native-error'); return alert?.textContent.trim() || ''; }).filter(Boolean);
      const messages=[...new Set([...this.uploadErrors.values(),...nativeErrors])].join(' ');
      let error=group.querySelector('[data-aes-page-design-services-section5-file-error]');
      if (messages) {
        if (!error) { error=document.createElement('p'); error.dataset.aesPageDesignServicesSection5FileError=''; error.setAttribute('role','alert'); error.id=prefix+'-upload-error-'+this.id; group.append(error); }
        const override=this.copy.querySelector('[data-aes-page-design-services-section5-file-error]').textContent.trim(); if (error.textContent!==(override || messages)) error.textContent=override || messages;
      } else error?.remove();
      const button=group.querySelector('[data-aes-page-design-services-section5-upload]'); if (error) button.setAttribute('aria-describedby',error.id); else button.removeAttribute('aria-describedby');
    }
    renderRemoteUploads() {
      const prefix='aes-page-design-services-section5',form=this.form;
      if (!form) return;
      this.fileInputs().forEach(input=>this.fileGroup(input).classList.add(prefix+'-native-upload'));
      let group=form.querySelector('.'+prefix+'-upload');
      if (!group) {
        group=document.createElement('div'); group.className=prefix+'-upload';
        const list=document.createElement('ul'); list.className=prefix+'-upload-list'; list.setAttribute('aria-live','polite');
        const button=this.copy.querySelector('[data-aes-page-design-services-section5-upload]').cloneNode(true);
        const picker=document.createElement('input'); picker.type='file'; picker.multiple=true; picker.hidden=true; picker.className=prefix+'-upload-picker'; picker.dataset.aesPageDesignServicesSection5Picker=''; picker.id=prefix+'-picker-'+this.id;
        button.addEventListener('click',()=>{if (!this.busy) picker.click();},{signal:this.abort.signal});
        group.append(list,button,picker);
        const native=this.fileInputs()[0],target=native ? this.fileGroup(native) : form.querySelector('[data-aes-page-design-services-section5-disclaimer],[data-testid="btn-form-submit"]');
        target ? target.before(group) : form.append(group);
      }
      const files=this.uploader?.files || [],key=JSON.stringify([!!this.fileCards,files.map(file=>[file.name,file.size,file.lastModified])]);
      if (group.dataset.aesFiles!==key) {
        group.dataset.aesFiles=key; group.toggleAttribute('data-aes-has-files',files.length>0);
        const list=group.querySelector('.'+prefix+'-upload-list'); list.replaceChildren();
        const entries=files.map((file,index)=>{
          const row=document.createElement('li'); row.className=prefix+'-filename';
          const name=document.createElement('span'); name.textContent=file.name;
          const remove=this.copy.querySelector('[data-aes-page-design-services-section5-remove]').cloneNode(true); remove.setAttribute('aria-label',this.uploadCopy.remove_file.replace('%filename%',file.name));
          const onRemove=()=>{if(this.busy)return;this.uploader.remove(index);this.uploadErrors.clear();this.renderUploads();group.querySelector('[data-aes-page-design-services-section5-upload]')?.focus();};
          if (!this.fileCards) { remove.addEventListener('click',onRemove,{signal:this.abort.signal}); row.append(name,remove); list.append(row); }
          return {file,name:file.name,removeButton:remove,onRemove};
        });
        this.fileCards?.render(list,entries);
      }
      const button=group.querySelector('[data-aes-page-design-services-section5-upload]'),label=button.querySelector('[data-aes-page-design-services-section5-upload-label]');
      const text=files.length ? files.length>=3 ? this.uploadCopy.files_added : this.copy.querySelector('[data-aes-page-design-services-section5-replace-label]').textContent.trim() || this.uploadCopy.add_file : this.uploadCopy[this.dataset.uploadPage==='custom-service' ? 'cad_label' : 'floor_label'];
      if (label.textContent!==text) label.textContent=text;
      button.disabled=files.length>=3;
      group.querySelector('input[type="file"]').accept=this.uploader?.accept || '';
      const message=[...new Set(this.uploadErrors.values())].join(' ');
      let error=group.querySelector('[data-aes-page-design-services-section5-file-error]');
      if (message) {
        if (!error) {error=document.createElement('p');error.dataset.aesPageDesignServicesSection5FileError='';error.setAttribute('role','alert');error.id=prefix+'-upload-error-'+this.id;group.append(error);}
        if (error.textContent!==message) error.textContent=message;
        button.setAttribute('aria-describedby',error.id);
      } else {error?.remove();button.removeAttribute('aria-describedby');}
    }
    async prepareUploads() {
      const form=this.form,button=form.querySelector('[data-testid="btn-form-submit"]');
      this.uploading=true; this.uploadErrors.clear(); this.uploadProgress=this.uploadCopy.preparing;
      const controller=new AbortController();this.prepareAbort=controller;
      button?.style.setProperty('--aes-page-design-services-section5-submit-width',button.getBoundingClientRect().width+'px');this.syncBusy();
      try {
        await this.uploaderReady;
        if (controller.signal.aborted || this.form!==form) return;
        if (!this.uploader || this.uploadSetupError) throw new Error(this.uploadSetupError || this.uploadCopy.service_refresh);
        const field=form.querySelector('[id="custom#inquiry_attachment_manifest"],[name="custom#inquiry_attachment_manifest"]');
        if (!field) throw new Error(this.uploadCopy.form_not_ready);
        let security=form.querySelector('[data-aes-inquiry-security]');
        if (!security) {security=document.createElement('div');security.dataset.aesInquirySecurity='';security.style.gridColumn='1 / -1';button.before(security);}
        const metadata=await this.uploader.prepare(security,{signal:controller.signal,onProgress:percent=>{this.uploadProgress=this.uploadCopy.progress.replace('%percent%',String(percent));this.syncBusy();}});
        if (controller.signal.aborted || this.form!==form) return;
        const serialized=JSON.stringify(metadata),maximum=Math.min(field.maxLength>0?field.maxLength:60000,60000);
        if (serialized.length>maximum) throw new Error(this.uploadCopy.manifest_too_large);
        const prototype=field.tagName==='TEXTAREA' ? HTMLTextAreaElement.prototype : HTMLInputElement.prototype;
        Object.getOwnPropertyDescriptor(prototype,'value').set.call(field,serialized);
        field.dispatchEvent(new Event('input',{bubbles:true}));field.dispatchEvent(new Event('change',{bubbles:true}));
        await new Promise(resolve=>requestAnimationFrame(()=>requestAnimationFrame(resolve)));
        if (controller.signal.aborted || this.form!==form) return;
        this.uploading=false;this.release();this.prepared=true;form.requestSubmit();
      } catch(error) {
        if (controller.signal.aborted || this.form!==form || !this.isConnected) return;
        this.uploading=false;this.prepared=false;this.attempted=false;this.release();
        this.uploadErrors.set('service',error.message || this.uploadCopy.upload_failed);this.renderUploads();
      } finally {if(this.prepareAbort===controller)this.prepareAbort=null;}
    }
    syncBusy() {
      const form=this.form;
      if (!form || !this.root.contains(form)) return;
      const button=form.querySelector('[data-testid="btn-form-submit"]');
      if (this.successCooling()) { this.release(); this.syncSuccessButton(); return; }
      this.syncSuccessButton();
      const nativeBusy=!!(button?.disabled || button?.getAttribute('aria-disabled')==='true');
      if (this.awaitingNative && (nativeBusy || form.querySelector('[aria-invalid="true"],output[role="alert"]'))) this.awaitingNative=false;
      const busy=this.uploading || this.awaitingNative || (this.attempted && nativeBusy);
      if (this.busy && !busy) this.attempted=false;
      this.busy=busy;
      form.toggleAttribute('data-aes-page-design-services-section5-busy',busy);
      form.setAttribute('aria-busy',String(busy));
      button?.toggleAttribute('data-aes-page-design-services-section5-busy',busy);
      if (busy) {
        this.pendingStarted ||= Date.now();
        for (const control of form.querySelectorAll('input,textarea,select,button')) {
          if (!this.locked.has(control)) this.locked.set(control,control.inert);
          control.inert=true;
        }
      } else this.release();
      const status=form.querySelector('[data-aes-page-design-services-section5-status]');
      if (status) {
        status.hidden=!busy || Date.now()-this.pendingStarted<1500;
        const message=this.uploading ? this.uploadProgress || this.uploadCopy.preparing : Date.now()-this.pendingStarted>90000 ? this.copy.querySelector('[data-aes-page-design-services-section5-slow-message]').textContent.trim() || 'Your submission is taking longer than expected. Check any verification or error message before trying again.' : this.copy.querySelector('[data-aes-page-design-services-section5-pending]').textContent.trim();
        if (busy && status.textContent!==message) status.textContent=message;
      }
    }
    release() {
      this.awaitingNative=false;
      for (const [control,inert] of this.locked || []) control.inert=inert;
      this.locked?.clear();
      this.busy=false;
      this.pendingStarted=0;
      this.form?.removeAttribute('data-aes-page-design-services-section5-busy');
      this.form?.setAttribute('aria-busy','false');
      this.form?.querySelector('[data-testid="btn-form-submit"]')?.removeAttribute('data-aes-page-design-services-section5-busy');
      this.form?.querySelector('[data-testid="btn-form-submit"]')?.style.removeProperty('--aes-page-design-services-section5-submit-width');
      const status=this.form?.querySelector('[data-aes-page-design-services-section5-status]');
      if (status) status.hidden=true;
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["aes-page-design-services-sticky-cta"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('aes-design-services-sticky-cta')) {
  customElements.define('aes-design-services-sticky-cta', class extends HTMLElement {
    connectedCallback() {
      this.abort?.abort();
      this.abort = new AbortController();
      const signal = this.abort.signal;
      this.schedule = () => {
        if (!this.frame) this.frame = requestAnimationFrame(() => {
          this.frame = 0;
          this.update();
        });
      };
      this.refresh = () => {
        this.resizeObserver?.disconnect();
        const main = this.closest('main');
        this.regions = main ? [...main.querySelectorAll('.aes-page-design-services-section2-container, .aes-page-design-services-section3-container, .aes-page-design-services-section4-container')] : [];
        this.form = main?.querySelector('#design-consultation')?.closest('.aes-page-design-services-section5-container');
        this.header = document.querySelector('.aes-header-section1-host');
        if (typeof ResizeObserver !== 'undefined') {
          this.resizeObserver = new ResizeObserver(this.schedule);
          [main, this.header, this.form, ...this.regions].filter(Boolean).forEach(element => this.resizeObserver.observe(element));
        }
        this.schedule();
      };
      window.addEventListener('scroll', this.schedule, { passive: true, signal });
      window.addEventListener('resize', this.schedule, { passive: true, signal });
      window.visualViewport?.addEventListener('resize', this.schedule, { passive: true, signal });
      ['shopify:section:load', 'shopify:section:unload', 'shopify:section:reorder'].forEach(type => document.addEventListener(type, this.refresh, { signal }));
      if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', this.refresh, { once: true, signal });
      this.refresh();
    }
    update() {
      if (!this.form?.isConnected || !this.regions?.length) {
        this.hidden = true;
        return;
      }
      const bounds = this.regions.filter(region => region.isConnected).map(region => region.getBoundingClientRect()).filter(rect => rect.height > 0);
      const form = this.form.getBoundingClientRect();
      const headerBottom = Math.max(0, this.header?.getBoundingClientRect().bottom || 0);
      const viewportBottom = window.visualViewport ? window.visualViewport.offsetTop + window.visualViewport.height : window.innerHeight;
      const inRange = bounds.length > 0
        && Math.min(...bounds.map(rect => rect.top)) < viewportBottom
        && Math.max(...bounds.map(rect => rect.bottom)) > headerBottom;
      this.hidden = !inRange || form.height === 0 || form.top < viewportBottom;
    }
    disconnectedCallback() {
      this.abort?.abort();
      this.resizeObserver?.disconnect();
      cancelAnimationFrame(this.frame);
      this.frame = 0;
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["aes-page-faq-section2"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('aes-page-faq-section2')) {
  class AesPageFaqSection2 extends HTMLElement {
    connectedCallback() {
      this.aesPageFaqSection2Abort?.abort();
      this.aesPageFaqSection2Abort = new AbortController();
      const signal = this.aesPageFaqSection2Abort.signal;
      this.aesPageFaqSection2Groups = [...this.querySelectorAll('.aes-page-faq-section2-group')];
      this.aesPageFaqSection2Links = [...this.querySelectorAll('.aes-page-faq-section2-category-link')];
      this.aesPageFaqSection2Dropdown = this.querySelector('.aes-page-faq-section2-dropdown');
      this.aesPageFaqSection2Animations = new Map();
      this.aesPageFaqSection2ScrollTarget = null;
      this.aesPageFaqSection2Header = document.querySelector('aes-header');
      this.aesPageFaqSection2ReducedMotion = matchMedia('(prefers-reduced-motion: reduce)');
      this.addEventListener('click', event => {
        const link = event.target.closest('.aes-page-faq-section2-category-link');
        if (link && !event.ctrlKey && !event.metaKey && !event.shiftKey && !event.altKey && event.button === 0) {
          const group = this.aesPageFaqSection2Groups.find(item => '#' + item.id === link.getAttribute('href'));
          if (!group) return;
          event.preventDefault();
          this.aesPageFaqSection2Dropdown.open = false;
          this.aesPageFaqSection2MeasureHeader();
          this.aesPageFaqSection2ScrollTarget = this.aesPageFaqSection2ReducedMotion.matches ? null : group;
          group.scrollIntoView({ block: 'start', behavior: this.aesPageFaqSection2ReducedMotion.matches ? 'instant' : 'smooth' });
          group.querySelector('h2').focus({ preventScroll: true });
          this.aesPageFaqSection2Select(group);
          history.replaceState(history.state, '', '#' + group.id);
          return;
        }
        const summary = event.target.closest('.aes-page-faq-section2-question');
        if (summary) {
          event.preventDefault();
          this.aesPageFaqSection2Toggle(summary.parentElement);
        }
      }, { signal });
      this.addEventListener('keydown', event => {
        if (event.key === 'Escape' && this.aesPageFaqSection2Dropdown.open) {
          this.aesPageFaqSection2Dropdown.open = false;
          this.aesPageFaqSection2Dropdown.querySelector('summary').focus();
        }
      }, { signal });
      document.addEventListener('click', event => {
        if (!this.aesPageFaqSection2Dropdown.contains(event.target)) this.aesPageFaqSection2Dropdown.open = false;
      }, { signal });
      const schedule = () => {
        if (this.aesPageFaqSection2Raf) return;
        this.aesPageFaqSection2Raf = requestAnimationFrame(() => {
          this.aesPageFaqSection2Raf = 0;
          this.aesPageFaqSection2MeasureHeader();
          const threshold = this.aesPageFaqSection2HeaderHeight + 32;
          let current = this.aesPageFaqSection2Groups[0];
          for (const group of this.aesPageFaqSection2Groups) {
            if (group.getBoundingClientRect().top <= threshold) current = group;
          }
          if (current) this.aesPageFaqSection2Select(this.aesPageFaqSection2ScrollTarget || current);
        });
      };
      const finishScroll = () => { clearTimeout(this.aesPageFaqSection2ScrollTimer); this.aesPageFaqSection2ScrollTarget = null; schedule(); };
      window.addEventListener('scroll', () => {
        schedule();
        if (this.aesPageFaqSection2ScrollTarget) {
          clearTimeout(this.aesPageFaqSection2ScrollTimer);
          this.aesPageFaqSection2ScrollTimer = setTimeout(finishScroll, 160);
        }
      }, { passive: true, signal });
      window.addEventListener('scrollend', finishScroll, { passive: true, signal });
      window.addEventListener('wheel', finishScroll, { passive: true, signal });
      window.addEventListener('touchstart', finishScroll, { passive: true, signal });
      window.addEventListener('keydown', event => { if (['ArrowUp', 'ArrowDown', 'PageUp', 'PageDown', 'Home', 'End', 'Escape'].includes(event.key)) finishScroll(); }, { signal });
      window.addEventListener('resize', schedule, { passive: true, signal });
      window.addEventListener('hashchange', schedule, { signal });
      this.aesPageFaqSection2Resize = new ResizeObserver(schedule);
      this.aesPageFaqSection2Resize.observe(this);
      if (this.aesPageFaqSection2Header) this.aesPageFaqSection2Resize.observe(this.aesPageFaqSection2Header);
      document.addEventListener('shopify:block:select', event => {
        if (!this.contains(event.target)) return;
        const item = event.target.closest('.aes-page-faq-section2-item');
        if (item) { this.aesPageFaqSection2Animations.get(item)?.cancel(); this.aesPageFaqSection2Animations.delete(item); item.open = true; item.removeAttribute('data-aes-page-faq-section2-closing'); }
        schedule();
      }, { signal });
      schedule();
    }
    aesPageFaqSection2MeasureHeader() {
      const header = this.aesPageFaqSection2Header;
      this.aesPageFaqSection2HeaderHeight = header ? Math.ceil(header.getBoundingClientRect().height) : 0;
      this.style.setProperty('--aes-page-faq-section2-header', this.aesPageFaqSection2HeaderHeight + 'px');
    }
    aesPageFaqSection2Select(group) {
      for (const link of this.aesPageFaqSection2Links) {
        if (link.getAttribute('href') === '#' + group.id) link.setAttribute('aria-current', 'location');
        else link.removeAttribute('aria-current');
      }
      this.querySelector('[data-aes-page-faq-section2-current]').textContent = group.querySelector('h2').textContent;
    }
    aesPageFaqSection2Toggle(item) {
      const frame = item.querySelector('.aes-page-faq-section2-answer-frame');
      const previous = this.aesPageFaqSection2Animations.get(item);
      const opening = !item.open || item.hasAttribute('data-aes-page-faq-section2-closing');
      const from = item.open ? frame.getBoundingClientRect().height : 0;
      previous?.cancel();
      this.aesPageFaqSection2Animations.delete(item);
      item.toggleAttribute('data-aes-page-faq-section2-closing', !opening);
      item.open = true;
      if (this.aesPageFaqSection2ReducedMotion.matches || !frame.animate) {
        item.open = opening;
        item.removeAttribute('data-aes-page-faq-section2-closing');
        return;
      }
      const animation = frame.animate([{ height: from + 'px' }, { height: (opening ? frame.scrollHeight : 0) + 'px' }], { duration: 300, easing: 'cubic-bezier(0.22, 1, 0.36, 1)', fill: 'both' });
      this.aesPageFaqSection2Animations.set(item, animation);
      animation.onfinish = () => {
        if (this.aesPageFaqSection2Animations.get(item) !== animation) return;
        item.open = opening;
        item.removeAttribute('data-aes-page-faq-section2-closing');
        animation.cancel();
        this.aesPageFaqSection2Animations.delete(item);
      };
    }
    disconnectedCallback() {
      this.aesPageFaqSection2Abort?.abort();
      this.aesPageFaqSection2Resize?.disconnect();
      clearTimeout(this.aesPageFaqSection2ScrollTimer);
      this.aesPageFaqSection2ScrollTarget = null;
      cancelAnimationFrame(this.aesPageFaqSection2Raf);
      this.aesPageFaqSection2Raf = 0;
      for (const [item, animation] of this.aesPageFaqSection2Animations || []) {
        animation.cancel();
        item.open = !item.hasAttribute('data-aes-page-faq-section2-closing');
        item.removeAttribute('data-aes-page-faq-section2-closing');
      }
    }
  }
  customElements.define('aes-page-faq-section2', AesPageFaqSection2);
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["aes-page-home-section5"] && !Shopify.designMode) return;
  try {
    

if (!customElements.get('aes-page-home-section5')) {
  class AesPageHomeSection5 extends HTMLElement {
    connectedCallback() {
      if (this.controller) return;
      this.track = this.querySelector('.aes-page-home-section5-track');
      if (!this.track) return;
      this.cards = Array.from(this.track.children);
      this.previous = this.querySelector('[data-aes-page-home-section5-previous]');
      this.next = this.querySelector('[data-aes-page-home-section5-next]');
      this.controls = this.querySelector('.aes-page-home-section5-controls');
      this.current = this.querySelector('[data-aes-page-home-section5-current]');
      this.motion = matchMedia('(prefers-reduced-motion: reduce)');
      this.controller = new AbortController();
      const signal = this.controller.signal;
      this.activeIndex = 0;
      this.targetIndex = null;
      this.targets = [];
      this.previous?.addEventListener('click', () => this.move((this.targetIndex ?? this.activeIndex) - 1), { signal });
      this.next?.addEventListener('click', () => this.move((this.targetIndex ?? this.activeIndex) + 1), { signal });
      this.track.addEventListener('keydown', event => {
        if (event.target !== this.track || !this.overflow || !['ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(event.key)) return;
        event.preventDefault();
        if (event.key === 'Home') this.move(0);
        else if (event.key === 'End') this.move(this.targets.length - 1);
        else this.move((this.targetIndex ?? this.activeIndex) + ((event.key === 'ArrowRight') !== this.rtl ? 1 : -1));
      }, { signal });
      this.track.addEventListener('scroll', () => {
        if (this.scrollFrame) return;
        this.scrollFrame = requestAnimationFrame(() => { this.scrollFrame = null; this.sync(); });
      }, { passive: true, signal });
      this.track.addEventListener('scrollend', () => this.sync(), { signal });
      this.track.addEventListener('wheel', () => this.cancelMove(), { passive: true, signal });
      this.track.addEventListener('pointerdown', event => {
        if (event.button !== 0 || event.target.closest('button,input,textarea,select,video,iframe')) return;
        this.cancelMove();
        this.sync();
        this.suppressClick = false;
        if (event.pointerType === 'mouse' && this.overflow) this.drag = { id: event.pointerId, x: event.clientX, y: event.clientY, start: this.track.scrollLeft, moved: false };
      }, { passive: true, signal });
      window.addEventListener('pointermove', event => {
        const drag = this.drag;
        if (!drag || event.pointerId !== drag.id) return;
        const dx = event.clientX - drag.x, dy = event.clientY - drag.y;
        if (!drag.moved) {
          if (Math.abs(dx) < 6) return;
          if (Math.abs(dy) > Math.abs(dx)) { this.drag = null; return; }
          drag.moved = true;
          this.track.setPointerCapture(drag.id);
          this.track.setAttribute('data-aes-page-home-section5-dragging', '');
          this.track.setAttribute('data-aes-page-home-section5-moving', '');
        }
        event.preventDefault();
        this.track.scrollLeft = drag.start - dx;
      }, { signal });
      const endDrag = event => {
        if (!this.drag || event.pointerId !== this.drag.id) return;
        const moved = this.drag.moved;
        this.releaseDrag();
        if (moved) {
          this.suppressClick = true;
          clearTimeout(this.clickTimer);
          this.clickTimer = setTimeout(() => { this.suppressClick = false; }, 0);
          this.sync();
          this.move(this.activeIndex);
        }
      };
      window.addEventListener('pointerup', endDrag, { signal });
      window.addEventListener('pointercancel', endDrag, { signal });
      this.track.addEventListener('lostpointercapture', event => { if (this.drag?.id === event.pointerId) endDrag(event); }, { signal });
      this.track.addEventListener('click', event => { if (this.suppressClick) { event.preventDefault(); event.stopPropagation(); } }, { capture: true, signal });
      this.track.addEventListener('dragstart', event => event.preventDefault(), { signal });
      this.track.addEventListener('focusin', event => {
        if (this.drag?.moved || !this.overflow) return;
        const card = event.target.closest('.aes-page-home-section5-card');
        const rect = card?.getBoundingClientRect(), bounds = this.track.getBoundingClientRect();
        if (rect && (rect.left < bounds.left - 1 || rect.right > bounds.right + 1)) this.reveal(card);
      }, { signal });
      this.addEventListener('shopify:block:select', event => {
        const card = this.cards.find(card => card.getAttribute('data-aes-page-home-section5-block') === event.detail?.blockId);
        if (card) this.reveal(card);
      }, { signal });
      this.motion.addEventListener('change', () => { const target = this.targetIndex; this.cancelMove(); if (target !== null) this.move(target, false); }, { signal });
      this.observer = new ResizeObserver(() => {
        cancelAnimationFrame(this.measureFrame);
        this.measureFrame = requestAnimationFrame(() => { this.measureFrame = null; this.measure(); });
      });
      this.observer.observe(this.track);
      this.cards.forEach(card => this.observer.observe(card));
      this.measure();
    }
    measure() {
      const card = this.targets?.[this.targetIndex ?? this.activeIndex]?.card;
      this.cancelMove();
      this.releaseDrag();
      const style = getComputedStyle(this.track), bounds = this.track.getBoundingClientRect();
      this.rtl = style.direction === 'rtl';
      this.maximum = Math.max(0, this.track.scrollWidth - this.track.clientWidth);
      this.overflow = this.maximum > 1;
      this.track.tabIndex = this.overflow ? 0 : -1;
      if (this.controls) this.controls.hidden = !this.overflow;
      const padding = parseFloat(this.rtl ? style.scrollPaddingRight : style.scrollPaddingLeft) || 0;
      this.targets = [];
      this.cards.forEach((card, cardIndex) => {
        const rect = card.getBoundingClientRect();
        const position = this.track.scrollLeft + (this.rtl ? rect.right - bounds.right + padding : rect.left - bounds.left - padding);
        const value = this.rtl ? Math.max(-this.maximum, Math.min(0, position)) : Math.max(0, Math.min(this.maximum, position));
        if (!this.targets.some(target => Math.abs(target.value - value) < 1)) this.targets.push({ value, card, cardIndex });
      });
      if (card) this.reveal(card); else this.sync();
    }
    sync() {
      let nearest = 0, distance = Infinity;
      this.targets.forEach((target, index) => { const delta = Math.abs(target.value - this.track.scrollLeft); if (delta < distance) { nearest = index; distance = delta; } });
      this.activeIndex = nearest;
      const state = this.targetIndex ?? nearest;
      if (this.previous) this.previous.disabled = !this.overflow || state <= 0;
      if (this.next) this.next.disabled = !this.overflow || state >= this.targets.length - 1;
      if (this.current && this.targetIndex === null) {
        const text = String((this.targets[nearest]?.cardIndex ?? 0) + 1);
        if (this.current.textContent !== text) this.current.textContent = text;
      }
    }
    reveal(card) {
      let nearest = 0, distance = Infinity;
      const cardIndex = this.cards.indexOf(card);
      this.targets.forEach((target, index) => { const delta = Math.abs(target.cardIndex - cardIndex); if (delta < distance) { nearest = index; distance = delta; } });
      this.move(nearest, false);
    }
    cancelMove() {
      cancelAnimationFrame(this.animationFrame);
      this.animationFrame = null;
      this.targetIndex = null;
      this.track?.removeAttribute('data-aes-page-home-section5-moving');
    }
    releaseDrag() {
      const drag = this.drag;
      this.drag = null;
      if (drag && this.track.hasPointerCapture(drag.id)) this.track.releasePointerCapture(drag.id);
      this.track?.removeAttribute('data-aes-page-home-section5-dragging');
      this.track?.removeAttribute('data-aes-page-home-section5-moving');
    }
    move(index, animate = true) {
      if (!this.targets.length) return;
      this.cancelMove();
      const next = Math.max(0, Math.min(this.targets.length - 1, index));
      const start = this.track.scrollLeft, end = this.targets[next].value;
      const token = getComputedStyle(this).getPropertyValue('--aes-duration').trim();
      const duration = animate && !this.motion.matches ? parseFloat(token) * (token.endsWith('ms') ? 1 : 1000) : 0;
      if (!Number.isFinite(duration) || duration <= 1 || Math.abs(end - start) < 1) { this.track.scrollLeft = end; this.sync(); return; }
      this.targetIndex = next;
      this.track.setAttribute('data-aes-page-home-section5-moving', '');
      this.sync();
      let began;
      const tick = time => {
        began ??= time;
        const progress = Math.min((time - began) / duration, 1);
        this.track.scrollLeft = start + (end - start) * (1 - Math.pow(1 - progress, 3));
        if (progress < 1) this.animationFrame = requestAnimationFrame(tick);
        else { this.track.scrollLeft = end; this.cancelMove(); this.sync(); }
      };
      this.animationFrame = requestAnimationFrame(tick);
    }
    disconnectedCallback() {
      this.cancelMove();
      this.releaseDrag();
      cancelAnimationFrame(this.scrollFrame);
      cancelAnimationFrame(this.measureFrame);
      clearTimeout(this.clickTimer);
      this.observer?.disconnect();
      this.controller?.abort();
      this.controller = null;
    }
  }
  customElements.define('aes-page-home-section5', AesPageHomeSection5);
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["aes-page-material-quote-section1"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('aes-page-material-quote-section1')) {
  customElements.define('aes-page-material-quote-section1',class extends HTMLElement {
    initLoading() {
      this.loadingRegion=this.querySelector('[data-aes-form-mount]');
      this.loadingLogo=this.loadingRegion?.querySelector('[data-aes-global-loading]');
      this.loadingStatus=this.loadingRegion?.querySelector('[data-aes-form-load-status]');
      this.loadingRetry=this.loadingRegion?.querySelector('[data-aes-form-load-retry]');
      this.loadingLocks=new Map();
      this.loadingAbort?.abort(); this.loadingAbort=new AbortController();
      this.loadingRetry?.addEventListener('click',()=>{
        clearInterval(this.locateTimer); this.attempts=0; this.setLoading(true); this.locate();
        if (!this.root) this.locateTimer=setInterval(this.locate,250);
      },{signal:this.loadingAbort.signal});
      this.setLoading(true);
    }
    setLoading(loading,failed=false) {
      if (!this.loadingLogo) return;
      const region=this.loadingRegion;
      if (loading) {
        if (region.contains(document.activeElement)) { this.loadingStatus.tabIndex=-1; this.loadingStatus.focus({preventScroll:true}); }
        region.querySelectorAll('.shopify-block,shopify-forms-embed').forEach(node=>{
          if (!this.loadingLocks.has(node)) this.loadingLocks.set(node,node.inert);
          node.inert=true;
        });
      } else { this.loadingLocks.forEach((inert,node)=>{node.inert=inert}); this.loadingLocks.clear(); }
      region.toggleAttribute('data-aes-form-loading',loading);
      region.setAttribute('aria-busy',String(loading));
      this.loadingLogo.hidden=!loading;
      this.loadingStatus.hidden=!loading&&!failed;
      this.loadingStatus.setAttribute('role',failed?'alert':'status');
      this.loadingStatus.textContent=failed?'The form could not be loaded. Please retry or refresh the page.':'Loading form. Please wait.';
      this.loadingRetry.hidden=!failed;
    }
    connectedCallback() {
      if (this.connected) return;
      this.connected=true;
      this.attempts=0;
      this.initLoading();
      const action=this.querySelector('[data-aes-material-new-request]')||document.createElement('button');
      action.dataset.aesMaterialNewRequest='';
      action.type='button';action.className='aes-material-link';action.textContent='Start a new request';action.hidden=true;
      this.querySelector('[data-aes-form-mount]').append(action);this.newRequest=action;
      action.addEventListener('click',()=>location.reload(),{signal:this.loadingAbort.signal});
      this.locate=()=>{
        const root=this.querySelector('shopify-forms-embed')?.shadowRoot;
        if (root && (root.querySelector('[data-testid="banner-success"]') || (root.querySelector('[data-testid="btn-form-submit"]') && root.querySelectorAll('#first_name,#last_name,#email,[name="phone_number"],[id="custom#country_region"],[name="custom#country_region"],[id="custom#zip_postal_code"],[name="custom#zip_postal_code"],[name="custom#message"]').length===7))) {
          clearInterval(this.locateTimer);
          this.attach(root);
        } else if (++this.attempts>=120) {
          clearInterval(this.locateTimer);
          this.setLoading(false,true);
        }
      };
      this.locate();
      if (!this.root) this.locateTimer=setInterval(this.locate,250);
    }
    disconnectedCallback() {
      this.setLoading(false); this.loadingAbort?.abort();
      clearInterval(this.locateTimer);
      clearInterval(this.pendingTimer);
      this.observer?.disconnect();
      this.release();
      this.abort?.abort();
      this.prepareAbort?.abort();
      this.preparing=false;
      this.connected=false;
      this.root=null;
    }
    attach(root) {
      this.observer?.disconnect();
      clearInterval(this.pendingTimer);
      this.release();
      this.abort?.abort();
      this.prepareAbort?.abort();
      this.preparing=false;
      this.prepared=false;
      this.abort=new AbortController();
      window.addEventListener("resize",()=>this.positionPhoneMenu(),{signal:this.abort.signal});
      this.root=root;
      this.copy=this.querySelector('template[data-aes-page-material-quote-section1-copy]').content;
      this.form=root.querySelector('form');
      this.attempted=false;
      this.awaitingNative=false;
      this.locked=new Map();
      this.busy=false;
      const prefix='aes-page-material-quote-section1';
      let style=root.querySelector('style[data-aes-page-material-quote-section1-style]');
      if (!style) {
        style=document.createElement('style');
        style.dataset.aesPageMaterialQuoteSection1Style='';
        style.textContent=`
          :host{--inline-container-max-width:100%!important;--container-max-w:100%!important;--forms-body-font:normal 400 14px var(--aes-font-body)!important;--form-field-border-radius:0px!important;--button-border-radius:0px!important;--container-text-alignment:left!important}
          [data-form-root],[data-testid="app-router"],#form-container-ref,section[role="dialog"],[class*="_formContainer_"],[class*="_inline_"]{width:100%!important;max-width:none!important;padding:0!important;margin:0!important;background:transparent!important;border:0!important;box-shadow:none!important}
          :host(:focus),section[role="dialog"]:focus,form:focus{outline:none!important;box-shadow:none!important}
          [class*="_gridItemContent_"]{padding:0!important;min-width:0!important}
          [class*="_formHeader_"],form>div:has(shop-lead-capture){display:none!important}
          form[data-aes-page-material-quote-section1-form]{display:grid!important;grid-template-columns:minmax(0,1fr)!important;gap:24px!important;margin:0!important;padding:0!important;border:0!important;box-shadow:none!important;outline:none!important}
          form[data-aes-page-material-quote-section1-form],form[data-aes-page-material-quote-section1-form] *{box-sizing:border-box!important}
          .${prefix}-field{display:flex!important;flex-direction:column!important;gap:8px!important;position:relative!important;min-width:0!important}
          .${prefix}-field::before{content:none!important}
          .${prefix}-field label{position:static!important;order:-1!important;padding:0!important;margin:0!important;transform:none!important;color:var(--aes-text-primary)!important;font:400 14px/1.6 var(--aes-font-body)!important;line-height:round(nearest,22.4px,1px)!important;text-transform:uppercase!important;letter-spacing:0!important}
          .${prefix}-field label::after{content:' *'}
          .${prefix}-field :is(input,textarea,select){box-sizing:border-box!important;display:block!important;width:100%!important;max-width:none!important;min-height:48px!important;height:48px!important;padding:0 16px!important;margin:0!important;border:1px solid var(--aes-page-material-quote-section1-control-border)!important;border-radius:0!important;background:var(--aes-bg-primary)!important;color:var(--aes-text-secondary)!important;font:400 14px/1.6 var(--aes-font-body)!important;letter-spacing:0!important;box-shadow:none!important;outline:none!important;transition:border-color var(--aes-duration) var(--aes-ease)}
          .${prefix}-field textarea{height:96px!important;min-height:96px!important;resize:vertical!important;padding:12px 16px!important}
          .${prefix}-field :is(input,textarea,select)::placeholder{color:var(--aes-text-muted)!important;opacity:1!important}
          .${prefix}-field :is(input,textarea,select):is(:focus,:focus-visible){border-color:var(--aes-page-material-quote-section1-control-active)!important;outline:0!important;box-shadow:none!important}
          @media(hover:hover) and (pointer:fine){.${prefix}-field :is(input,textarea,select):hover:where(:not(:disabled)){border-color:var(--aes-page-material-quote-section1-control-active)!important}}
          .${prefix}-field :is(input,textarea,select)[aria-invalid="true"],.${prefix}-field[class*="_withError_"]>textarea,.${prefix}-field:has(+output[role="alert"]) :is(input,textarea,select){border-color:var(--aes-page-material-quote-section1-control-error)!important}
          output[role="alert"],[role="alert"]{grid-column:1/-1!important;margin:0!important;font:400 12px/1.6 var(--aes-font-body)!important;color:var(--aes-page-material-quote-section1-control-error)!important;text-transform:none!important;overflow-wrap:anywhere}
          .${prefix}-native-error{position:absolute!important;width:1px!important;height:1px!important;padding:0!important;margin:-1px!important;overflow:hidden!important;clip-path:inset(50%)!important;white-space:nowrap!important}
          .${prefix}-field-error{order:1!important;display:block;margin:0!important;color:var(--aes-page-material-quote-section1-control-error)!important;font:400 12px/1.6 var(--aes-font-body)!important;text-transform:none!important}
          [data-testid="btn-form-submit"]{position:relative!important;display:inline-flex!important;align-items:center!important;justify-content:center!important;gap:12px!important;justify-self:center!important;grid-column:1/-1!important;box-sizing:border-box!important;min-height:49px!important;height:49px!important;width:max-content!important;max-width:100%!important;margin:0!important;padding:0 16px!important;border:1px solid var(--aes-text-primary)!important;border-radius:0!important;box-shadow:none!important;background:transparent!important;color:var(--aes-text-primary)!important;font:400 16px/1.35 var(--aes-font-heading)!important;letter-spacing:0!important;text-transform:uppercase;transition:background var(--aes-duration),color var(--aes-duration)}
          [data-testid="btn-form-submit"]::after{content:'';position:absolute;inset:var(--aes-button-inset);border:var(--aes-button-inset-border-width) solid currentColor;opacity:0;pointer-events:none;transition:opacity var(--aes-duration)}
          [data-testid="btn-form-submit"]:is(:active,:focus-visible){background:#897266!important;border-color:#897266!important;color:var(--aes-text-inverse)!important}
          [data-testid="btn-form-submit"]:is(:active,:focus-visible)::after{opacity:1}
          [data-testid="btn-form-submit"]:focus{outline:none!important;box-shadow:none!important}
          .${prefix}-arrow{display:flex;align-items:center;justify-content:center;position:relative;width:16px;height:16px;flex:none}
          .${prefix}-arrow svg{display:block;width:24px;height:24px;flex:none;transform:rotate(-45deg) scale(.6666667)}
          .${prefix}-arrow [fill]:not([fill="none"]){fill:currentColor}
          [data-aes-page-material-quote-section1-busy] .${prefix}-arrow svg{visibility:hidden}
          [data-aes-page-material-quote-section1-busy] .${prefix}-arrow::after{content:'';position:absolute;inset:0;border:2px solid currentColor;border-right-color:transparent;border-radius:50%;animation:aes-page-material-quote-section1-submit 1s linear infinite}
          [data-aes-page-material-quote-section1-busy]>svg{display:none!important}
          [data-aes-page-material-quote-section1-busy] [data-testid="spinner-icon"]{display:none!important}
          [data-aes-page-material-quote-section1-busy] [class*="_visuallyHidden_"]{position:static!important;width:auto!important;height:auto!important;padding:0!important;margin:0!important;overflow:visible!important;clip:auto!important;clip-path:none!important;white-space:normal!important}
          [data-testid="btn-form-submit"][data-aes-page-material-quote-section1-busy]{min-width:var(--aes-page-material-quote-section1-submit-width,0px)!important}
          .${prefix}-status{grid-column:1/-1;margin:0;font:400 14px/1.6 var(--aes-font-body);color:var(--aes-text-secondary)}
          .${prefix}-status[hidden]{display:none!important}
          form[data-aes-page-material-quote-section1-busy] :is(input,textarea,select,button){cursor:wait}
          [data-testid="banner-success"]{padding:32px 0!important;color:var(--aes-text-primary);text-align:center}
          [data-testid="banner-success"] h2{margin:0 0 16px!important;font:400 28px/1.25 var(--aes-font-heading)!important;outline:none}
          [data-testid="banner-success"] p{margin:0!important;font:400 14px/1.6 var(--aes-font-body)!important;color:var(--aes-text-secondary)!important}
          @keyframes aes-page-material-quote-section1-submit{to{transform:rotate(360deg)}}
          @media(hover:hover) and (pointer:fine){[data-testid="btn-form-submit"]:hover:not(:disabled):not([aria-disabled="true"]){background:#897266!important;border-color:#897266!important;color:var(--aes-text-inverse)!important}[data-testid="btn-form-submit"]:hover:not(:disabled):not([aria-disabled="true"])::after{opacity:1}}
          @media(min-width:768px){form[data-aes-page-material-quote-section1-form]{grid-template-columns:minmax(0,1fr) minmax(0,1fr)!important;column-gap:32px!important}.${prefix}-field{gap:12px!important}.${prefix}-field:has(:is(textarea)){grid-column:1/-1}}
          @media(prefers-reduced-motion:reduce){[data-testid="btn-form-submit"],[data-testid="btn-form-submit"]::after{transition:none!important}[data-aes-page-material-quote-section1-busy] .${prefix}-arrow::after{animation:none}}
        
          .aes-page-material-quote-section1-field{order:var(--aes-page-material-quote-section1-field-order)}
          .aes-page-material-quote-section1-cart{grid-column:1/-1;order:7;display:flex;align-items:center;gap:12px;margin:0;font:400 14px/1.6 var(--aes-font-body);cursor:pointer}
          .aes-page-material-quote-section1-cart input{appearance:none!important;-webkit-appearance:none!important;display:inline-grid;place-items:center;width:20px;height:20px;min-width:20px;margin:0;padding:0;border:1px solid var(--aes-text-primary);border-radius:0;background:var(--aes-bg-primary);flex:none;cursor:pointer}
          .aes-page-material-quote-section1-cart input::after{content:'';display:block;width:20px;height:20px;background:var(--aes-text-inverse);mask:var(--aes-page-material-quote-section1-check-icon) center/contain no-repeat;-webkit-mask:var(--aes-page-material-quote-section1-check-icon) center/contain no-repeat;opacity:0}
          .aes-page-material-quote-section1-cart input:checked{background:var(--aes-text-primary);border-color:var(--aes-text-primary)}
          .aes-page-material-quote-section1-cart input:checked::after{opacity:1}
          .aes-page-material-quote-section1-cart input:focus-visible{outline:2px solid var(--aes-border-focus)!important;outline-offset:2px}
          .aes-page-material-quote-section1-snapshot{display:none!important}
          .aes-page-material-quote-section1-field [data-aes-page-material-quote-section1-native-country]{display:none!important}
          .aes-page-material-quote-section1-field select{appearance:none;background-image:none!important;padding-right:44px!important}
          .aes-page-material-quote-section1-country{position:relative}
          .aes-page-material-quote-section1-country svg{position:absolute;right:16px;top:14px;width:20px;height:20px;pointer-events:none;transform:rotate(90deg);color:#897266}
          .aes-page-material-quote-section1-phone{order:3!important;display:block!important;position:relative!important;min-width:0!important}
          .aes-page-material-quote-section1-phone .phone-country-selector{position:absolute;left:1px;top:31px;z-index:2;width:74px;height:46px}
          .aes-page-material-quote-section1-phone .phone-country-selector button{height:46px;max-height:none;padding:0 10px;border:0;border-radius:0;background:transparent;box-shadow:none}
          .aes-page-material-quote-section1-phone .phone-country-selector button:focus-visible{outline:1px solid #897266;outline-offset:-1px;box-shadow:none}
          .aes-page-material-quote-section1-phone .phone-country-selector img{width:24px;height:16px;object-fit:contain}

          .aes-page-material-quote-section1-phone [class*="_dropdownContainer_"]{position:absolute!important;top:46px!important;bottom:auto!important;left:0!important;right:auto!important;width:var(--aes-page-material-quote-section1-phone-menu-width,100%)!important;max-width:calc(100vw - 32px)!important;transform:none!important;margin:0!important;z-index:20!important;border-radius:0!important;box-shadow:none!important}
          .aes-page-material-quote-section1-phone [role="listbox"]{box-sizing:border-box!important;width:100%!important;max-width:none!important;margin:0!important;padding:0!important;overflow-x:hidden!important;border:1px solid var(--aes-page-material-quote-section1-control-active)!important;border-radius:0!important;background:var(--aes-bg-primary)!important;box-shadow:none!important;text-align:left!important}
          .aes-page-material-quote-section1-phone [role="listbox"]::-webkit-scrollbar{width:6px}
          .aes-page-material-quote-section1-phone [role="listbox"]::-webkit-scrollbar-thumb{background:var(--aes-text-muted);border-radius:0}
          .aes-page-material-quote-section1-phone [role="listbox"]::-webkit-scrollbar-button{display:none;width:0;height:0}
          .aes-page-material-quote-section1-phone [class*="_optionListItem_"]{margin:0!important;border:0!important;outline:0!important;box-shadow:none!important;border-radius:0!important;background:transparent!important}
          .aes-page-material-quote-section1-phone [role="option"]{box-sizing:border-box!important;display:flex;align-items:center;min-height:48px;padding:12px 16px!important;margin:0!important;border:0!important;outline:0!important;box-shadow:none!important;border-radius:0!important;background:var(--aes-bg-primary)!important;color:var(--aes-text-secondary)!important;font:400 14px/1.6 var(--aes-font-body)!important;text-align:left!important;white-space:normal!important;overflow-wrap:anywhere}
          .aes-page-material-quote-section1-phone [role="option"]:is(:hover,:focus,:focus-visible,[aria-selected="true"]){background:var(--aes-bg-subtle)!important;outline:0!important}
          .aes-page-material-quote-section1-field input[type=tel]{padding-left:84px!important}
          @media(min-width:768px){.aes-page-material-quote-section1-phone .phone-country-selector{top:35px}}
          @media(min-width:1440px){.${prefix}-field label{font-size:16px!important;line-height:round(nearest,25.6px,1px)!important}.aes-page-material-quote-section1-phone .phone-country-selector{top:39px}.aes-page-material-quote-section1-cart{font-size:16px;line-height:24px}}
          [data-testid="btn-form-submit"]{order:8!important}
          .aes-page-material-quote-section1-status,[role="alert"]{order:9!important}
          .aes-page-material-quote-section1-cart-error{grid-column:1/-1;order:8;margin:0;color:#c62828;font:400 12px/1.6 var(--aes-font-body)}
          .${prefix}-field label,.${prefix}-field :is(input,textarea,select),.aes-page-material-quote-section1-phone [role="option"],.aes-page-material-quote-section1-cart{font-size:var(--aes-material-quote-body-size)!important;line-height:round(nearest,calc(var(--aes-material-quote-body-size) * 1.6),1px)!important}
          [data-testid="btn-form-submit"]{min-height:41px!important;height:41px!important;padding:8px!important;font-size:var(--aes-material-quote-button-size)!important;line-height:round(nearest,calc(var(--aes-material-quote-button-size) * 1.35),1px)!important;gap:12px!important}
          .${prefix}-arrow{width:8px;height:8px;flex:0 0 8px}
          .${prefix}-arrow svg{transform:rotate(-45deg) scale(calc(8 / 13.5))}
          .aes-page-material-quote-section1-cart input{position:relative;box-sizing:border-box;width:24px;height:24px;min-width:24px;border:0;background:transparent}
          .aes-page-material-quote-section1-cart input::before{content:'';position:absolute;inset:2px;box-sizing:border-box;border:1px solid var(--aes-text-primary);background:var(--aes-bg-primary);pointer-events:none}
          .aes-page-material-quote-section1-cart input::after{position:absolute;left:50%;top:50%;transform:translate(-50%,-50%);pointer-events:none}
          .aes-page-material-quote-section1-cart input:checked{border:0;background:transparent}
          .aes-page-material-quote-section1-cart input:checked::before{background:var(--aes-bg-inverse);border-color:var(--aes-bg-inverse)}
          .aes-page-material-quote-section1-phone .phone-country-selector{top:35px}
          @media(min-width:768px){.aes-page-material-quote-section1-phone .phone-country-selector{top:calc(13px + round(nearest,calc(var(--aes-material-quote-body-size) * 1.6),1px))}}
        `;
        root.append(style);
      }
      this.decorate();
      this.setLoading(false);
      if (this.form) {
        this.form.addEventListener('submit',event=>{
          if (this.prepared) { this.prepared=false; this.attempted=true; this.awaitingNative=true; queueMicrotask(()=>{this.preparing=false;this.syncBusy();}); return; }
          if (this.busy || this.preparing) { event.preventDefault(); event.stopImmediatePropagation(); return; }
          const visible=[...this.form.querySelectorAll('.aes-page-material-quote-section1-field input,.aes-page-material-quote-section1-field textarea')];
          if (visible.some(input=>!input.validity.valid)) { this.attempted=true; queueMicrotask(()=>this.syncBusy()); return; }
          event.preventDefault(); event.stopImmediatePropagation(); this.prepareSubmission();
        },{capture:true,signal:this.abort.signal});
        this.form.addEventListener('input',event=>{
          if (!this.busy && !this.preparing) this.attempted=false;
          if (event.target.matches('input,textarea,select')) event.target.setCustomValidity('');
        },{signal:this.abort.signal});
        this.pendingTimer=setInterval(()=>this.syncBusy(),250);
      }
      this.observer=new MutationObserver(()=>{
        this.observer.disconnect();
        if (this.form!==root.querySelector('form')) { this.attach(root); return; }
        this.decorate();
        this.syncBusy();
        this.observer.observe(root,{childList:true,subtree:true,characterData:true,attributes:true,attributeFilter:['disabled','aria-disabled','aria-invalid']});
      });
      this.observer.observe(root,{childList:true,subtree:true,characterData:true,attributes:true,attributeFilter:['disabled','aria-disabled','aria-invalid']});
    }
    positionPhoneMenu() {
      const phone=this.form?.querySelector('.aes-page-material-quote-section1-phone');
      if (!phone) return;
      phone.style.setProperty('--aes-page-material-quote-section1-phone-menu-width',Math.max(0,phone.getBoundingClientRect().width-2)+'px');
      const popup=phone.querySelector('[class*="_dropdownContainer_"]');
      if (!popup || this.phoneMenus?.has(popup)) return;
      (this.phoneMenus ||= new WeakSet()).add(popup);
      requestAnimationFrame(()=>{
        if (!popup.isConnected || this.abort.signal.aborted) return;
        const bottom=popup.getBoundingClientRect().bottom;
        const viewportBottom=window.visualViewport?window.visualViewport.offsetTop+window.visualViewport.height:window.innerHeight;
        if (bottom>viewportBottom-16) window.scrollBy({top:bottom-viewportBottom+16,behavior:'instant'});
      });
    }
    decorate() {
      const prefix='aes-page-material-quote-section1',form=this.form;
      if (!form) {
        const heading=this.root.querySelector('[data-testid="banner-success"] h2');
        if(this.newRequest)this.newRequest.hidden=!heading;
        if (heading && !heading.hasAttribute('tabindex')) { heading.tabIndex=-1; heading.focus({preventScroll:true}); }
        return;
      }
      form.dataset.aesPageMaterialQuoteSection1Form='';
      for (const id of ['first_name','last_name','email','phone_number','custom#country_region','custom#zip_postal_code','custom#message']) {
        const input=form.querySelector('[id="'+id+'"],[name="'+id+'"]');
        if (!input) continue;
        if (!input.id) input.id=id;
        const group=input.closest('[class*="_formFieldContainer_"]') || input.parentElement;
        group.classList.add(prefix+'-field');
        const label=group.querySelector('label');
        if (label && id==='custom#country_region' && label.textContent!=='Country/Region') label.textContent='Country/Region';
        if (label && id==='custom#zip_postal_code' && label.textContent!=='Zip/Postal Code') label.textContent='Zip/Postal Code';
        input.required=true;
        if (id==='email') { input.type='email'; input.autocomplete='email'; }
        
        group.style.setProperty('--aes-page-material-quote-section1-field-order',String(['first_name','last_name','email','phone_number','custom#country_region','custom#zip_postal_code','custom#message'].indexOf(id)));
        if (id==='phone_number') input.closest('[class*="_formPhoneInputContainer_"]')?.classList.add(prefix+'-phone');
        if (id==='first_name') input.autocomplete='given-name';
        if (id==='last_name') input.autocomplete='family-name';
        if (id==='custom#zip_postal_code') input.autocomplete='postal-code';
        if (id==='custom#country_region') this.decorateCountry(input,group);
        if (input.tagName==='TEXTAREA') input.maxLength=5000;
        const placeholder=this.copy.querySelector('[data-aes-page-material-quote-section1-placeholder="'+(id==='phone_number'?'phone':id)+'"]')?.textContent.trim() || label?.textContent.trim() || '';
        if (input.placeholder!==placeholder) input.placeholder=placeholder;
        const nativeError=group.nextElementSibling?.matches('output[role="alert"]') ? group.nextElementSibling : null;
        let errorCopy=group.querySelector('.'+prefix+'-field-error');
        const previousError=input.dataset.aesPageMaterialQuoteSection1Error;
        const described=new Set((input.getAttribute('aria-describedby') || '').split(/\s+/).filter(Boolean));
        if (previousError) described.delete(previousError);
        if (nativeError) {
          nativeError.classList.add(prefix+'-native-error');
          if (!nativeError.id) nativeError.id=id+'-aes-error';
          input.dataset.aesPageMaterialQuoteSection1Error=nativeError.id;
          described.add(nativeError.id);
          if (!errorCopy) { errorCopy=document.createElement('span'); errorCopy.className=prefix+'-field-error'; errorCopy.setAttribute('aria-hidden','true'); group.append(errorCopy); }
          if (errorCopy.textContent!==nativeError.textContent) errorCopy.textContent=nativeError.textContent;
        } else {
          errorCopy?.remove();
          delete input.dataset.aesPageMaterialQuoteSection1Error;
        }
        if (described.size) input.setAttribute('aria-describedby',Array.from(described).join(' ')); else input.removeAttribute('aria-describedby');
        if (id==='custom#country_region') this.decorateCountry(input,group);
      }
      this.positionPhoneMenu();
      this.decorateCart();
      const button=form.querySelector('[data-testid="btn-form-submit"]');
      if (button && !button.querySelector('[data-aes-page-material-quote-section1-arrow]')) button.append(this.copy.querySelector('[data-aes-page-material-quote-section1-arrow]').cloneNode(true));
      let status=form.querySelector('[data-aes-page-material-quote-section1-status]');
      if (!status) { status=document.createElement('p'); status.className=prefix+'-status'; status.dataset.aesPageMaterialQuoteSection1Status=''; status.setAttribute('role','status'); status.setAttribute('aria-live','polite'); status.hidden=true; form.append(status); }
      const nativeDisclaimer=form.parentElement.querySelector('[class*="_formDisclaimer_"]');
      if (nativeDisclaimer) nativeDisclaimer.hidden=true;
    }

    setNativeValue(input,value) {
      const prototype=input.tagName==='TEXTAREA' ? HTMLTextAreaElement.prototype : HTMLInputElement.prototype;
      Object.getOwnPropertyDescriptor(prototype,'value').set.call(input,value);
      input.dispatchEvent(new Event('input',{bubbles:true}));
      input.dispatchEvent(new Event('change',{bubbles:true}));
    }
    decorateCountry(input,group) {
      input.dataset.aesPageMaterialQuoteSection1NativeCountry='';
      input.tabIndex=-1;
      let wrapper=group.querySelector('.aes-page-material-quote-section1-country');
      if (!wrapper) {
        wrapper=this.copy.querySelector('.aes-page-material-quote-section1-country').cloneNode(true);
        const select=wrapper.querySelector('select');
        select.id=this.id+'-country';
        const label=group.querySelector('label'); if (label) label.htmlFor=select.id;
        select.addEventListener('change',()=>this.setNativeValue(input,select.value),{signal:this.abort.signal});
        group.append(wrapper);
      }
      const select=wrapper.querySelector('select');
      if (select.value!==input.value) select.value=input.value;
      select.setAttribute('aria-invalid',input.getAttribute('aria-invalid')||'false');
      const described=input.getAttribute('aria-describedby'); if (described) select.setAttribute('aria-describedby',described); else select.removeAttribute('aria-describedby');
    }
    decorateCart() {
      const form=this.form;
      if (!form) return;
      const snapshot=form.querySelector('[id="custom#material_quote_snapshot"],[name="custom#material_quote_snapshot"]');
      const group=snapshot?.closest('[class*="_formFieldContainer_"]');
      group?.classList.add('aes-page-material-quote-section1-snapshot');
      if (!form.querySelector('[data-aes-page-material-quote-section1-cart]')) {
        const label=this.copy.querySelector('[data-aes-page-material-quote-section1-cart]').cloneNode(true);
        label.querySelector('input').addEventListener('change',event=>this.querySelector('aes-material-selection')?.setAttachCart(event.target.checked),{signal:this.abort.signal});
        form.append(label);
      }
    }
    cartError(message) {
      let error=this.form?.querySelector('[data-aes-page-material-quote-section1-cart-error]');
      if (!message) { error?.remove(); return; }
      if (!error) { error=document.createElement('p'); error.dataset.aesPageMaterialQuoteSection1CartError=''; error.className='aes-page-material-quote-section1-cart-error'; error.setAttribute('role','alert'); this.form.append(error); }
      error.textContent=message;
    }
    async prepareSubmission() {
      const form=this.form,field=form.querySelector('[id="custom#material_quote_snapshot"],[name="custom#material_quote_snapshot"]');
      if (!field) { this.cartError('This form is not ready. Please reload the page and try again.'); return; }
      this.cartError('');
      this.preparing=true; const controller=new AbortController(); this.prepareAbort=controller;
      const button=form.querySelector('[data-testid="btn-form-submit"]');
      button?.style.setProperty('--aes-page-material-quote-section1-submit-width',button.getBoundingClientRect().width+'px');
      this.syncBusy();
      const timeout=setTimeout(()=>controller.abort(),60000);
      try {
        const attach=form.querySelector('[data-aes-page-material-quote-section1-cart] input').checked;
        await customElements.whenDefined('aes-material-selection');
        const selection=this.querySelector('aes-material-selection');
        selection.setBusy(true);
        const snapshot=await window.aesMaterialSelection.snapshot(this.dataset.rootUrl,this.dataset.cartUrl.replace(/\.js$/,''),attach,controller.signal);
        if (!this.isConnected || this.form!==form) return;
        const serialized=JSON.stringify(snapshot);
        if (serialized.length>Math.min(field.maxLength>0?field.maxLength:60000,60000) || new TextEncoder().encode(serialized).length>45000) throw new Error('Your selection is too large to send. Reduce the number of materials or extra cart products and try again.');
        this.setNativeValue(field,serialized);
        await new Promise(resolve=>requestAnimationFrame(()=>requestAnimationFrame(resolve)));
        if (!this.isConnected || this.form!==form) return;
        this.prepared=true;
        form.requestSubmit();
      } catch(error) {
        if (!this.isConnected || this.form!==form) return;
        this.prepared=false; this.preparing=false; this.attempted=false; this.release();
        this.cartError(error.name==='AbortError'?'Your selection could not be verified in time. Please try again.':error.message);
      } finally { clearTimeout(timeout); if (this.prepareAbort===controller) this.prepareAbort=null; }
    }
    syncBusy() {
      const form=this.form;
      if (!form || !this.root.contains(form)) return;
      const button=form.querySelector('[data-testid="btn-form-submit"]');
      const nativeBusy=!!(button?.disabled || button?.getAttribute('aria-disabled')==='true');
      if (this.awaitingNative && (nativeBusy || form.querySelector('[aria-invalid="true"],output[role="alert"]'))) this.awaitingNative=false;
      const busy=this.preparing || this.awaitingNative || (this.attempted && nativeBusy);
      if (this.busy && !busy) this.attempted=false;
      this.busy=busy;
      this.querySelector('aes-material-selection')?.setBusy(busy);
      form.toggleAttribute('data-aes-page-material-quote-section1-busy',busy);
      form.setAttribute('aria-busy',String(busy));
      button?.toggleAttribute('data-aes-page-material-quote-section1-busy',busy);
      if (busy) {
        this.pendingStarted ||= Date.now();
        for (const control of form.querySelectorAll('input,textarea,select,button')) {
          if (!this.locked.has(control)) this.locked.set(control,control.inert);
          control.inert=true;
        }
      } else this.release();
      const status=form.querySelector('[data-aes-page-material-quote-section1-status]');
      if (status) {
        status.hidden=!busy || Date.now()-this.pendingStarted<1500;
        const message=Date.now()-this.pendingStarted>90000 ? this.copy.querySelector('[data-aes-page-material-quote-section1-slow-message]').textContent.trim() || 'Your submission is taking longer than expected. Check any verification or error message before trying again.' : this.copy.querySelector('[data-aes-page-material-quote-section1-pending]').textContent.trim();
        if (busy && status.textContent!==message) status.textContent=message;
      }
    }
    release() {
      this.querySelector('aes-material-selection')?.setBusy(false);
      this.awaitingNative=false;
      for (const [control,inert] of this.locked || []) control.inert=inert;
      this.locked?.clear();
      this.busy=false;
      this.pendingStarted=0;
      this.form?.removeAttribute('data-aes-page-material-quote-section1-busy');
      this.form?.setAttribute('aria-busy','false');
      this.form?.querySelector('[data-testid="btn-form-submit"]')?.removeAttribute('data-aes-page-material-quote-section1-busy');
      this.form?.querySelector('[data-testid="btn-form-submit"]')?.style.removeProperty('--aes-page-material-quote-section1-submit-width');
      const status=this.form?.querySelector('[data-aes-page-material-quote-section1-status]');
      if (status) status.hidden=true;
    }
  });
}


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["aes-page-search-section1"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('aes-page-search-section1')) {
  customElements.define('aes-page-search-section1', class AesPageSearchSection1 extends HTMLElement {
    connectedCallback() {
      this.events?.abort();
      this.cleanupSelects();
      this.events = new AbortController();
      const signal = this.events.signal;
      this.form = this.querySelector('[data-aes-search-page-form]');
      this.input = this.querySelector('[data-aes-search-page-query]');
      this.type = this.querySelector('[data-aes-search-page-type]');
      this.clear = this.querySelector('[data-aes-search-page-clear]');
      this.results = this.querySelector('[data-aes-search-page-results]');
      this.loading = this.querySelector('[data-aes-search-page-loading]');
      if (!this.form || !this.input || !this.type) return;
      this.setupSelects(signal);
      this.setAttribute('data-enhanced', '');
      const sync = () => {
        if (this.clear) this.clear.hidden = this.input.value.length === 0;
        this.syncSelects();
      };
      sync();
      this.input.addEventListener('input', sync, { signal });
      this.clear?.addEventListener('click', () => {
        this.input.value = '';
        this.input.dispatchEvent(new Event('input', { bubbles: true }));
        this.input.focus();
      }, { signal });
      this.form.addEventListener('submit', event => {
        this.input.value = this.input.value.trim();
        sync();
        if (this.busy) { event.preventDefault(); return; }
        this.showLoading();
      }, { signal });
      this.type.addEventListener('change', () => {
        const sort = this.querySelector('[data-aes-search-page-sort]');
        if (sort) sort.disabled = true;
        this.form.requestSubmit();
      }, { signal });
      this.querySelector('[data-aes-search-page-sort]')?.addEventListener('change', () => this.form.requestSubmit(), { signal });
      this.querySelectorAll('.aes-page-search-section1-pagination a').forEach(link => link.addEventListener('click', event => {
        if (event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
        if (this.busy) { event.preventDefault(); return; }
        this.showLoading();
      }, { signal }));
      window.addEventListener('pageshow', event => {
        this.resetLoading();
        sync();
        if (event.persisted || performance.getEntriesByType('navigation')[0]?.type === 'back_forward') {
          cancelAnimationFrame(this.restoreFrame);
          this.restoreFrame = requestAnimationFrame(() => {
            this.restoreFrame = 0;
            this.type.value = this.type.querySelector('option[selected]')?.value || 'product';
            this.input.value = this.input.defaultValue;
            const sort = this.querySelector('[data-aes-search-page-sort]');
            if (sort) sort.value = sort.querySelector('option[selected]')?.value || sort.options[0]?.value;
            this.resetLoading();
            sync();
          });
        }
      }, { signal });
      document.addEventListener('visibilitychange', () => { if (!document.hidden) this.resetLoading(); }, { signal });
      if (this.dataset.defaultUrl && !window.Shopify?.designMode) {
        const destination = new URL(this.dataset.defaultUrl, location.href);
        const current = new URL(location.href);
        if (destination.origin === current.origin && destination.pathname === current.pathname) {
          current.searchParams.set('type', 'product');
          current.searchParams.delete('page');
          if (!current.searchParams.has('options[prefix]')) current.searchParams.set('options[prefix]', 'last');
          this.showLoading();
          location.replace(current.href);
        }
      }
    }
    setupSelects(signal) {
      this.dropdowns = [];
      this.querySelectorAll('.aes-page-search-section1-select').forEach(wrapper => {
        const select = wrapper.querySelector('select');
        const arrow = wrapper.querySelector(':scope > span');
        const label = wrapper.closest('.aes-page-search-section1-select-field')?.querySelector('label');
        if (!select || !arrow || !label) return;
        const trigger = document.createElement('button');
        trigger.type = 'button';
        trigger.id = select.id + '-trigger';
        trigger.className = 'aes-page-search-section1-select-trigger';
        trigger.setAttribute('role', 'combobox');
        trigger.setAttribute('aria-expanded', 'false');
        trigger.setAttribute('aria-haspopup', 'listbox');
        label.id ||= select.id + '-label';
        trigger.setAttribute('aria-labelledby', label.id);
        const value = document.createElement('span');
        value.className = 'aes-page-search-section1-select-label';
        const chevron = arrow.cloneNode(true);
        chevron.className = 'aes-page-search-section1-select-chevron';
        trigger.append(value, chevron);
        const list = document.createElement('ul');
        list.id = select.id + '-options';
        list.className = 'aes-page-search-section1-select-options';
        list.setAttribute('role', 'listbox');
        list.setAttribute('aria-labelledby', label.id);
        list.hidden = true;
        trigger.setAttribute('aria-controls', list.id);
        const options = [...select.options].filter(option => !option.disabled).map((option, index) => {
          const item = document.createElement('li');
          item.id = list.id + '-' + index;
          item.setAttribute('role', 'option');
          item.dataset.value = option.value;
          item.textContent = option.textContent;
          list.append(item);
          return item;
        });
        const state = { wrapper, select, arrow, label, trigger, value, list, options, active: 0, typed: '', typedAt: 0 };
        this.dropdowns.push(state);
        wrapper.append(trigger, list);
        label.htmlFor = trigger.id;
        select.hidden = true;
        arrow.hidden = true;
        select.addEventListener('change', () => this.syncSelects(), { signal });
        trigger.addEventListener('click', () => {
          if (list.hidden) this.openSelect(state);
          else this.closeSelect(state);
        }, { signal });
        trigger.addEventListener('keydown', event => this.selectKeydown(event, state), { signal });
        list.addEventListener('mousedown', event => event.preventDefault(), { signal });
        list.addEventListener('click', event => {
          const item = event.target.closest('[role="option"]');
          if (!item || !list.contains(item)) return;
          state.active = options.indexOf(item);
          this.commitSelect(state);
          trigger.focus();
        }, { signal });
      });
      document.addEventListener('pointerdown', event => {
        this.dropdowns.forEach(state => { if (!state.wrapper.contains(event.target)) this.closeSelect(state); });
      }, { signal });
      document.addEventListener('scroll', event => {
        this.dropdowns.forEach(state => { if (event.target !== state.list) this.closeSelect(state); });
      }, { capture: true, signal });
      window.addEventListener('resize', () => this.dropdowns.forEach(state => this.closeSelect(state)), { signal });
      this.syncSelects();
    }
    syncSelects() {
      this.dropdowns?.forEach(state => {
        state.value.textContent = state.select.selectedOptions[0]?.textContent || '';
        state.trigger.disabled = !!this.busy || state.select.disabled;
        if (state.list.hidden) state.options.forEach(item => item.setAttribute('aria-selected', String(item.dataset.value === state.select.value)));
      });
    }
    openSelect(state) {
      if (this.busy || state.select.disabled) return;
      this.dropdowns.forEach(other => this.closeSelect(other));
      const rect = state.trigger.getBoundingClientRect();
      const below = window.innerHeight - rect.bottom - 24;
      const above = rect.top - 24;
      const up = below < Math.min(240, state.options.length * 48 + 2) && above > below;
      state.wrapper.toggleAttribute('data-menu-up', up);
      state.list.style.maxHeight = Math.max(48, Math.min(240, up ? above : below)) + 'px';
      state.list.hidden = false;
      state.trigger.setAttribute('aria-expanded', 'true');
      state.typed = '';
      this.activateSelect(state, Math.max(0, state.options.findIndex(item => item.dataset.value === state.select.value)));
    }
    closeSelect(state) {
      state.list.hidden = true;
      state.trigger.setAttribute('aria-expanded', 'false');
      state.trigger.removeAttribute('aria-activedescendant');
      state.options.forEach(item => item.removeAttribute('data-active'));
      this.syncSelects();
    }
    activateSelect(state, index) {
      state.active = Math.max(0, Math.min(state.options.length - 1, index));
      state.options.forEach((item, i) => {
        item.toggleAttribute('data-active', i === state.active);
        item.setAttribute('aria-selected', String(i === state.active));
      });
      const item = state.options[state.active];
      if (!item) return;
      state.trigger.setAttribute('aria-activedescendant', item.id);
      if (item.offsetTop < state.list.scrollTop) state.list.scrollTop = item.offsetTop;
      else if (item.offsetTop + item.offsetHeight > state.list.scrollTop + state.list.clientHeight) state.list.scrollTop = item.offsetTop + item.offsetHeight - state.list.clientHeight;
    }
    commitSelect(state) {
      const value = state.options[state.active]?.dataset.value;
      const changed = value !== undefined && state.select.value !== value;
      if (changed) state.select.value = value;
      this.closeSelect(state);
      if (changed) state.select.dispatchEvent(new Event('change', { bubbles: true }));
    }
    selectKeydown(event, state) {
      if (event.ctrlKey || event.metaKey) return;
      const open = !state.list.hidden;
      if (event.key === 'Tab') { if (open) this.commitSelect(state); return; }
      if (event.key === 'Escape') {
        if (open) { event.preventDefault(); event.stopPropagation(); this.closeSelect(state); }
        return;
      }
      if (event.key === 'Enter' || event.key === ' ' || (event.altKey && event.key === 'ArrowUp')) {
        event.preventDefault();
        if (open) this.commitSelect(state);
        else this.openSelect(state);
        return;
      }
      const keys = ['ArrowDown', 'ArrowUp', 'Home', 'End', 'PageDown', 'PageUp'];
      if (keys.includes(event.key)) {
        event.preventDefault();
        if (!open) this.openSelect(state);
        let next = state.active;
        if (event.key === 'Home' || (event.key === 'ArrowUp' && !open)) next = 0;
        else if (event.key === 'End') next = state.options.length - 1;
        else if (open && event.key === 'ArrowDown') next++;
        else if (open && event.key === 'ArrowUp') next--;
        else if (event.key === 'PageDown') next += 10;
        else if (event.key === 'PageUp') next -= 10;
        this.activateSelect(state, next);
        return;
      }
      if (!event.altKey && event.key.length === 1) {
        event.preventDefault();
        if (!open) this.openSelect(state);
        const now = performance.now();
        state.typed = now - state.typedAt < 700 ? state.typed + event.key.toLowerCase() : event.key.toLowerCase();
        state.typedAt = now;
        const query = [...state.typed].every(c => c === state.typed[0]) ? state.typed[0] : state.typed;
        const candidates = [...state.options.slice(state.active + 1), ...state.options.slice(0, state.active + 1)];
        const match = candidates.find(item => item.textContent.trim().toLowerCase().startsWith(query));
        if (match) this.activateSelect(state, state.options.indexOf(match));
      }
    }
    cleanupSelects() {
      this.dropdowns?.forEach(state => {
        state.trigger.remove();
        state.list.remove();
        state.select.hidden = false;
        state.arrow.hidden = false;
        state.label.htmlFor = state.select.id;
        state.wrapper.removeAttribute('data-menu-up');
      });
      this.dropdowns = [];
    }
    showLoading() {
      this.busy = true;
      this.dropdowns?.forEach(state => this.closeSelect(state));
      this.syncSelects();
      this.results?.setAttribute('aria-busy', 'true');
      if (this.loading) this.loading.hidden = false;
      const logo = this.loading?.querySelector('[data-aes-global-loading]');
      if (logo) logo.hidden = false;
      clearTimeout(this.release);
      this.release = setTimeout(() => this.resetLoading(), 15000);
    }
    resetLoading() {
      this.busy = false;
      clearTimeout(this.release);
      this.results?.removeAttribute('aria-busy');
      if (this.loading) this.loading.hidden = true;
      const sort = this.querySelector('[data-aes-search-page-sort]');
      if (sort) sort.disabled = this.type.value !== 'product';
      this.syncSelects();
    }
    disconnectedCallback() { this.events?.abort(); clearTimeout(this.release); cancelAnimationFrame(this.restoreFrame); this.cleanupSelects(); }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["aes-page-swatches-gallery-section2"] && !Shopify.designMode) return;
  try {
    
if(!customElements.get('aes-page-swatches-gallery-section2'))customElements.define('aes-page-swatches-gallery-section2',class extends HTMLElement{
connectedCallback(){this.abort=new AbortController();this.catalog=this.querySelector('[data-aes-catalog]');this.sync=()=>{if(!window.aesMaterialSelection)return;const selected=new Set(window.aesMaterialSelection.state.materials.map(x=>x.variantId));for(const button of this.querySelectorAll('[data-aes-material-add]')){button.disabled=!!this.loading;button.setAttribute('aria-pressed',String(selected.has(button.dataset.aesMaterialAdd)));button.querySelector('[data-aes-add-text]').textContent=selected.has(button.dataset.aesMaterialAdd)?'Edit selection':'Add to list';}};customElements.whenDefined('aes-material-selection').then(()=>{if(this.isConnected)this.sync();});document.addEventListener('aes:materials:change',this.sync,{signal:this.abort.signal});document.addEventListener('click',event=>{const menu=this.catalog.querySelector('[data-aes-mobile-filter]');if(menu?.open&&!menu.contains(event.target))menu.open=false;},{signal:this.abort.signal});this.addEventListener('keydown',event=>this.filterKey(event),{signal:this.abort.signal});this.addEventListener('submit',event=>{const form=event.target.closest('[data-aes-type-filter]');if(!form)return;event.preventDefault();if(this.loading)return;const button=event.submitter,menu=form.querySelector('[data-aes-mobile-filter]'),current=new URL(location.href);if(menu)menu.open=false;if(!button||button.disabled)return;if(button.getAttribute('aria-pressed')==='true'&&(button.dataset.aesType||!current.searchParams.has('filter.p.product_type'))){if(window.innerWidth<768)menu?.querySelector('summary').focus({preventScroll:true});return;}const url=new URL(form.action,location.origin);for(const [name,value]of current.searchParams){if(name!=='filter.p.product_type'&&name!==form.dataset.aesPageParam&&name!=='page'&&name!=='section_id')url.searchParams.append(name,value);}if(button.dataset.aesType)url.searchParams.set('filter.p.product_type',button.dataset.aesType);this.load(url,true);},{signal:this.abort.signal});this.addEventListener('click',event=>{const add=event.target.closest('[data-aes-material-add]');if(add){if(this.loading||add.disabled)return;const item=JSON.parse(add.closest('article').querySelector('template[data-aes-gallery-record]').content.textContent);this.querySelector('aes-material-selection').choose(item,add);return;}const link=event.target.closest('.aes-page-swatches-gallery-section2-pagination a');if(link&&this.loading){event.preventDefault();return;}if(!link||event.ctrlKey||event.metaKey||event.shiftKey||event.altKey||event.button!==0)return;event.preventDefault();this.load(new URL(link.href,location.origin),true);},{signal:this.abort.signal});this.querySelector('[data-aes-retry]').addEventListener('click',()=>this.load(this.failedUrl,true),{signal:this.abort.signal});window.addEventListener('popstate',()=>this.load(new URL(location.href),false),{signal:this.abort.signal});}
filterKey(event){
const menu=event.target.closest('[data-aes-mobile-filter]');if(!menu)return;if(this.loading){event.preventDefault();return;}
const summary=menu.querySelector('summary'),options=Array.from(menu.querySelectorAll('button:not(:disabled)'));
if(event.key==='Escape'&&menu.open){event.preventDefault();event.stopPropagation();menu.open=false;summary.focus({preventScroll:true});return;}
if(!['ArrowDown','ArrowUp','Home','End'].includes(event.key)||!options.length)return;
event.preventDefault();const current=options.indexOf(event.target);menu.open=true;
const index=event.key==='Home'?0:event.key==='End'?options.length-1:current<0?Math.max(0,options.findIndex(option=>option.getAttribute('aria-pressed')==='true')):(current+(event.key==='ArrowDown'?1:-1)+options.length)%options.length;
options[index].focus({preventScroll:true});
}
setLoading(busy){
this.loading=busy;
if(busy){
this.catalog.setAttribute('aria-busy','true');
if(this.loadingControls)return;
this.loadingControls=[];
const lock=(node,name,value='')=>{if(!node)return;this.loadingControls.push({node,name,value:node.getAttribute(name)});node.setAttribute(name,value);};
const grid=this.catalog.querySelector('[data-aes-grid]'),form=this.catalog.querySelector('[data-aes-type-filter]'),menu=form?.querySelector('[data-aes-mobile-filter]'),pagination=this.catalog.querySelector('.aes-page-swatches-gallery-section2-pagination');
lock(grid,'inert');lock(grid,'aria-busy','true');lock(form,'aria-busy','true');
for(const button of this.catalog.querySelectorAll('[data-aes-type-filter] button,[data-aes-material-add]'))lock(button,'disabled');
if(menu){menu.open=false;lock(menu,'inert');lock(menu.querySelector('summary'),'aria-disabled','true');lock(menu.querySelector('summary'),'tabindex','-1');}
lock(pagination,'inert');lock(pagination,'aria-busy','true');
for(const link of pagination?.querySelectorAll('a')||[]){lock(link,'aria-disabled','true');lock(link,'tabindex','-1');}
}else{
for(const {node,name,value}of this.loadingControls||[]){if(!this.catalog.contains(node))continue;if(value===null)node.removeAttribute(name);else node.setAttribute(name,value);}
this.loadingControls=null;this.catalog.removeAttribute('aria-busy');
}
}
disconnectedCallback(){this.abort?.abort();this.request?.abort();this.request=null;this.setLoading(false);this.catalog.querySelectorAll('[data-aes-grid] > [data-aes-global-loading]').forEach(node=>node.remove());}
async load(url,push){
if(!url||url.origin!==location.origin||!this.catalog.querySelector('[data-aes-grid]'))return;
this.failedUrl=url;this.request?.abort();this.request=new AbortController();const request=this.request;
const endpoint=new URL(url);endpoint.searchParams.set('section_id',this.dataset.sectionId);
this.catalog.querySelectorAll('[data-aes-grid] > [data-aes-global-loading]').forEach(node=>node.remove());
this.setLoading(true);const grid=this.catalog.querySelector('[data-aes-grid]'),loading=this.querySelector('template[data-aes-gallery-loading]').content.cloneNode(true),overlay=loading.querySelector('[data-aes-global-loading]'),box=grid.getBoundingClientRect(),visibleTop=Math.max(0,box.top),visibleBottom=Math.max(visibleTop,Math.min(window.innerHeight,box.bottom));overlay.hidden=false;overlay.style.setProperty('--aes-gallery-loading-y',Math.max(0,Math.min(box.height,(visibleTop+visibleBottom)/2-box.top))+'px');grid.append(loading);
this.querySelector('[data-aes-catalog-status]').textContent=this.dataset.loadingLabel;
this.querySelector('[data-aes-error]').hidden=true;
try{
const response=await fetch(endpoint,{credentials:'same-origin',signal:AbortSignal.any([request.signal,AbortSignal.timeout(15000)])});
if(!response.ok)throw Error();
const doc=new DOMParser().parseFromString(await response.text(),'text/html'),next=doc.querySelector('[data-aes-catalog]');
if(!next?.querySelector('[data-aes-grid]'))throw Error();
if(this.request!==request||request.signal.aborted)return;
this.catalog.replaceChildren(...Array.from(next.childNodes));if(push)history.pushState({},'',url);this.setLoading(false);this.sync();this.catalog.querySelector(window.innerWidth<768?'[data-aes-mobile-filter] summary':'[data-aes-desktop-filter][aria-pressed="true"]')?.focus({preventScroll:true});
this.querySelector('[data-aes-catalog-status]').textContent=(this.catalog.querySelector('.aes-page-swatches-gallery-section2-count')?.textContent||'Materials')+' loaded.';
}catch(error){if(error.name!=='AbortError'&&this.request===request){this.querySelector('[data-aes-catalog-status]').textContent='';this.querySelector('[data-aes-error-text]').textContent='Materials could not be loaded. Your selection is saved. Please retry.';this.querySelector('[data-aes-error]').hidden=false;}}
finally{if(this.request===request){this.setLoading(false);this.catalog.querySelectorAll('[data-aes-grid] > [data-aes-global-loading]').forEach(node=>node.remove());}}
}
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["aes-page-trade-program-section3"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('aes-page-trade-program-section3')) {
  customElements.define('aes-page-trade-program-section3', class AesPageTradeProgramSection3 extends HTMLElement {
    initLoading() {
      this.loadingRegion=this.querySelector('[data-aes-form-mount]');
      this.loadingLogo=this.loadingRegion?.querySelector('[data-aes-global-loading]');
      this.loadingStatus=this.loadingRegion?.querySelector('[data-aes-form-load-status]');
      this.loadingRetry=this.loadingRegion?.querySelector('[data-aes-form-load-retry]');
      this.loadingLocks=new Map();
      this.loadingAbort?.abort(); this.loadingAbort=new AbortController();
      this.loadingRetry?.addEventListener('click',()=>{
        clearInterval(this.locateTimer); this.attempts=0; this.setLoading(true); this.locate();
        if (!this.root) this.locateTimer=setInterval(this.locate,250);
      },{signal:this.loadingAbort.signal});
      this.setLoading(true);
    }
    setLoading(loading,failed=false) {
      if (!this.loadingLogo) return;
      const region=this.loadingRegion;
      if (loading) {
        if (region.contains(document.activeElement)) { this.loadingStatus.tabIndex=-1; this.loadingStatus.focus({preventScroll:true}); }
        region.querySelectorAll('.shopify-block,shopify-forms-embed').forEach(node=>{
          if (!this.loadingLocks.has(node)) this.loadingLocks.set(node,node.inert);
          node.inert=true;
        });
      } else { this.loadingLocks.forEach((inert,node)=>{node.inert=inert}); this.loadingLocks.clear(); }
      region.toggleAttribute('data-aes-form-loading',loading);
      region.setAttribute('aria-busy',String(loading));
      this.loadingLogo.hidden=!loading;
      this.loadingStatus.hidden=!loading&&!failed;
      this.loadingStatus.setAttribute('role',failed?'alert':'status');
      this.loadingStatus.textContent=failed?'The form could not be loaded. Please retry or refresh the page.':'Loading form. Please wait.';
      this.loadingRetry.hidden=!failed;
    }
    connectedCallback() {
      if (this.aesConnected) return;
      this.aesConnected = true;
      this.uploaderReady=import(this.dataset.uploadClient).then(module=>{
        if (!this.isConnected) return;
        this.uploadCopy=module.DEFAULT_UPLOAD_COPY;
        this.fileCardsModule=module.AesInquiryFileCards;
        if (this.root) this.fileCards=new module.AesInquiryFileCards(this.root);
        if (this.dataset.uploadEndpoint) this.uploader=new module.AesInquiryUpload({endpoint:this.dataset.uploadEndpoint,page:'trade-program',siteKey:this.dataset.uploadSiteKey,copy:this.uploadCopy});
        this.refreshUploads?.();
      }).catch(()=>{this.uploadSetupError='The upload service could not be loaded. Refresh the page and try again.';this.refreshUploads?.();});
      this.abort = new AbortController();
      this.anchorAbort = new AbortController();
      this.applicationScrollPending = location.hash === '#trade-application';
      document.addEventListener('click',event=>{
        if (event.defaultPrevented || event.button!==0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
        const link=event.target.closest('a[href]');
        if (!link || (link.target && link.target!=='_self') || link.hasAttribute('download')) return;
        const destination=new URL(link.href,location.href);
        if (destination.origin!==location.origin || destination.pathname!==location.pathname || destination.search!==location.search || destination.hash!=='#trade-application') return;
        event.preventDefault();
        if (location.hash!==destination.hash) history.pushState(null,'',destination.hash);
        this.applicationScrollPending=true;
        this.scrollToApplication();
      },{signal:this.anchorAbort.signal});
      window.addEventListener('hashchange',()=>{
        if (location.hash!=='#trade-application') return;
        this.applicationScrollPending=true;
        this.scrollToApplication();
      },{signal:this.anchorAbort.signal});
      this.attempts = 0;
      this.initLoading();
      this.locate = () => {
        const root = this.querySelector('shopify-forms-embed')?.shadowRoot;
        if (root && (root.querySelector('[data-testid="banner-success"]') || (root.querySelector('[data-testid="btn-form-submit"]') && root.querySelectorAll('#first_name,#last_name,#email,#company_name').length===4))) { clearInterval(this.locateTimer); this.attach(root); }
        else if (++this.attempts >= 120) { clearInterval(this.locateTimer); this.setLoading(false,true); }
      };
      this.locate();
      if (!this.root) this.locateTimer = setInterval(this.locate, 250);
    }
    disconnectedCallback() {
      this.prepareAbort?.abort(); this.preparingUploads=false; this.fileCards?.dispose();
      this.setLoading(false); this.loadingAbort?.abort();
      clearInterval(this.locateTimer); clearInterval(this.pendingTimer);
      this.submissionCleanup?.();
      this.observer?.disconnect(); this.abort?.abort(); this.anchorAbort?.abort(); this.aesConnected = false;
      this.root = null;
    }
    scrollToApplication() {
      const anchor=this.querySelector('#trade-application');
      const heading=this.root?.querySelector('h3[data-aes-order="0"]');
      const target=heading || anchor;
      if (!target) return;
      const headerHeight=document.querySelector('.aes-header-section1-host')?.getBoundingClientRect().height || 0;
      anchor?.style.setProperty('--aes-trade-anchor-header',headerHeight+'px');
      if (heading) {
        heading.tabIndex=-1;
        heading.focus({preventScroll:true});
        this.applicationScrollPending=false;
      }
      window.scrollTo({top:Math.max(0,window.scrollY+target.getBoundingClientRect().top-headerHeight-16),behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'auto':'smooth'});
    }
    attach(root) {
      this.prepareAbort?.abort(); this.preparingUploads=false; this.preparedUploads=false;
      this.fileCards?.dispose();
      if (this.fileCardsModule) this.fileCards=new this.fileCardsModule(root);
      this.setLoading(false);
      this.submissionCleanup?.();
      this.root = root;
      const prefix = 'aes-page-trade-program-section3';
      const form = root.querySelector('form');
      if (!form) {
        this.renderSuccess(root);
        this.observer=new MutationObserver(()=>{ this.observer.disconnect(); this.attach(root); });
        this.observer.observe(root,{childList:true,subtree:true});
        return;
      }
      this.activeForm=form;
      this.installSubmissionState(form);
      const intro=this.querySelector('.'+prefix+'-intro');
      if (intro) intro.hidden=false;
      const alreadyAdapted = form.dataset.aesTradeAdapted === 'true';
      form.dataset.aesTradeAdapted = 'true';
      const fragment = this.querySelector('template').content.cloneNode(true);
      const selectChevron = fragment.querySelector('[data-aes-select-chevron]');
      const uploadCopy = fragment.querySelector('[data-aes-upload-copy]');
      uploadCopy.remove();
      const uploadRemove = fragment.querySelector('[data-aes-upload-remove]');
      uploadRemove.remove();
      selectChevron.remove();
      const addressLabels = fragment.querySelector('[data-aes-address-labels]');
      addressLabels.remove();
      const policyLinks = fragment.querySelector('[data-aes-policy-links]');
      policyLinks.remove();
      const arrow = fragment.querySelector('[data-aes-arrow]');
      arrow.remove();
      if (!alreadyAdapted) form.append(fragment);
      const style = document.createElement('style');
      style.textContent = `
@layer aes-focus-policy {
  :is(:focus, :focus-visible, .focused) { outline: none !important; box-shadow: none !important; }
  :focus-within { outline: none !important; }
}

        :host { --inline-container-max-width:100%!important; --container-max-w:100%!important; --forms-body-font:normal 400 14px var(--aes-font-body)!important; --container-text-alignment:left!important; --forms-accent-color:var(--aes-bg-brand)!important; --form-field-border-radius:0px!important; --button-border-radius:0px!important; }
        [data-form-root],[data-testid="app-router"],#form-container-ref,section[role="dialog"] { width:100%!important; max-width:none!important; padding:0!important; margin:0!important; }
        /* Native validation can focus the whole form before an invalid field. */
        :host(:focus),:host(:focus-visible),section[class*="_formContainer_"][tabindex="-1"]:focus,form[data-aes-trade-adapted]:focus { outline:none!important; box-shadow:none!important; }
        [class*="_gridItemContent_"] { padding:0!important; min-width:0; }
        [data-current-step="form"] [class*="_formHeader_"] { display:${this.querySelector('.'+prefix+'-intro') ? 'none' : 'block'}!important; }
        form[data-aes-trade-adapted] { display:grid!important; grid-template-columns:minmax(0,1fr)!important; gap:24px!important; align-items:start!important; text-align:left!important; padding:0!important; }
        .${prefix}-flatten,form[data-aes-trade-adapted]>div:has(>shop-lead-capture) { display:contents!important; }
        .${prefix}-field { min-width:0; position:relative!important; align-self:start; }
        .${prefix}-field:has(>input:not([type=checkbox]):not([type=file])),.${prefix}-field:has(>textarea) { display:flex; flex-direction:column!important; gap:12px; }
        .${prefix}-field:has(>textarea)::before { content:none!important; display:none!important; }
        .${prefix}-field>label,.${prefix}-field>p,.${prefix}-address-label { display:block!important; position:static!important; transform:none!important; font:400 14px/22px var(--aes-font-body)!important; text-transform:uppercase!important; color:var(--aes-text-primary)!important; opacity:1!important; padding:0!important; margin:0!important; pointer-events:auto!important; }
        .${prefix}-field>input:not([type=checkbox]):not([type=file]),.${prefix}-field>textarea,.${prefix}-field>button { width:100%!important; box-sizing:border-box!important; min-height:48px; height:48px; padding:0 16px!important; border:1px solid var(--aes-border-default)!important; border-radius:2px!important; box-shadow:none!important; color:var(--aes-text-primary)!important; background:var(--aes-bg-primary)!important; font:400 14px/22px var(--aes-font-body)!important; }
        .${prefix}-field>textarea { min-height:48px; padding-block:12px!important; resize:none; }
        .${prefix}-field>button { margin-top:12px!important; text-align:left; }
        .${prefix}-select { position:relative!important; }
        .${prefix}-field>button.${prefix}-select,.phone-country-selector button.${prefix}-select { padding-right:48px!important; }
        .${prefix}-select>svg,.${prefix}-select>[class*="_arrowDownIcon_"] { display:none!important; }
        .${prefix}-select-chevron { position:absolute; inset-inline-end:12px; top:50%; display:flex; width:24px; height:24px; margin-top:-12px; color:var(--aes-bg-brand); transform:rotate(90deg); pointer-events:none; transition:transform var(--aes-duration),color var(--aes-duration); }
        .${prefix}-select-chevron svg { flex:none; }
        .${prefix}-select-chevron [stroke] { stroke:currentColor; }
        .${prefix}-select:is(:hover,:focus-visible,[aria-expanded="true"]) .${prefix}-select-chevron { color:var(--aes-page-trade-program-section3-control-active); }
        .${prefix}-select:disabled .${prefix}-select-chevron { color:var(--aes-text-muted); }
        .${prefix}-field>input[role="combobox"] { padding-right:48px!important; }
        .${prefix}-field>button.${prefix}-city-toggle { position:absolute!important; right:0; width:48px!important; min-height:48px; height:48px; margin:0!important; padding:0!important; border:0!important; background:transparent!important; }
        .${prefix}-city-menu { position:absolute; left:0; right:0; z-index:40; border:1px solid var(--aes-page-trade-program-section3-control-active); background:var(--aes-bg-primary); text-transform:none; }
        .${prefix}-city-menu[hidden] { display:none!important; }
        .${prefix}-city-options { max-height:240px; overflow-y:auto; margin:0; padding:0; list-style:none; }
        .${prefix}-city-option { padding:12px 16px; cursor:pointer; color:var(--aes-text-primary); font:400 14px/22px var(--aes-font-body); }
        .${prefix}-city-option:is(:hover,[aria-selected="true"]) { background:var(--aes-button-secondary-bg); }
        .${prefix}-city-help { display:flex; justify-content:space-between; flex-wrap:wrap; gap:8px; padding:8px 16px; border-top:1px solid var(--aes-border-default); color:var(--aes-text-muted); font:400 12px/1.6 var(--aes-font-body); }
        .${prefix}-city-help a { color:var(--aes-bg-brand); }
        .${prefix}-field input::placeholder,.${prefix}-field textarea::placeholder { color:var(--aes-text-muted)!important; opacity:1!important; }
        .${prefix}-select [id$="-selector-value"]:empty::before { content:'Select'; color:var(--aes-text-muted); }
        .${prefix}-field :is(input,button,textarea):focus-visible { outline:2px solid var(--aes-border-focus)!important; outline-offset:2px; }
        .${prefix}-group { display:flex; align-items:center; gap:8px; grid-column:1/-1; margin:16px 0 0!important; padding:40px 0 0!important; border-top:1px solid var(--aes-border-default); color:var(--aes-text-primary); font:400 var(--aes-trade-group-size)/1.35 var(--aes-font-heading)!important; line-height:round(nearest,calc(var(--aes-trade-group-size) * 1.35),1px)!important; }
        .${prefix}-group[data-aes-order="0"] { border-top:0; margin-top:0!important; padding-top:0!important; }
        .${prefix}-group:focus { outline:none!important; }
        .${prefix}-wide { grid-column:1/-1; }
        .${prefix}-field:has([id="custom#aes_business_website"]) { grid-column-start:1; }
        .${prefix}-required::after { content:" *"; font:400 16px/26px var(--aes-font-body); }
        form[data-aes-trade-adapted]>legend { display:none!important; }
        .${prefix}-check { display:flex; align-items:flex-start; gap:12px; font:400 14px/22px var(--aes-font-body); }
        .${prefix}-check[hidden],.${prefix}-group:empty,.${prefix}-note:empty { display:none!important; }
        .${prefix}-check input { width:24px; height:24px; flex:0 0 24px; margin:1px 0 0; accent-color:var(--aes-bg-brand); }
        .${prefix}-delivery { display:grid; grid-template-columns:minmax(0,1fr); gap:24px; min-width:0; margin:0; padding:24px; border:1px solid var(--aes-page-trade-program-section3-control-border); grid-column:1/-1; box-sizing:border-box; }
        .${prefix}-delivery[hidden],.${prefix}-delivery-storage { display:none!important; }
        .${prefix}-delivery>legend { grid-column:1/-1; width:auto; max-width:100%; margin:0; padding:0 8px; color:var(--aes-text-primary); font:400 20px/1.4 var(--aes-font-heading); }
        .${prefix}-delivery .${prefix}-field>button.${prefix}-delivery-toggle { position:absolute!important; right:0; bottom:0; width:48px!important; min-height:48px; height:48px; margin:0!important; padding:0!important; border:0!important; background:transparent!important; }
        .${prefix}-delivery .${prefix}-city-menu { top:100%; }
        @media(min-width:1440px) { .${prefix}-delivery { grid-template-columns:repeat(2,minmax(0,1fr)); column-gap:88px; } .${prefix}-delivery .${prefix}-field:has(>[data-aes-delivery="first_name"]) { grid-column-start:1; } }
        .${prefix}-hidden { display:none!important; }
        .${prefix}-hidden:has([aria-invalid="true"]) { display:block!important; grid-column:1/-1; order:57; }
        .${prefix}-phone { display:flex!important; flex-wrap:wrap!important; gap:0!important; position:relative!important; padding-top:38px!important; }
        .${prefix}-phone>div:has(>input) { flex:1; min-width:0; position:static!important; }
        .${prefix}-phone>output { flex:0 0 100%; margin:8px 0 0!important; }
        .${prefix}-phone label { position:absolute!important; top:0!important; left:0!important; transform:none!important; font:400 14px/22px var(--aes-font-body)!important; text-transform:uppercase!important; color:var(--aes-text-primary)!important; }
        .${prefix}-phone input,.${prefix}-phone .phone-country-selector button { box-sizing:border-box!important; min-height:48px!important; height:48px!important; border:1px solid var(--aes-border-default)!important; border-radius:0!important; box-shadow:none!important; background:var(--aes-bg-primary)!important; font:400 14px/22px var(--aes-font-body)!important; }
        .${prefix}-phone input { width:100%!important; padding:0 16px!important; }
        .${prefix}-phone .phone-country-selector button { border-right:0!important; }
        .${prefix}-phone .phone-country-selector { flex:0 0 96px!important; width:96px!important; }
        .${prefix}-phone .phone-country-selector button { display:flex!important; align-items:center!important; width:96px!important; padding-left:16px!important; }
        .${prefix}-phone .phone-country-selector [id="country-selector-value"] { flex:0 0 28px!important; width:28px!important; min-width:28px!important; height:20px!important; overflow:visible!important; }
        .${prefix}-phone .phone-country-selector img { flex:none!important; width:auto!important; min-width:0!important; max-width:28px!important; height:20px!important; object-fit:contain; }
        .${prefix}-file { display:none!important; }
        .${prefix}-upload { box-sizing:border-box; grid-column:1/-1; min-width:0; min-height:160px; padding:24px; border:2px dashed var(--aes-page-trade-program-section3-control-border); text-align:center; background:transparent; outline:none; box-shadow:none; }
        .${prefix}-upload-add { display:flex; align-items:center; justify-content:center; flex-direction:column; gap:12px; width:100%; min-height:110px; padding:0; border:0; background:transparent; color:var(--aes-text-primary); font:400 16px/1.6 var(--aes-font-body); cursor:pointer; }
        .${prefix}-upload[data-aes-has-files] { min-height:0; padding:12px; }
        .${prefix}-upload[data-aes-has-files] .${prefix}-upload-add { min-height:32px; margin-top:12px; }
        .${prefix}-upload-add:disabled { cursor:default; color:var(--aes-text-muted); }
        .${prefix}-upload[data-aes-has-files] .${prefix}-upload-add:disabled { display:none; }
        .${prefix}-upload-list { display:grid; gap:8px; margin:0; padding:0; list-style:none; text-align:left; }
        .${prefix}-upload-item { display:flex; align-items:center; justify-content:space-between; gap:12px; min-height:32px; }
        .${prefix}-upload-name { flex:1; min-width:0; overflow-wrap:anywhere; font:400 14px/22px var(--aes-font-body); }
        .${prefix}-upload-remove { display:inline-flex; align-items:center; justify-content:center; flex:0 0 32px; width:32px; height:32px; padding:0; border:0; background:transparent; color:var(--aes-bg-brand); cursor:pointer; }
        .${prefix}-upload-remove svg { width:20px; height:20px; }
        .${prefix}-upload-remove [stroke] { stroke:currentColor; }
        .${prefix}-upload-remove [fill]:not([fill="none"]) { fill:currentColor; }
        .${prefix}-upload :is(button):focus-visible { outline:none!important; box-shadow:inset 0 0 0 1px var(--aes-page-trade-program-section3-control-active); }
        .${prefix}-upload:focus-within { border-color:var(--aes-page-trade-program-section3-control-active); }
        .${prefix}-upload:has(.${prefix}-upload-error) { border-color:var(--aes-page-trade-program-section3-control-error); }
        .${prefix}-upload-title { font:400 14px/22px var(--aes-font-body); color:var(--aes-text-primary); }
        .${prefix}-upload-description { font:400 14px/22px var(--aes-font-body); color:var(--aes-text-muted); }
        .${prefix}-upload-description:empty { display:none; }
        .${prefix}-upload-picker { display:none!important; }
        .${prefix}-upload-limits { grid-column:1/-1; margin:0!important; color:var(--aes-text-muted); font:400 14px/22px var(--aes-font-body); }
        .${prefix}-upload-error { display:block; width:100%; margin:8px 0 0!important; text-align:left!important; color:var(--aes-page-trade-program-section3-control-error); font:400 12px/1.6 var(--aes-font-body); }
        .${prefix}-consent { grid-column:1/-1; font:400 14px/22px var(--aes-font-body)!important; }
        .${prefix}-consent label { font:inherit!important; color:var(--aes-text-primary)!important; }
        .${prefix}-consent label:has(input[type="checkbox"]) { display:flex!important; align-items:flex-start!important; gap:12px!important; }
        .${prefix}-consent [class*="_checkboxWrapper_"] { box-sizing:border-box!important; flex:0 0 24px!important; width:24px!important; min-width:24px!important; height:24px!important; margin:0!important; }
        .${prefix}-terms { border:0!important; border-top:1px solid var(--aes-border-default)!important; padding:32px 0 0!important; margin:16px 0 0!important; min-width:0; }
        .${prefix}-terms legend { display:none; }
        .${prefix}-terms a { color:inherit; text-decoration:underline; text-underline-offset:3px; }
        [data-testid="btn-form-submit"] { position:relative; order:60!important; grid-column:1/-1!important; justify-self:start!important; width:max-content!important; min-width:0!important; height:41px!important; min-height:41px!important; padding:0 8px!important; border:1px solid var(--aes-text-primary)!important; border-radius:0!important; background:transparent!important; color:var(--aes-text-primary)!important; display:inline-flex!important; align-items:center!important; gap:12px!important; box-sizing:border-box!important; font:400 var(--aes-trade-submit-size)/1.35 var(--aes-font-heading)!important; letter-spacing:0!important; text-transform:uppercase!important; transition:background var(--aes-duration),color var(--aes-duration); }
        [data-testid="btn-form-submit"]::after { content:''; position:absolute; inset:4px; border:var(--aes-button-inset-border-width) solid currentColor; opacity:0; pointer-events:none; transition:opacity var(--aes-duration); }
        form[data-aes-verification-retry] [data-testid="btn-form-submit"],.${prefix}-verification-retry[hidden] { display:none!important; }
        .${prefix}-verification-retry { position:relative; display:inline-flex; align-items:center; justify-self:start; grid-column:1/-1; gap:12px; min-height:41px; padding:0 8px; border:1px solid var(--aes-text-primary); border-radius:0; background:transparent; color:var(--aes-text-primary); font:400 var(--aes-trade-submit-size)/1.35 var(--aes-font-heading); text-transform:uppercase; cursor:pointer; }
        .${prefix}-verification-retry::after { content:''; position:absolute; inset:var(--aes-button-inset); border:var(--aes-button-inset-border-width) solid currentColor; opacity:0; pointer-events:none; }
        .${prefix}-verification-retry:is(:active,:focus-visible) { background:#897266; border-color:#897266; color:var(--aes-text-inverse); outline:2px solid var(--aes-border-focus); outline-offset:2px; }
        .${prefix}-verification-retry:is(:active,:focus-visible)::after { opacity:1; }
        @media(hover:hover) and (pointer:fine) { .${prefix}-verification-retry:hover { background:#897266; border-color:#897266; color:var(--aes-text-inverse); } .${prefix}-verification-retry:hover::after { opacity:1; } }
        @media(min-width:1440px) { .${prefix}-verification-retry { min-height:56px; padding-inline:24px; } }
        [data-testid="btn-form-submit"]:is(:active,:focus-visible) { background:#897266!important; border-color:#897266!important; color:var(--aes-text-inverse)!important; }
        [data-testid="btn-form-submit"]:is(:active,:focus-visible)::after { opacity:1; }
        .${prefix}-arrow { width:8px; height:8px; display:inline-flex; align-items:center; justify-content:center; flex:0 0 8px; transform:rotate(-45deg); }
        .${prefix}-arrow svg { display:block; flex:none; width:24px; height:24px; transform:scale(calc(8px / 13.5px)); fill:currentColor; }
        .${prefix}-arrow [fill] { fill:currentColor; }
        [data-aes-page-trade-program-section3-busy] .${prefix}-arrow { position:relative; transform:none; }
        [data-aes-page-trade-program-section3-busy] .${prefix}-arrow svg { visibility:hidden; }
        [data-aes-page-trade-program-section3-busy] .${prefix}-arrow::after { content:''; position:absolute; inset:0; border:2px solid currentColor; border-right-color:transparent; border-radius:50%; animation:aes-page-trade-program-section3-submit 1s linear infinite; }
        [data-aes-page-trade-program-section3-busy]>svg { display:none!important; }
        [data-aes-page-trade-program-section3-busy] [data-testid="spinner-icon"] { display:none!important; }
        [data-aes-page-trade-program-section3-busy] [class*="_visuallyHidden_"] { position:static!important; width:auto!important; height:auto!important; padding:0!important; margin:0!important; overflow:visible!important; clip:auto!important; clip-path:none!important; white-space:normal!important; }
        [data-testid="btn-form-submit"][data-aes-page-trade-program-section3-busy] { min-width:var(--aes-page-trade-program-section3-submit-width,128px)!important; }
        form[data-aes-page-trade-program-section3-busy] :is(input,select,textarea,button) { cursor:wait; }
        @keyframes aes-page-trade-program-section3-submit { to { transform:rotate(360deg); } }
        /* Keep the inset border anchored when Shopify removes its hover filter. */
        [data-testid="btn-form-submit"] { position:relative!important; padding-inline:8px!important; }
        @media(min-width:1440px) { [data-testid="btn-form-submit"] { min-width:128px!important; height:56px!important; min-height:56px!important; padding-inline:24px!important; } }
        .${prefix}-note { margin:0!important; color:var(--aes-text-muted); font:400 14px/22px var(--aes-font-body); }
        .${prefix}-status { font:400 14px/22px var(--aes-font-body); margin:0; }
        .${prefix}-status[hidden] { display:none!important; }
        @media(hover:hover) and (pointer:fine) { [data-testid="btn-form-submit"]:hover:not(:disabled) { background:#897266!important; border-color:#897266!important; color:var(--aes-text-inverse)!important; } [data-testid="btn-form-submit"]:hover:not(:disabled)::after { opacity:1; } }
        @media(min-width:1440px) { form[data-aes-trade-adapted] { grid-template-columns:repeat(2,minmax(0,1fr))!important; column-gap:88px!important; row-gap:24px!important; } .${prefix}-group { padding-top:64px!important; margin-top:24px!important; } }
        /* Qualification follows the same 88px column gap as the other desktop fields. */
        @media(min-width:1440px) {
          .${prefix}-upload { grid-column:1; width:100%; justify-self:start; }
          .${prefix}-field:has([id="custom#aes_purchase_for_resale-selector-value"]) { grid-column:2; width:100%!important; justify-self:end; }
        }
        @media(prefers-reduced-motion:reduce) { [data-testid="btn-form-submit"],[data-testid="btn-form-submit"]::after,.${prefix}-select-chevron { transition:none!important; } [data-aes-page-trade-program-section3-busy] .${prefix}-arrow::after { animation:none; } }
      `;
      style.textContent += `
        :host,form[data-aes-trade-adapted],form[data-aes-trade-adapted] * { letter-spacing:var(--aes-letter-spacing)!important; }
        .${prefix}-group-number { font:400 var(--aes-trade-group-number-size)/1.6 var(--aes-font-body)!important; vertical-align:baseline; }
        form[data-aes-trade-adapted] input[type="checkbox"] { appearance:none!important; -webkit-appearance:none!important; position:relative; display:inline-grid!important; place-items:center!important; box-sizing:border-box!important; flex:0 0 24px!important; width:24px!important; min-width:24px!important; max-width:24px!important; height:24px!important; min-height:24px!important; max-height:24px!important; padding:0!important; margin:1px 0 0!important; border:0!important; border-radius:0!important; background:transparent!important; box-shadow:none!important; cursor:pointer; vertical-align:top; }
        form[data-aes-trade-adapted] input[type="checkbox"]::before { content:''; position:absolute; inset:2px; box-sizing:border-box; border:1px solid var(--aes-text-primary); background:var(--aes-bg-primary); pointer-events:none; }
        form[data-aes-trade-adapted] input[type="checkbox"]::after { content:''; position:absolute; left:50%; top:50%; transform:translate(-50%,-50%); display:block; width:20px; height:20px; background:var(--aes-text-inverse); mask:var(--aes-page-trade-program-section3-check-icon) center/contain no-repeat; -webkit-mask:var(--aes-page-trade-program-section3-check-icon) center/contain no-repeat; opacity:0; pointer-events:none; }
        form[data-aes-trade-adapted] input[type="checkbox"]:checked::before { background:var(--aes-bg-inverse); border-color:var(--aes-bg-inverse); }
        form[data-aes-trade-adapted] input[type="checkbox"]:checked::after { opacity:1; }
        form[data-aes-trade-adapted] input[type="checkbox"]:focus-visible { outline:2px solid var(--aes-border-focus)!important; outline-offset:2px; }
        form[data-aes-trade-adapted] input[type="checkbox"][aria-invalid="true"]::before { border-color:var(--aes-page-trade-program-section3-control-error)!important; }
        form[data-aes-trade-adapted] input[type="checkbox"]:disabled { opacity:.5; cursor:not-allowed; }
        .${prefix}-field:has(>input:not([type=checkbox]):not([type=file])),.${prefix}-field:has(>textarea) { flex-direction:column!important; }
        .${prefix}-field>label { order:-1!important; }
        .${prefix}-field>input,.${prefix}-field>textarea { order:0!important; }
        .${prefix}-field>[role="alert"],.${prefix}-field>[id$="-error"],.${prefix}-field>[class*="_error"] { order:1!important; }
        .${prefix}-native-error { position:absolute!important; width:1px!important; height:1px!important; padding:0!important; margin:-1px!important; overflow:hidden!important; clip-path:inset(50%)!important; white-space:nowrap!important; }
        .${prefix}-field-error { order:1!important; display:block; margin:0!important; color:var(--aes-page-trade-program-section3-control-error)!important; font:400 12px/1.6 var(--aes-font-body)!important; text-transform:none!important; }
        [data-testid="btn-form-submit"]:focus { outline:0!important; box-shadow:none!important; }
        .${prefix}-field>button[class*="_selectorError_"],.${prefix}-phone button[class*="_selectorError_"],.${prefix}-field[class*="_withError_"]>textarea { border-color:var(--aes-page-trade-program-section3-control-error)!important; }
        .${prefix}-field>input:not([type=checkbox]):not([type=file]),.${prefix}-field>textarea,.${prefix}-field>button,.${prefix}-phone input,.${prefix}-phone .phone-country-selector button {
          border-color:var(--aes-page-trade-program-section3-control-border)!important;
          color:var(--aes-text-secondary)!important; font-weight:400!important;
          outline:0!important; box-shadow:none!important;
          transition:border-color var(--aes-duration) var(--aes-ease);
        }
        form[data-aes-trade-adapted] .${prefix}-field :is(input,textarea,button):is(:focus,:focus-visible),form[data-aes-trade-adapted] .${prefix}-phone :is(input,button):is(:focus,:focus-visible),form[data-aes-trade-adapted] .${prefix}-select[aria-expanded="true"] {
          border-color:var(--aes-page-trade-program-section3-control-active)!important; outline:0!important;
        }
        @media(hover:hover) and (pointer:fine) {
          form[data-aes-trade-adapted] .${prefix}-field :is(input,textarea,button):hover:where(:not(:disabled)),form[data-aes-trade-adapted] .${prefix}-phone :is(input,button):hover:where(:not(:disabled)) { border-color:var(--aes-page-trade-program-section3-control-active)!important; }
        }
        form[data-aes-trade-adapted] .${prefix}-field :is(input,textarea,button)[aria-invalid="true"],form[data-aes-trade-adapted] .${prefix}-phone :is(input,button)[aria-invalid="true"],form[data-aes-trade-adapted] .${prefix}-field>input:user-invalid { border-color:var(--aes-page-trade-program-section3-control-error)!important; }
        form[data-aes-trade-adapted] [role="alert"],form[data-aes-trade-adapted] [id$="-error"],form[data-aes-trade-adapted] [class*="_error"],form[data-aes-trade-adapted] [class*="_Error"] { color:var(--aes-page-trade-program-section3-control-error)!important; font:400 12px/1.6 var(--aes-font-body)!important; letter-spacing:0!important; text-transform:none!important; }
        .${prefix}-group,.${prefix}-terms { border-color:var(--aes-page-trade-program-section3-divider)!important; }
        .${prefix}-file { border-color:var(--aes-page-trade-program-section3-control-border)!important; }
        .${prefix}-select [id$="-selector-value"],.${prefix}-select [id$="-selector-value"] * { font:inherit!important; color:inherit; }
        [role="listbox"] { box-sizing:border-box!important; margin:0!important; padding:0!important; border:1px solid var(--aes-page-trade-program-section3-control-active)!important; border-radius:0!important; background:var(--aes-bg-primary)!important; box-shadow:none!important; text-align:left!important; }
        [class*="_dropdownContainer_"] { position:absolute!important; top:var(--aes-dropdown-top,100%)!important; bottom:auto!important; left:0!important; right:0!important; transform:none!important; margin:0!important; z-index:20!important; box-shadow:none!important; border-radius:0!important; }
        [role="listbox"] { overflow-x:hidden!important; }
        [role="option"] { white-space:normal!important; overflow-wrap:anywhere; }
        [role="listbox"]::-webkit-scrollbar { width:6px; }
        [role="listbox"]::-webkit-scrollbar-thumb { background:var(--aes-text-muted); border-radius:0; }
        [role="listbox"]::-webkit-scrollbar-button { display:none; width:0; height:0; }
        [class*="_optionListItem_"] { margin:0!important; border:0!important; outline:0!important; box-shadow:none!important; border-radius:0!important; background:transparent!important; }
        [role="option"] { box-sizing:border-box!important; display:flex; align-items:center; min-height:48px; padding:12px 16px!important; margin:0!important; border:0!important; outline:0!important; box-shadow:none!important; border-radius:0!important; background:var(--aes-bg-primary)!important; color:var(--aes-text-secondary)!important; font:400 14px/22px var(--aes-font-body)!important; text-align:left!important; }
        [role="option"]:is(:hover,:focus,:focus-visible,[aria-selected="true"]) { background:var(--aes-bg-subtle)!important; outline:0!important; }
        @media(max-width:1439.999px) {
          form[data-aes-trade-adapted] { row-gap:12px!important; }
          .${prefix}-group { margin-top:28px!important; margin-bottom:8px!important; padding-top:40px!important; }
          .${prefix}-field:has([id="email"],[id="billing_address_country-selector-value"],[id="billing_address_city"],[id="billing_address_address1"],[id="custom#aes_business_website"],[id="custom#aes_social_media"],[id="custom#aes_estimated_project_budget-selector-value"],[id="custom#aes_purchase_for_resale-selector-value"]) { margin-top:8px!important; }
          .${prefix}-terms { margin-top:28px!important; padding-top:40px!important; }
          .${prefix}-consent:not(.${prefix}-terms),[data-testid="btn-form-submit"],.${prefix}-note { margin-top:8px!important; }
        }
        @media(min-width:768px) and (max-width:1439.999px) {
          .${prefix}-group { margin-bottom:12px!important; }
          .${prefix}-field:has([id="email"],[id="billing_address_country-selector-value"],[id="billing_address_city"],[id="billing_address_address1"],[id="custom#aes_business_website"],[id="custom#aes_social_media"],[id="custom#aes_estimated_project_budget-selector-value"],[id="custom#aes_purchase_for_resale-selector-value"]),.${prefix}-consent:not(.${prefix}-terms),[data-testid="btn-form-submit"],.${prefix}-note { margin-top:12px!important; }
        }
        @media(prefers-reduced-motion:reduce) { .${prefix}-field :is(input,textarea,button),.${prefix}-phone :is(input,button) { transition:none!important; } }
      `;
      style.dataset.aesTradeStyle = '';
      root.querySelector('style[data-aes-trade-style]')?.remove();
      root.append(style);
      const rows = [
        ['first_name',1],['last_name',2],['email',3],['company_name',11],['custom#aes_business_type',12],
        ['billing_address_country',13],['billing_address_zone',14],['billing_address_city',15],['billing_address_zip',16],
        ['billing_address_address1',17],['billing_address_address2',18],['custom#aes_requested_delivery_address',20],
        ['custom#aes_business_website',22],['custom#aes_portfolio_link',23],['custom#aes_social_media',24],
        ['custom#aes_professional_membership',25],['custom#aes_years_in_business',26],['custom#aes_inquiry_type',31],
        ['custom#aes_project_type',32],['custom#aes_estimated_project_budget',33],['custom#aes_purchase_timeline',34],
        ['custom#aes_purchase_for_resale',49]
      ];
      const control = id => root.getElementById(id) || root.getElementById(id+'-selector-value') || root.querySelector('[name="'+CSS.escape(id)+'"]');
      const fieldBox = el => el?.id.endsWith('-selector-value') ? el.closest('[class*="_selectContainer_"]') : el?.parentElement;
      const top = el => { while (el?.parentElement && el.parentElement !== form) el = el.parentElement; return el; };
      const flatten = el => { let parent = el.parentElement; while (parent && parent !== form) { parent.classList.add(prefix+'-flatten'); parent = parent.parentElement; } };
      const mark = (el,order,kind='field') => { if (!el) return; el.classList.add(prefix+'-'+kind); if (el.style.order !== String(order)) el.style.order = order; };
      const placeholders = {
        billing_address_city:'City', billing_address_zip:'ZIP/Postal Code',
        billing_address_address1:'Address', billing_address_address2:'Apartment, Suite, etc',
        phone_number:'Include country code', 'custom#aes_requested_delivery_address':'Delivery Address',
        'custom#aes_business_website':'https://', 'custom#aes_portfolio_link':'https://', 'custom#aes_social_media':'https://'
      };
      const uploadLimit = { count:3, bytes:20*1024*1024 };
      const uploadTypes = {
        pdf:['application/pdf'], png:['image/png'], jpg:['image/jpeg'], jpeg:['image/jpeg'],
        webp:['image/webp'], svg:['image/svg+xml'], heic:['image/heic','image/heif'], gif:['image/gif']
      };
      const uploadAccept = Object.keys(uploadTypes).map(extension=>'.'+extension).join(',');
      const uploadErrors = new Map();
      const fileInputs = () => Array.from(form.querySelectorAll('input[type="file"]:not([data-aes-upload-picker])'));
      const filesError = files => {
        for (const file of files) {
          const extension=file.name.split('.').pop().toLowerCase(),mimes=uploadTypes[extension];
          if (!mimes || (file.type && !mimes.includes(file.type.toLowerCase()))) return 'Choose a PDF, PNG, JPG, JPEG, WEBP, SVG, HEIC or GIF file. XLSX files are not supported.';
          if (file.size>uploadLimit.bytes) return 'Each file must be 20 MB or smaller.';
        }
        return '';
      };
      const uploadError = input => {
        const files=Array.from(input.files || []);
        if (files.length>1) return 'Choose files using the upload area.';
        if (fileInputs().reduce((count,field)=>count+(field.files?.length || 0),0)>uploadLimit.count) return 'You can upload up to 3 files in total.';
        return filesError(files);
      };
      const displayUploadErrors = () => {
        const group=form.querySelector('.'+prefix+'-upload');
        if (!group) return;
        const groupDescriptions=[];
        const displayInputs=[...fileInputs(),...form.querySelectorAll('[data-aes-upload-picker]')];
        const currentIds=new Set(displayInputs.map(input=>input.id+'-aes-upload-error'));
        group.querySelectorAll('.'+prefix+'-upload-error').forEach(alert=>{ if (!currentIds.has(alert.id)) alert.remove(); });
        displayInputs.forEach(input=>{
          const box=top(input),message=uploadErrors.get(input.id) || '';
          if (!box) return;
          let alert=group.querySelector('[id="'+CSS.escape(input.id+'-aes-upload-error')+'"]');
          const errorId=input.id+'-aes-upload-error';
          const descriptions=(input.getAttribute('aria-describedby') || '').split(/\s+/).filter(id=>id && id!==errorId);
          const nativeError=input.hasAttribute('data-aes-upload-picker') ? null : box.querySelector('output[role="alert"]') || (box.nextElementSibling?.matches('output[role="alert"]') ? box.nextElementSibling : null);
          nativeError?.classList.add(prefix+'-native-error');
          const text=message || nativeError?.textContent.trim() || '';
          if (text) {
            if (!alert) { alert=document.createElement('span'); alert.className=prefix+'-upload-error'; alert.id=errorId; alert.setAttribute('role','alert'); group.append(alert); }
            if (alert.textContent!==text) alert.textContent=text;
            groupDescriptions.push(errorId);
          } else alert?.remove();
          if (message) {
            input.setAttribute('aria-invalid','true'); descriptions.push(errorId);
          } else {
            if (input.getAttribute('aria-describedby')?.includes(errorId)) input.removeAttribute('aria-invalid');
          }
          const described=descriptions.join(' ');
          if (described) input.setAttribute('aria-describedby',described); else input.removeAttribute('aria-describedby');
        });
        const add=group.querySelector('.'+prefix+'-upload-add');
        if (groupDescriptions.length) add.setAttribute('aria-describedby',groupDescriptions.join(' ')); else add.removeAttribute('aria-describedby');
        add.setAttribute('aria-invalid',String(groupDescriptions.length>0));
      };
      const uploadName = input => input.files?.[0]?.name || top(input)?.querySelector('[class*="_formFileInputFileName_"]')?.textContent.trim() || '';
      const renderUploads = () => {
        const inputs=fileInputs(),remote=!!this.dataset.uploadEndpoint;
        if (!remote && !inputs.length) return;
        let group=form.querySelector('.'+prefix+'-upload');
        if (!group) {
          group=document.createElement('div'); group.className=prefix+'-upload'; group.style.order='42';
          group.setAttribute('role','group'); group.setAttribute('aria-label','Qualifying business documents');
          const list=document.createElement('ul'); list.className=prefix+'-upload-list'; list.setAttribute('aria-live','polite');
          const add=document.createElement('button'); add.type='button'; add.className=prefix+'-upload-add';
          group.append(list,add); form.append(group);
        }
        if (!group.querySelector('[data-aes-upload-picker]')) {
          const picker=document.createElement('input'); picker.type='file'; picker.multiple=true; picker.accept=uploadAccept;
          picker.id=prefix+'-upload-picker-'+this.id; picker.className=prefix+'-upload-picker'; picker.hidden=true;
          picker.setAttribute('data-aes-upload-picker',''); group.append(picker);
        }
        group.querySelector('[data-aes-upload-picker]').accept=remote ? this.uploader?.accept || '' : uploadAccept;
        const selected=remote ? this.uploader?.files || [] : inputs.filter(uploadName),key=JSON.stringify([!!this.fileCards,selected.map(input=>remote ? [input.name,input.size,input.lastModified] : [input.id,uploadName(input),input.files?.[0]?.lastModified])]);
        if (group.dataset.aesFiles!==key) {
          group.dataset.aesFiles=key;
          group.toggleAttribute('data-aes-has-files',selected.length>0);
          const list=group.querySelector('.'+prefix+'-upload-list'); list.replaceChildren();
          const entries=selected.map((input,index)=>{
            const item=document.createElement('li'); item.className=prefix+'-upload-item';
            const name=document.createElement('span'); name.className=prefix+'-upload-name'; name.textContent=remote ? input.name : uploadName(input);
            const remove=document.createElement('button'); remove.type='button'; remove.className=prefix+'-upload-remove'; remove.dataset.aesUploadId=input.id;
            remove.setAttribute('aria-label','Remove '+name.textContent);
            remove.append(uploadRemove.content.cloneNode(true));
            const onRemove=()=>{
              if (!remote || this.preparingUploads || form.hasAttribute('data-aes-page-trade-program-section3-busy')) return;
              this.uploader.remove(index); uploadErrors.clear(); renderUploads(); group.querySelector('.'+prefix+'-upload-add')?.focus();
            };
            if (!this.fileCards) { if(remote)remove.addEventListener('click',onRemove); item.append(name,remove); list.append(item); }
            return {file:remote ? input : input.files?.[0],name:name.textContent,removeButton:remove,onRemove};
          });
          this.fileCards?.render(list,entries);
          const add=group.querySelector('.'+prefix+'-upload-add'); add.replaceChildren();
          if (!selected.length) {
            const copy=uploadCopy.content.cloneNode(true),title=copy.querySelector('.'+prefix+'-upload-title');
            if (!title.textContent.trim()) title.textContent=(remote ? this.uploader?.policy.label : top(inputs[0])?.querySelector('p')?.textContent) || 'Upload a Qualifying Business Document *';
            add.append(copy);
          } else add.textContent=selected.length>=uploadLimit.count ? '3 files added' : 'Add file';
          add.disabled=selected.length>=uploadLimit.count;
        }
        displayUploadErrors();
      };
      this.refreshUploads=renderUploads;
      const clearUpload = input => {
        top(input)?.querySelector('button[class*="_formFileInputCancelButton_"]')?.click();
        input.value=''; uploadErrors.delete(input.id);
      };
      form.addEventListener('click',event=>{
        const add=event.target.closest('.'+prefix+'-upload-add');
        if (add) {
          const picker=form.querySelector('[data-aes-upload-picker]');
          if (picker && !add.disabled) { picker.value=''; picker.click(); }
          return;
        }
        const remove=event.target.closest('.'+prefix+'-upload-remove');
        if (!remove) return;
        if (this.dataset.uploadEndpoint || this.preparingUploads || form.hasAttribute('data-aes-page-trade-program-section3-busy')) return;
        const inputs=fileInputs(),target=inputs.find(input=>input.id===remove.dataset.aesUploadId);
        if (!target) return;
        const remaining=inputs.filter(input=>input!==target).map(input=>input.files?.[0]).filter(Boolean);
        uploadErrors.delete(form.querySelector('[data-aes-upload-picker]')?.id);
        inputs.forEach(clearUpload);
        remaining.forEach((file,index)=>{
          const input=fileInputs()[index],transfer=new DataTransfer(); transfer.items.add(file); input.files=transfer.files;
          input.dispatchEvent(new Event('change',{bubbles:true}));
        });
        queueMicrotask(()=>{ renderUploads(); form.querySelector('.'+prefix+'-upload-add')?.focus(); });
      },{signal:this.abort.signal});
      const openedDropdowns = new WeakSet();
      const positionDropdowns = () => {
        form.querySelectorAll('[class*="_dropdownContainer_"]').forEach(popup=>{
          const button=popup.parentElement.querySelector('button[aria-expanded="true"]');
          if (!button) return;
          popup.style.setProperty('--aes-dropdown-top',(button.offsetTop+button.offsetHeight)+'px');
          if (openedDropdowns.has(popup)) return;
          openedDropdowns.add(popup);
          requestAnimationFrame(()=>{
            if (!popup.isConnected || this.abort.signal.aborted) return;
            const bottom=popup.getBoundingClientRect().bottom;
            const viewportBottom=window.visualViewport ? window.visualViewport.offsetTop+window.visualViewport.height : window.innerHeight;
            if (bottom>viewportBottom-16) window.scrollBy({top:bottom-viewportBottom+16,behavior:'instant'});
          });
        });
      };
      window.addEventListener('resize',positionDropdowns,{signal:this.abort.signal});
      const decorate = () => {
        form.querySelectorAll('.'+prefix+'-group').forEach(heading=>{
          if (heading.querySelector('.'+prefix+'-group-number')) return;
          const match=heading.textContent.match(/^(\d{2})\s+/); if (!match) return;
          const number=document.createElement('span'); number.className=prefix+'-group-number'; number.textContent=match[1];
          const title=document.createElement('span'); title.textContent=heading.textContent.slice(match[0].length);
          heading.replaceChildren(number,title);
        });
        rows.forEach(([id,order]) => {
          const el=control(id),box=fieldBox(el); if (!box) return;
          if (!el.id && el.tagName==='TEXTAREA') el.id=id;
          flatten(box); mark(box,order);
          // Native text-field errors are React-owned siblings, not field children.
          // Keep them in place for reconciliation/announcements and mirror only
          // their visible text inside the field so they cannot become grid cells.
          const nativeError=box.nextElementSibling?.matches('output[role="alert"]') ? box.nextElementSibling : null;
          let errorCopy=box.querySelector('.'+prefix+'-field-error');
          if (nativeError) {
            nativeError.classList.add(prefix+'-native-error');
            nativeError.style.order=String(order);
            if (!nativeError.id) nativeError.id=id+'-aes-error';
            const described=new Set((el.getAttribute('aria-describedby')||'').split(/\s+/).filter(Boolean));
            described.add(nativeError.id); el.setAttribute('aria-describedby',Array.from(described).join(' '));
            if (!errorCopy) { errorCopy=document.createElement('span'); errorCopy.className=prefix+'-field-error'; errorCopy.setAttribute('aria-hidden','true'); box.append(errorCopy); }
            if (errorCopy.textContent!==nativeError.textContent) errorCopy.textContent=nativeError.textContent;
          } else if (errorCopy) {
            errorCopy.remove();
            const described=(el.getAttribute('aria-describedby')||'').split(/\s+/).filter(value=>value && value!==id+'-aes-error');
            if (described.length) el.setAttribute('aria-describedby',described.join(' ')); else el.removeAttribute('aria-describedby');
          }
          const label=box.querySelector('label,p');
          if (id==='billing_address_zip' && label && label.textContent!=='ZIP/POSTAL CODE') label.textContent='ZIP/POSTAL CODE';
          if (id==='custom#aes_requested_delivery_address') {
            const deliveryLabel=label || document.createElement('label');
            if (!label) box.prepend(deliveryLabel);
            if (deliveryLabel.textContent!=='DELIVERY ADDRESS') deliveryLabel.textContent='DELIVERY ADDRESS';
            deliveryLabel.htmlFor=el.id;
            deliveryLabel.id='label-'+el.id;
            el.setAttribute('aria-labelledby',deliveryLabel.id);
          }
          if (el.matches('input,textarea')) {
            const text=placeholders[id] || el.getAttribute('placeholder') || label?.textContent.trim() || '';
            const placeholder=placeholders[id] || text.replace(/^\p{Ll}/u,letter=>letter.toUpperCase());
            if (placeholder && el.getAttribute('placeholder')!==placeholder) el.setAttribute('placeholder',placeholder);
          }
        });
        addressLabels.content.querySelectorAll('[data-aes-address-id]').forEach(label => {
          const box=fieldBox(control(label.dataset.aesAddressId));
          if (!box || !label.textContent.trim() || box.querySelector('.'+prefix+'-address-label')) return;
          const copy=label.cloneNode(true); copy.className=prefix+'-address-label';
          copy.id=label.dataset.aesAddressId+'-aes-label'; box.prepend(copy);
          box.querySelector('button')?.setAttribute('aria-labelledby',copy.id+' '+label.dataset.aesAddressId+'-selector-value');
        });
        mark(top(control('phone_number')),4,'phone');
        const phoneInput=control('phone_number');
        if (phoneInput && phoneInput.getAttribute('placeholder')!==placeholders.phone_number) phoneInput.setAttribute('placeholder',placeholders.phone_number);
        ['first_name','last_name','email','phone_number','company_name','billing_address_country','billing_address_city','billing_address_zone','billing_address_zip','billing_address_address1','custom#aes_business_type','custom#aes_inquiry_type','custom#aes_purchase_timeline','custom#aes_purchase_for_resale'].forEach(id=>{
          const el=control(id),box=fieldBox(el); if (!box) return;
          box.querySelector('label,p,.'+prefix+'-address-label')?.classList.add(prefix+'-required');
        });
        form.querySelectorAll('[class*="_selectContainer_"]>button,.phone-country-selector button').forEach(button=>{
          button.classList.add(prefix+'-select');
          if (!button.querySelector('.'+prefix+'-select-chevron')) button.append(selectChevron.content.cloneNode(true));
        });
        fileInputs().forEach((fileInput,index)=>{
          fileInput.accept=uploadAccept;
          fileInput.multiple=false;
          const fileBox=top(fileInput);
          mark(fileBox,42+index,'file');
        });
        renderUploads(); decorateCity();
        const manifestField=control('custom#inquiry_attachment_manifest');
        if (manifestField) {top(manifestField)?.classList.add(prefix+'-hidden');manifestField.required=false;manifestField.tabIndex=-1;}
        const deliveryStorage=control('custom#aes_requested_delivery_address');
        if (deliveryStorage) { fieldBox(deliveryStorage)?.classList.add(prefix+'-delivery-storage'); deliveryStorage.required=false; deliveryStorage.removeAttribute('aria-required'); deliveryStorage.tabIndex=-1; }
        ['billing_address_first_name','billing_address_last_name','billing_address_recipient','billing_address_phone','billing_address_address2','custom#aes_same_delivery_address'].forEach(id => {
          const el=control(id); if (!el) return;
          const outer=top(el);
          const box=outer.classList.contains(prefix+'-flatten') ? (id==='billing_address_phone' ? el.closest('[class*="_formPhoneInputContainer_"]') : el.parentElement) : outer;
          box?.classList.add(prefix+'-hidden');
        });
        const terms = control('custom#aes_terms_accepted') || form.querySelector('[name="custom#aes_terms_accepted"]');
        if (terms) {
          const box=top(terms); mark(box,50,'consent'); box.classList.add(prefix+'-terms');
          const copy=box.querySelector('label>span');
          if (copy && !copy.dataset.aesPolicyLinked) {
            policyLinks.content.querySelectorAll('a[href]').forEach(link=>{
              if (!link.getAttribute('href') || !link.textContent.trim()) return;
              for (const node of Array.from(copy.childNodes)) {
                if (node.nodeType!==Node.TEXT_NODE) continue;
                const at=node.textContent.indexOf(link.textContent);
                if (at<0) continue;
                const tail=node.splitText(at); tail.splitText(link.textContent.length);
                tail.replaceWith(link.cloneNode(true)); break;
              }
            });
            copy.dataset.aesPolicyLinked='true';
          }
        }
        mark(top(form.querySelector('[name="emailConsent"]')),51,'consent');
        form.querySelectorAll('[data-aes-order]').forEach(el => mark(el,el.dataset.aesOrder,'ordered'));
        const button=form.querySelector('[data-testid="btn-form-submit"]');
        if (button) {
          button.style.order='60';
          if (!button.querySelector('[data-aes-arrow]')) button.append(arrow.cloneNode(true));
        }
        // Move only complete direct-child field groups; React keeps each field's parent.
        // This aligns keyboard order with the grid without positive tabindex values.
        const orderOf = node => {
          const orders=[node,...node.querySelectorAll('[style]')].map(el=>el.style.order).filter(v=>v!=='').map(Number);
          return orders.length ? Math.min(...orders) : Infinity;
        };
        const active=root.activeElement;
        [form,...form.querySelectorAll('.'+prefix+'-flatten')].forEach(parent=>{
          const children=Array.from(parent.children).filter(el=>Number.isFinite(orderOf(el)));
          const sorted=children.slice().sort((a,b)=>orderOf(a)-orderOf(b));
          const owned=new Set(children);
          let cursor=children[0];
          sorted.forEach(node=>{
            if (node!==cursor) parent.insertBefore(node,cursor||null);
            cursor=node.nextElementSibling;
            while (cursor && !owned.has(cursor)) cursor=cursor.nextElementSibling;
          });
        });
        if (active?.isConnected && root.activeElement!==active) active.focus({preventScroll:true});
        positionDropdowns();
      };
      const setNative = (el,value) => {
        if (!el || el.value===value) return;
        const prototype = el.tagName==='TEXTAREA' ? HTMLTextAreaElement.prototype : HTMLInputElement.prototype;
        const setter = Object.getOwnPropertyDescriptor(prototype,'value')?.set;
        if (!setter) return;
        setter.call(el,value); el.dispatchEvent(new Event('input',{bubbles:true})); el.dispatchEvent(new Event('change',{bubbles:true}));
      };
      const value = id => {
        const el=control(id);
        if (!el || el.querySelector('[class*="_formAddressRegionPlaceholder_"]')) return '';
        return 'value' in el ? el.value : el.textContent.trim();
      };
      let cityIndexPromise,cityContext='',cityOpen=false,cityResults=[],cityActive=-1,cityRequest=0;
      const cityShards=new Map();
      const normalizeCity = text => String(text).normalize('NFD').replace(/\p{Diacritic}/gu,'').toLowerCase().replace(/[^\p{L}\p{N}]/gu,'');
      const cityParts = () => ({input:control('billing_address_city'),box:fieldBox(control('billing_address_city'))});
      const positionCity = () => {
        const {input,box}=cityParts(); if (!input || !box) return;
        const toggle=box.querySelector('.'+prefix+'-city-toggle'),menu=box.querySelector('.'+prefix+'-city-menu');
        if (toggle) toggle.style.top=input.offsetTop+'px';
        if (menu) menu.style.top=input.offsetTop+input.offsetHeight+'px';
      };
      const closeCity = () => {
        cityOpen=false; cityRequest++;
        const {input,box}=cityParts();
        box?.querySelector('.'+prefix+'-city-menu')?.setAttribute('hidden','');
        input?.setAttribute('aria-expanded','false'); input?.removeAttribute('aria-activedescendant');
        box?.querySelector('.'+prefix+'-city-toggle')?.setAttribute('aria-expanded','false');
      };
      const selectCity = name => {
        const {input}=cityParts();
        input?.focus({preventScroll:true}); setNative(input,name); closeCity();
      };
      const renderCity = async () => {
        const {input,box}=cityParts(),menu=box?.querySelector('.'+prefix+'-city-menu');
        if (!cityOpen || !input || !menu) return;
        const request=++cityRequest,countryName=value('billing_address_country'),stateName=value('billing_address_zone'),search=normalizeCity(input.value);
        const list=menu.querySelector('ul'),help=menu.querySelector('[data-aes-city-help]');
        cityResults=[]; cityActive=-1; list.replaceChildren(); input.removeAttribute('aria-activedescendant');
        help.textContent='Loading cities… You can also enter your city.';
        try {
          cityIndexPromise ||= fetch(this.dataset.aesCityIndexUrl,{signal:this.abort.signal}).then(response=>{if(!response.ok)throw Error('City index unavailable');return response.json();}).catch(error=>{cityIndexPromise=null;throw error;});
          const index=await cityIndexPromise;
          const countries=Object.entries(index.countries),countryKey=normalizeCity(countryName),names=new Intl.DisplayNames(['en'],{type:'region'});
          const country=countries.find(([code,data])=>[...data.aliases,names.of(code)].some(alias=>normalizeCity(alias)===countryKey));
          if (!country) { if(request===cityRequest)help.textContent='Select a country, or enter your city.'; return; }
          const [code,config]=country,shard=config.shard;
          if (!cityShards.has(shard)) cityShards.set(shard,fetch(this.getAttribute('data-aes-city-'+shard+'-url'),{signal:this.abort.signal}).then(response=>{if(!response.ok)throw Error('Cities unavailable');return response.json();}).catch(error=>{cityShards.delete(shard);throw error;}));
          const data=(await cityShards.get(shard)).data[code] || {};
          if (request!==cityRequest || !cityOpen || this.abort.signal.aborted) return;
          const stateKey=normalizeCity(stateName),state=Object.entries(config.states).find(([,item])=>item.aliases.some(alias=>normalizeCity(alias)===stateKey));
          const province=control('billing_address_zone'),needsProvince=province && getComputedStyle(fieldBox(province)).display!=='none';
          const choices=state ? data[state[0]] || [] : !needsProvince && !stateName ? Object.values(data).flat() : [];
          cityResults=Array.from(new Set(choices)).filter(name=>!search || normalizeCity(name).includes(search)).sort((a,b)=>Number(normalizeCity(b)===search)-Number(normalizeCity(a)===search) || Number(normalizeCity(b).startsWith(search))-Number(normalizeCity(a).startsWith(search)) || a.localeCompare(b)).slice(0,80);
          cityResults.forEach((name,index)=>{
            const option=document.createElement('li'); option.className=prefix+'-city-option'; option.id=menu.id+'-'+index;
            option.setAttribute('role','option'); option.setAttribute('aria-selected','false'); option.dataset.aesCityIndex=String(index); option.textContent=name; list.append(option);
          });
          help.textContent=!stateName && needsProvince ? 'Select a state / province first, or enter your city.' : cityResults.length ? 'Type to find your city, or enter it manually.' : 'No matching cities. Enter your city above.';
        } catch (error) {
          if (request===cityRequest && !this.abort.signal.aborted) help.textContent='City suggestions are unavailable. Enter your city above.';
        }
        positionCity();
        requestAnimationFrame(()=>{ if(cityOpen && menu.isConnected && menu.getBoundingClientRect().bottom>window.innerHeight-16)window.scrollBy({top:menu.getBoundingClientRect().bottom-window.innerHeight+16,behavior:'instant'}); });
      };
      const openCity = () => {
        const {input,box}=cityParts(); if (!input || !box) return;
        input.focus({preventScroll:true});
        cityOpen=true; box.querySelector('.'+prefix+'-city-menu').hidden=false;
        input.setAttribute('aria-expanded','true'); box.querySelector('.'+prefix+'-city-toggle').setAttribute('aria-expanded','true');
        positionCity(); renderCity();
        requestAnimationFrame(()=>{ const menu=box.querySelector('.'+prefix+'-city-menu'); if(cityOpen && menu.getBoundingClientRect().bottom>window.innerHeight-16)window.scrollBy({top:menu.getBoundingClientRect().bottom-window.innerHeight+16,behavior:'instant'}); });
      };
      const decorateCity = () => {
        const {input,box}=cityParts(); if (!input || !box) return;
        if (!box.querySelector('.'+prefix+'-city-toggle')) {
          const toggle=document.createElement('button'); toggle.type='button'; toggle.className=prefix+'-city-toggle '+prefix+'-select'; toggle.setAttribute('aria-label','Show cities'); toggle.setAttribute('aria-expanded','false'); toggle.append(selectChevron.content.cloneNode(true));
          const menu=document.createElement('div'); menu.className=prefix+'-city-menu'; menu.id=prefix+'-cities-'+this.id; menu.hidden=true;
          const options=document.createElement('ul'); options.className=prefix+'-city-options'; options.setAttribute('role','listbox'); options.id=menu.id+'-list'; options.setAttribute('aria-label','Cities');
          const footer=document.createElement('div'); footer.className=prefix+'-city-help';
          const help=document.createElement('span'); help.dataset.aesCityHelp=''; help.setAttribute('role','status');
          const source=document.createElement('a'); source.href='https://github.com/dr5hn/countries-states-cities-database'; source.target='_blank'; source.rel='noopener'; source.textContent='City data · ODbL';
          footer.append(help,source); menu.append(options,footer); box.append(toggle,menu);
        }
        const toggle=box.querySelector('.'+prefix+'-city-toggle'),menu=box.querySelector('.'+prefix+'-city-menu');
        input.setAttribute('role','combobox'); input.setAttribute('aria-autocomplete','list'); input.setAttribute('aria-controls',menu.id+'-list');
        if (!input.hasAttribute('aria-expanded')) input.setAttribute('aria-expanded','false');
        toggle.setAttribute('aria-controls',menu.id+'-list');
        const context=value('billing_address_country')+'|'+value('billing_address_zone');
        if (cityContext && cityContext!==context) { setNative(input,''); closeCity(); }
        cityContext=context; positionCity();
      };
      form.addEventListener('click',event=>{
        if (event.target.closest('.'+prefix+'-city-toggle')) { cityOpen ? closeCity() : openCity(); return; }
        const option=event.target.closest('[data-aes-city-index]');
        if (option) { selectCity(cityResults[Number(option.dataset.aesCityIndex)]); return; }
        if (event.target===cityParts().input) openCity();
      },{signal:this.abort.signal});
      form.addEventListener('pointerdown',event=>{
        if (event.target.closest('[data-aes-city-index]')) event.preventDefault();
      },{signal:this.abort.signal});
      form.addEventListener('input',event=>{ if(event.target===cityParts().input && cityOpen)renderCity(); },{signal:this.abort.signal});
      form.addEventListener('keydown',event=>{
        if (event.target!==cityParts().input) return;
        if (event.key==='Escape') { closeCity(); return; }
        if (['ArrowDown','ArrowUp'].includes(event.key)) {
          event.preventDefault(); if(!cityOpen){openCity();return;}
          if (!cityResults.length) return;
          cityActive=cityActive<0 ? (event.key==='ArrowDown'?0:cityResults.length-1) : (cityActive+(event.key==='ArrowDown'?1:-1)+cityResults.length)%cityResults.length;
          const {input,box}=cityParts(),options=box.querySelectorAll('[role="option"]');
          options.forEach((option,index)=>option.setAttribute('aria-selected',String(index===cityActive)));
          input.setAttribute('aria-activedescendant',options[cityActive].id); options[cityActive].scrollIntoView({block:'nearest'});
        } else if(event.key==='Enter' && cityOpen) { event.preventDefault(); cityActive>=0 ? selectCity(cityResults[cityActive]) : closeCity(); }
      },{signal:this.abort.signal});
      root.addEventListener('focusin',event=>{ if (cityOpen && !cityParts().box?.contains(event.target))closeCity(); },{signal:this.abort.signal});
      root.addEventListener('pointerdown',event=>{ if (cityOpen && !cityParts().box?.contains(event.target))closeCity(); },{signal:this.abort.signal});
      window.addEventListener('resize',positionCity,{signal:this.abort.signal});
      const same = form.querySelector('[data-aes-same]');
      // The structured fields belong to the theme; the original Forms textarea
      // stays in its React-owned parent and remains the submitted source of truth.
      let deliveryGroup=form.querySelector('[data-aes-delivery-group]');
      if (!deliveryGroup) {
        deliveryGroup=document.createElement('fieldset'); deliveryGroup.className=prefix+'-delivery';
        deliveryGroup.id=prefix+'-delivery-'+this.id; deliveryGroup.dataset.aesDeliveryGroup=''; deliveryGroup.dataset.aesOrder='20'; deliveryGroup.hidden=true; deliveryGroup.disabled=true;
        const legend=document.createElement('legend'); legend.textContent='Delivery Address (Optional)'; deliveryGroup.append(legend);
        const fields=[
          ['country','Country/Region','country-name',100,false],
          ['first_name','First Name','given-name',100,false],['last_name','Last Name','family-name',100,false],
          ['address1','Address','address-line1',255,true],['address2','Apartment, Suite, etc. (Optional)','address-line2',255,true],
          ['city','City','address-level2',100,false],['zone','State/Province','address-level1',100,false],
          ['zip','ZIP/Postal Code','postal-code',30,false],['phone','Phone (Optional)','tel',40,false]
        ];
        fields.forEach(([key,label,autocomplete,maximum,wide])=>{
          const box=document.createElement('div'); box.className=prefix+'-field'+(wide?' '+prefix+'-wide':'');
          const title=document.createElement('label'),input=document.createElement('input');
          input.id=deliveryGroup.id+'-'+key; input.type=key==='phone'?'tel':'text'; input.dataset.aesDelivery=key;
          input.autocomplete='section-aes-delivery shipping '+autocomplete; input.placeholder=label; input.maxLength=maximum;
          title.htmlFor=input.id; title.textContent=label; box.append(title,input);
          if (['country','zone','city'].includes(key)) {
            input.setAttribute('role','combobox'); input.setAttribute('aria-autocomplete','list'); input.setAttribute('aria-expanded','false');
            const toggle=document.createElement('button'); toggle.type='button'; toggle.className=prefix+'-delivery-toggle '+prefix+'-select'; toggle.dataset.aesDeliveryToggle=key;
            toggle.setAttribute('aria-label','Show '+label.toLowerCase()+' suggestions'); toggle.setAttribute('aria-expanded','false'); toggle.append(selectChevron.content.cloneNode(true));
            const menu=document.createElement('div'); menu.className=prefix+'-city-menu'; menu.hidden=true; menu.dataset.aesDeliveryMenu=key;
            const list=document.createElement('ul'); list.className=prefix+'-city-options'; list.id=input.id+'-options'; list.setAttribute('role','listbox'); list.setAttribute('aria-label',label);
            input.setAttribute('aria-controls',list.id); toggle.setAttribute('aria-controls',list.id);
            const help=document.createElement('div'); help.className=prefix+'-city-help'; help.dataset.aesDeliveryHelp=''; help.setAttribute('role','status');
            const message=document.createElement('span'); message.dataset.aesDeliveryMessage=''; help.append(message);
            const source=document.createElement('a'); source.href='https://github.com/dr5hn/countries-states-cities-database'; source.target='_blank'; source.rel='noopener'; source.textContent='Address data · ODbL'; help.append(source);
            menu.append(list,help); box.append(toggle,menu);
          }
          deliveryGroup.append(box);
        });
        form.append(deliveryGroup);
      }
      same.setAttribute('aria-controls',deliveryGroup.id);
      const deliveryControl=key=>deliveryGroup.querySelector('[data-aes-delivery="'+key+'"]');
      const deliveryLabels=[['country','Country/Region'],['first_name','First Name'],['last_name','Last Name'],['address1','Address'],['address2','Apartment/Suite'],['city','City'],['zone','State/Province'],['zip','ZIP/Postal Code'],['phone','Phone']];
      const serializeDelivery=read=>deliveryLabels.map(([key,label])=>{const text=String(read(key)||'').trim();return text?label+': '+text:'';}).filter(Boolean).join('\n');
      const businessDelivery={country:'billing_address_country',first_name:'first_name',last_name:'last_name',address1:'billing_address_address1',address2:'billing_address_address2',city:'billing_address_city',zone:'billing_address_zone',zip:'billing_address_zip',phone:'phone_number'};
      let deliveryOpen='',deliveryOptions=[],deliveryActive=-1,deliveryRequest=0,syncing=false,scheduled=false;
      const closeDeliveryMenu=()=>{
        deliveryRequest++; deliveryOpen=''; deliveryActive=-1;
        deliveryGroup.querySelectorAll('[data-aes-delivery-menu]').forEach(menu=>{menu.hidden=true;});
        deliveryGroup.querySelectorAll('[aria-expanded]').forEach(el=>el.setAttribute('aria-expanded','false'));
        deliveryGroup.querySelectorAll('[aria-activedescendant]').forEach(el=>el.removeAttribute('aria-activedescendant'));
      };
      const renderDeliveryMenu=async key=>{
        const input=deliveryControl(key),menu=deliveryGroup.querySelector('[data-aes-delivery-menu="'+key+'"]');
        if (!input || !menu || deliveryGroup.hidden) return;
        const request=++deliveryRequest,search=normalizeCity(input.value),list=menu.querySelector('ul'),help=menu.querySelector('[data-aes-delivery-message]');
        deliveryOptions=[]; deliveryActive=-1; list.replaceChildren(); input.removeAttribute('aria-activedescendant'); help.textContent='Loading suggestions… You can also enter it manually.';
        try {
          cityIndexPromise ||= fetch(this.dataset.aesCityIndexUrl,{signal:this.abort.signal}).then(response=>{if(!response.ok)throw Error('Address index unavailable');return response.json();}).catch(error=>{cityIndexPromise=null;throw error;});
          const index=await cityIndexPromise,names=new Intl.DisplayNames(['en'],{type:'region'}),countries=Object.entries(index.countries);
          const countryKey=normalizeCity(deliveryControl('country').value),country=countries.find(([code,item])=>[code,item.name,names.of(code),...item.aliases].some(name=>normalizeCity(name)===countryKey));
          let choices=[];
          if (key==='country') choices=countries.map(([code,item])=>names.of(code)||item.name);
          else if (country && key==='zone') choices=Object.values(country[1].states).map(item=>item.name);
          else if (country && key==='city') {
            const [code,config]=country,shard=config.shard;
            if (!cityShards.has(shard)) cityShards.set(shard,fetch(this.getAttribute('data-aes-city-'+shard+'-url'),{signal:this.abort.signal}).then(response=>{if(!response.ok)throw Error('Cities unavailable');return response.json();}).catch(error=>{cityShards.delete(shard);throw error;}));
            const data=(await cityShards.get(shard)).data[code]||{},zoneKey=normalizeCity(deliveryControl('zone').value);
            const state=Object.entries(config.states).find(([,item])=>[item.name,...item.aliases].some(name=>normalizeCity(name)===zoneKey));
            choices=state?data[state[0]]||[]:zoneKey?[]:Object.values(data).flat();
          }
          if (request!==deliveryRequest || deliveryOpen!==key || this.abort.signal.aborted) return;
          deliveryOptions=Array.from(new Set(choices)).filter(name=>!search||normalizeCity(name).includes(search)).sort((a,b)=>Number(normalizeCity(b)===search)-Number(normalizeCity(a)===search)||Number(normalizeCity(b).startsWith(search))-Number(normalizeCity(a).startsWith(search))||a.localeCompare(b,'en')).slice(0,key==='country'?300:80);
          deliveryOptions.forEach((name,index)=>{
            const option=document.createElement('li'); option.className=prefix+'-city-option'; option.id=list.id+'-'+index; option.dataset.aesDeliveryOption=String(index); option.setAttribute('role','option'); option.setAttribute('aria-selected','false'); option.textContent=name; list.append(option);
          });
          help.textContent=deliveryOptions.length?'Choose a suggestion, or enter it manually.':key!=='country'&&!country?'Select a country, or enter it manually.':'No matching suggestions. Enter it above.';
        } catch(error) { if(request===deliveryRequest&&!this.abort.signal.aborted)help.textContent='Suggestions are unavailable. Enter it above.'; }
        requestAnimationFrame(()=>{if(!menu.hidden&&menu.isConnected&&menu.getBoundingClientRect().bottom>window.innerHeight-16)window.scrollBy({top:menu.getBoundingClientRect().bottom-window.innerHeight+16,behavior:'instant'});});
      };
      const openDeliveryMenu=key=>{
        closeCity(); closeDeliveryMenu(); deliveryOpen=key;
        const input=deliveryControl(key),menu=deliveryGroup.querySelector('[data-aes-delivery-menu="'+key+'"]');
        menu.hidden=false; input.setAttribute('aria-expanded','true'); deliveryGroup.querySelector('[data-aes-delivery-toggle="'+key+'"]').setAttribute('aria-expanded','true');
        renderDeliveryMenu(key);
      };
      const chooseDeliveryOption=index=>{
        const input=deliveryControl(deliveryOpen),text=deliveryOptions[index]; if(!input||!text)return;
        input.value=text; input.dispatchEvent(new Event('input',{bubbles:true})); input.dispatchEvent(new Event('change',{bubbles:true})); closeDeliveryMenu(); input.focus({preventScroll:true});
      };
      deliveryGroup.addEventListener('click',event=>{
        const toggle=event.target.closest('[data-aes-delivery-toggle]'),option=event.target.closest('[data-aes-delivery-option]');
        if(toggle){const key=toggle.dataset.aesDeliveryToggle;deliveryOpen===key?closeDeliveryMenu():openDeliveryMenu(key);deliveryControl(key).focus({preventScroll:true});}
        else if(option)chooseDeliveryOption(Number(option.dataset.aesDeliveryOption));
        else if(event.target.matches('[data-aes-delivery][role="combobox"]'))openDeliveryMenu(event.target.dataset.aesDelivery);
      },{signal:this.abort.signal});
      deliveryGroup.addEventListener('pointerdown',event=>{if(event.target.closest('[data-aes-delivery-option]'))event.preventDefault();},{signal:this.abort.signal});
      deliveryGroup.addEventListener('input',event=>{
        const key=event.target.dataset.aesDelivery;
        if(key==='country'){deliveryControl('zone').value='';deliveryControl('city').value='';}
        else if(key==='zone')deliveryControl('city').value='';
        if(deliveryOpen===key)renderDeliveryMenu(key);
      },{signal:this.abort.signal});
      deliveryGroup.addEventListener('keydown',event=>{
        const key=event.target.dataset.aesDelivery; if(!['country','zone','city'].includes(key))return;
        if(event.key==='Escape'){closeDeliveryMenu();return;}
        if(['ArrowDown','ArrowUp'].includes(event.key)){
          event.preventDefault();if(deliveryOpen!==key){openDeliveryMenu(key);return;}if(!deliveryOptions.length)return;
          deliveryActive=deliveryActive<0?(event.key==='ArrowDown'?0:deliveryOptions.length-1):(deliveryActive+(event.key==='ArrowDown'?1:-1)+deliveryOptions.length)%deliveryOptions.length;
          const options=deliveryGroup.querySelector('[data-aes-delivery-menu="'+key+'"]').querySelectorAll('[role="option"]');
          options.forEach((option,index)=>option.setAttribute('aria-selected',String(index===deliveryActive)));event.target.setAttribute('aria-activedescendant',options[deliveryActive].id);options[deliveryActive].scrollIntoView({block:'nearest'});
        } else if(event.key==='Enter'&&deliveryOpen===key){event.preventDefault();deliveryActive>=0?chooseDeliveryOption(deliveryActive):closeDeliveryMenu();}
      },{signal:this.abort.signal});
      ['focusin','pointerdown'].forEach(type=>root.addEventListener(type,event=>{
        if(deliveryOpen&&!deliveryControl(deliveryOpen)?.parentElement.contains(event.target))closeDeliveryMenu();
      },{signal:this.abort.signal}));
      const sync = () => {
        [['first_name','billing_address_first_name'],['last_name','billing_address_last_name'],['company_name','billing_address_recipient'],['phone_number','billing_address_phone']].forEach(([from,to])=>setNative(control(to),value(from)||''));
        const delivery=control('custom#aes_requested_delivery_address');
        const sameField=control('custom#aes_same_delivery_address');
        same.closest('label').hidden=!sameField || !delivery || !same.nextElementSibling.textContent.trim();
        deliveryGroup.hidden=same.checked||!sameField||!delivery; deliveryGroup.disabled=deliveryGroup.hidden;
        same.setAttribute('aria-expanded',String(!deliveryGroup.hidden));
        if (sameField && delivery) {
          if(same.checked)closeDeliveryMenu();
          const text=serializeDelivery(key=>same.checked?value(businessDelivery[key]):deliveryControl(key).value);
          setNative(delivery,text); setNative(sameField,same.checked?'Yes':'No');
        }
      };
      const schedule = () => { if (syncing || scheduled) return; scheduled=true; queueMicrotask(()=>{ scheduled=false; if(!form.isConnected || this.abort.signal.aborted)return; syncing=true; try { sync(); } finally { syncing=false; } }); };
      form.addEventListener('input',schedule,{signal:this.abort.signal});
      form.addEventListener('change',schedule,{signal:this.abort.signal});
      // Reject unsupported selections before the native Forms change handler stores them.
      form.addEventListener('change',event=>{
        const input=event.target;
        if (!(input instanceof HTMLInputElement) || input.type!=='file') return;
        if (input.hasAttribute('data-aes-upload-picker')) {
          event.stopImmediatePropagation();
          if (this.dataset.uploadEndpoint) {
            try {
              if (this.preparingUploads || form.hasAttribute('data-aes-page-trade-program-section3-busy')) return;
              if (!this.uploader) throw new Error(this.uploadSetupError || 'The upload service is loading. Please try again.');
              this.uploader.add(Array.from(input.files || [])); uploadErrors.clear();
            } catch(error) {uploadErrors.set(input.id,error.message);}
            finally {input.value=''; renderUploads();}
            return;
          }
          const files=Array.from(input.files || []),available=fileInputs().filter(field=>!uploadName(field));
          const remaining=Math.min(available.length,uploadLimit.count-fileInputs().filter(uploadName).length);
          const message=files.length>remaining ? 'You can upload up to 3 files in total.' : filesError(files);
          input.value='';
          if (message) uploadErrors.set(input.id,message);
          else {
            uploadErrors.delete(input.id);
            files.forEach((file,index)=>{
              const transfer=new DataTransfer(); transfer.items.add(file); available[index].files=transfer.files;
              available[index].dispatchEvent(new Event('change',{bubbles:true}));
            });
          }
          queueMicrotask(renderUploads); return;
        }
        const message=uploadError(input);
        if (message) {
          event.stopImmediatePropagation();
          top(input)?.querySelector('button[class*="_formFileInputCancelButton_"]')?.click();
          input.value=''; uploadErrors.set(input.id,message);
        } else uploadErrors.delete(input.id);
        queueMicrotask(renderUploads);
      },{capture:true,signal:this.abort.signal});
      const urlFields=['custom#aes_business_website','custom#aes_portfolio_link','custom#aes_social_media'];
      const validateUrl = el => {
        if (!el?.setCustomValidity) return;
        let valid=true;
        if (el.value.trim()) {
          try { valid=['http:','https:'].includes(new URL(el.value.trim()).protocol); } catch { valid=false; }
        }
        el.setCustomValidity(valid ? '' : 'Enter a complete website address beginning with https:// or http://.');
      };
      form.addEventListener('input',event=>{ if(urlFields.includes(event.target.id))validateUrl(event.target); },{signal:this.abort.signal});
      let attempted=false;
      form.addEventListener('submit',event=>{
        syncing=true; try { sync(); } finally { syncing=false; }
        urlFields.forEach(id=>validateUrl(control(id)));
        if (this.dataset.uploadEndpoint) {
          const picker=form.querySelector('[data-aes-upload-picker]');
          uploadErrors.clear();
          const message=this.uploadSetupError || (!this.uploader ? 'The upload service is loading. Please try again.' : this.uploader.validate(this.uploader.files) || (!this.uploader.files.length ? 'Upload a qualifying business document.' : ''));
          if (message) uploadErrors.set(picker.id,message);
          displayUploadErrors();
          if (message) {event.preventDefault();event.stopImmediatePropagation();this.submissionState?.release();form.querySelector('.'+prefix+'-upload-add')?.focus();return;}
          const invalid=[...form.querySelectorAll('input:not([type="file"]),textarea,select')].find(el=>!el.checkValidity());
          if (invalid) {event.preventDefault();event.stopImmediatePropagation();this.submissionState?.release();invalid.reportValidity();return;}
          if (!this.preparedUploads) {
            event.preventDefault();event.stopImmediatePropagation();
            this.prepareUploads(form,(message)=>{uploadErrors.set(picker.id,message);displayUploadErrors();});return;
          }
          this.preparedUploads=false;attempted=true;return;
        }
        uploadErrors.delete(form.querySelector('[data-aes-upload-picker]')?.id);
        fileInputs().forEach(input=>{
          const message=uploadError(input);
          if (message) uploadErrors.set(input.id,message); else uploadErrors.delete(input.id);
        });
        const firstUpload=fileInputs()[0];
        if (firstUpload && !uploadName(firstUpload)) uploadErrors.set(firstUpload.id,'Upload a qualifying business document.');
        displayUploadErrors();
        const invalidUpload=fileInputs().find(input=>uploadErrors.has(input.id));
        if (invalidUpload) { event.preventDefault(); event.stopImmediatePropagation(); this.submissionState?.release(); form.querySelector('.'+prefix+'-upload-add')?.focus(); return; }
        const invalid=urlFields.map(control).find(el=>el && !el.checkValidity());
        if (invalid) { event.preventDefault(); event.stopImmediatePropagation(); this.submissionState?.release(); invalid.reportValidity(); return; }
        attempted=true;
      },{capture:true,signal:this.abort.signal});
      decorate(); schedule();
      if (this.applicationScrollPending) this.scrollToApplication();
      this.observer=new MutationObserver(()=>{
        this.observer.disconnect();
        if (!root.contains(form)) {
          clearInterval(this.pendingTimer);
          this.abort.abort(); this.abort=new AbortController();
          this.attach(root); return;
        }
        decorate(); schedule(); this.observer.observe(root,{childList:true,subtree:true});
      });
      this.observer.observe(root,{childList:true,subtree:true});
      let started=0;
      const status=form.querySelector('[role="status"][data-aes-order]');
      this.pendingTimer=setInterval(()=>{
        if (!root.contains(form)) { clearInterval(this.pendingTimer); return; }
        if (form.hasAttribute('data-aes-verification-retry')) { attempted=false; started=0; return; }
        const button=form.querySelector('[data-testid="btn-form-submit"]');
        const pending=this.preparingUploads || attempted && (button?.disabled || button?.getAttribute('aria-disabled')==='true');
        if (!pending) { started=0; status.hidden=true; return; }
        started ||= Date.now();
        if (this.preparingUploads) {status.hidden=false;status.textContent=this.uploadProgress || 'Preparing attachments. Please wait.';return;}
        if (Date.now()-started<1500) return;
        status.hidden=false;
        status.textContent=Date.now()-started>90000 ? 'Your submission is taking longer than expected. Check any verification or error message before trying again.' : 'Submitting your application. Complete the security verification if prompted.';
      },1000);
    }
    async prepareUploads(form,onError) {
      if (this.preparingUploads) return;
      const controller=new AbortController();this.prepareAbort=controller;this.preparingUploads=true;
      this.uploadProgress='Preparing attachments. Please wait.';this.submissionState?.sync();
      try {
        await this.uploaderReady;
        if (controller.signal.aborted || this.activeForm!==form) return;
        if (!this.uploader || this.uploadSetupError) throw new Error(this.uploadSetupError || 'The upload service is unavailable. Refresh the page and try again.');
        const field=form.querySelector('[id="custom#inquiry_attachment_manifest"],[name="custom#inquiry_attachment_manifest"]');
        if (!field) throw new Error(this.uploadCopy.form_not_ready);
        let security=form.querySelector('[data-aes-inquiry-security]');
        if (!security) {security=document.createElement('div');security.dataset.aesInquirySecurity='';security.style.order='58';security.style.gridColumn='1 / -1';form.append(security);}
        const metadata=await this.uploader.prepare(security,{signal:controller.signal,onProgress:percent=>{this.uploadProgress=this.uploadCopy.progress.replace('%percent%',String(percent));this.submissionState?.sync();}});
        if (controller.signal.aborted || this.activeForm!==form) return;
        const serialized=JSON.stringify(metadata),maximum=Math.min(field.maxLength>0?field.maxLength:1000,1000);
        if (serialized.length>maximum) throw new Error(this.uploadCopy.manifest_too_large);
        const prototype=field.tagName==='TEXTAREA' ? HTMLTextAreaElement.prototype : HTMLInputElement.prototype;
        Object.getOwnPropertyDescriptor(prototype,'value').set.call(field,serialized);
        field.dispatchEvent(new Event('input',{bubbles:true}));field.dispatchEvent(new Event('change',{bubbles:true}));
        await new Promise(resolve=>requestAnimationFrame(()=>requestAnimationFrame(resolve)));
        if (controller.signal.aborted || this.activeForm!==form) return;
        this.preparingUploads=false;this.submissionState?.release();this.preparedUploads=true;form.requestSubmit();
      } catch(error) {
        if (controller.signal.aborted || !this.isConnected || this.activeForm!==form) return;
        this.preparingUploads=false;this.preparedUploads=false;this.submissionState?.release();
        onError(error.message || this.uploadCopy?.upload_failed || 'The attachments could not be uploaded. Please try again.');
      } finally {if(this.prepareAbort===controller)this.prepareAbort=null;}
    }
    installSubmissionState(form) {
      const attribute='data-aes-page-trade-program-section3-busy';
      const locked=new Map(),abort=new AbortController();
      const retryAttribute='data-aes-verification-retry',prefix='aes-page-trade-program-section3';
      let attempted=false,busy=false,awaitingNative=false,attempt=0,challengeSeen=null,terminalFailure=null,retryOrigin=false,retryValidation=null;
      let retry=form.querySelector('[data-aes-verification-retry-button]');
      if (!retry) {
        retry=document.createElement('button'); retry.type='button'; retry.hidden=true; retry.dataset.aesVerificationRetryButton=''; retry.className=prefix+'-verification-retry'; retry.style.order='60';
        const text=document.createElement('span'); text.textContent='Retry verification'; retry.append(text);
        const arrow=this.querySelector('[data-aes-page-trade-program-section3-content]')?.content.querySelector('[data-aes-arrow]');
        if(arrow)retry.append(arrow.cloneNode(true)); form.append(retry);
      }
      const captchaFrames=scope=>Array.from(scope.querySelectorAll('iframe[src]')).map(frame=>{
        try { const url=new URL(frame.src),hash=new URLSearchParams(url.hash.slice(1)); return /(^|\.)hcaptcha\.com$/.test(url.hostname)?{frame,id:hash.get('id'),type:hash.get('frame')}:null; } catch{return null;}
      }).filter(Boolean);
      const ownedCaptcha=()=>{
        const embed=this.querySelector('shopify-forms-embed');
        if (!embed || embed.shadowRoot!==this.root || document.querySelectorAll('shopify-forms-embed').length!==1) return null;
        const allFrames=scope=>[...captchaFrames(scope),...Array.from(scope.querySelectorAll('*')).filter(node=>node.shadowRoot).flatMap(node=>allFrames(node.shadowRoot))];
        const widgets=allFrames(document).filter(item=>['checkbox','checkbox-invisible'].includes(item.type));
        if(widgets.some(item=>!this.root.contains(item.frame)))return null;
        return widgets.length===1?widgets[0]:null;
      };
      const visible=frame=>{
        if(!frame.isConnected||!frame.getClientRects().length)return false;
        for(let node=frame;node instanceof Element;node=node.parentElement||node.getRootNode().host){
          const style=getComputedStyle(node);
          if(node.hidden||node.getAttribute('aria-hidden')==='true'||style.display==='none'||['hidden','collapse'].includes(style.visibility)||style.opacity==='0'||style.contentVisibility==='hidden')return false;
        }
        return true;
      };
      const challenges=()=>captchaFrames(document).filter(item=>item.type==='challenge');
      const nativeErrors=()=>Array.from(form.querySelectorAll('input[aria-invalid="true"],textarea[aria-invalid="true"],select[aria-invalid="true"],button[aria-invalid="true"],output[role="alert"]')).filter(node=>!node.closest('[data-aes-delivery-group],.'+prefix+'-upload'));
      const rememberChallenge=()=>{
        if(!attempted||!busy||this.preparingUploads||!ownedCaptcha())return;
        const list=challenges(); if(list.length===1&&visible(list[0].frame)){challengeSeen=list[0].frame;retryOrigin=false;retryValidation=null;}
      };
      const release=()=>{
        for (const [control,inert] of locked) control.inert=inert;
        locked.clear();
        awaitingNative=false;
        attempted=false;
        busy=false;
        terminalFailure=null;
        retryValidation=null;
        form.removeAttribute(attribute);
        form.setAttribute('aria-busy','false');
        const button=form.querySelector('[data-testid="btn-form-submit"]'); button?.removeAttribute(attribute);
        if(retryOrigin&&button?.disabled&&!this.preparingUploads){form.setAttribute(retryAttribute,'');retry.hidden=false;}
        else if(!button?.disabled)retryOrigin=false;
      };
      const tryRecovery=()=>{
        const failure=terminalFailure; if(!failure)return;
        const button=form.querySelector('[data-testid="btn-form-submit"]');
        if(failure.attempt!==attempt||!attempted||!busy||!form.isConnected||this.activeForm!==form||this.root.querySelector('[data-testid="banner-success"]')){terminalFailure=null;return;}
        const list=challenges();
        if(this.preparingUploads||!button?.disabled||!ownedCaptcha()||list.length>1||(list.length===1&&list[0].frame!==failure.frame)||visible(failure.frame))return;
        release(); retryOrigin=false; form.setAttribute(retryAttribute,''); retry.hidden=false;
        const status=form.querySelector('[role="status"][data-aes-order]');
        if(status){status.hidden=false;status.textContent=failure.reason==='challenge-expired'?'Verification expired. Your details and files are saved on this page. Select Retry verification to continue.':'Verification was closed. Your details and files are saved on this page. Select Retry verification to continue.';}
        retry.focus({preventScroll:true});
      };
      const sync=()=>{
        if (!form.isConnected) { release(); return; }
        const button=form.querySelector('[data-testid="btn-form-submit"]');
        const nativeBusy=!!(button?.disabled || button?.getAttribute('aria-disabled')==='true');
        if (attempted && nativeBusy && !this.preparingUploads)rememberChallenge();
        tryRecovery();
        if(retryValidation?.attempt===attempt&&attempted&&nativeBusy&&!this.preparingUploads&&!challengeSeen&&!terminalFailure&&this.activeForm===form&&!this.root.querySelector('[data-testid="banner-success"]')&&nativeErrors().some(node=>!retryValidation.errors.has(node))){
          release(); retryOrigin=false;
          const status=form.querySelector('[role="status"][data-aes-order]');
          if(status){status.hidden=false;status.textContent='Review the highlighted fields, then select Retry verification. Your details and files have been kept.';}
        }
        if (awaitingNative && (nativeBusy || form.querySelector('[aria-invalid="true"],output[role="alert"]'))) awaitingNative=false;
        const pending=this.preparingUploads || awaitingNative || (attempted && nativeBusy);
        if (busy && !pending) attempted=false;
        busy=pending;
        form.toggleAttribute(attribute,pending);
        form.setAttribute('aria-busy',String(pending));
        button?.toggleAttribute(attribute,pending);
        if (pending) {
          // Inert preserves native FormData and lets the verification iframe remain interactive.
          for (const control of form.querySelectorAll('input,select,textarea,button')) {
            if (!locked.has(control)) locked.set(control,control.inert);
            control.inert=true;
          }
        } else release();
      };
      form.addEventListener('submit',event=>{
        if (busy) { event.preventDefault(); event.stopImmediatePropagation(); return; }
        const wasRetry=retryOrigin||form.hasAttribute(retryAttribute); retryOrigin=wasRetry;
        form.removeAttribute(retryAttribute); retry.hidden=true; challengeSeen=null; terminalFailure=null; attempt++;
        retryValidation=wasRetry?{attempt,errors:new Set(nativeErrors())}:null;
        const button=form.querySelector('[data-testid="btn-form-submit"]');
        if (button) form.style.setProperty('--aes-page-trade-program-section3-submit-width',button.getBoundingClientRect().width+'px');
        attempted=true;
        awaitingNative=true;
        sync();
        queueMicrotask(sync);
      },{capture:true,signal:abort.signal});
      const reset=()=>{ if (!busy) attempted=false; };
      form.addEventListener('input',reset,{signal:abort.signal});
      form.addEventListener('change',reset,{signal:abort.signal});
      // Shopify's async hCaptcha await rejects on these two terminal outcomes.
      // Recover only a witnessed challenge belonging to this sole native embed;
      // elapsed time and unrelated promises never unlock a pending submission.
      window.addEventListener('unhandledrejection',event=>{
        if (!event.isTrusted || !['challenge-expired','challenge-closed'].includes(event.reason) || !attempted || !busy || this.preparingUploads) return;
        const widget=ownedCaptcha();
        if (!widget || !challengeSeen) return;
        terminalFailure={attempt,frame:challengeSeen,reason:event.reason}; tryRecovery();
      },{signal:abort.signal});
      retry.addEventListener('click',()=>{
        if (busy || !form.hasAttribute(retryAttribute) || !form.isConnected) return;
        const errors=nativeErrors();
        if(errors.length){
          errors.find(node=>node.matches('input,textarea,select,button'))?.focus({preventScroll:true});
          const status=form.querySelector('[role="status"][data-aes-order]');
          if(status){status.hidden=false;status.textContent='Review the highlighted fields, then select Retry verification. Your details and files have been kept.';}
          return;
        }
        retryOrigin=true;
        form.requestSubmit();
      },{signal:abort.signal});
      const captchaObserver=new MutationObserver(()=>{rememberChallenge();tryRecovery();});
      captchaObserver.observe(document.documentElement,{subtree:true,childList:true,attributes:true,attributeFilter:['style','hidden','aria-hidden']});
      const observer=new MutationObserver(sync);
      observer.observe(form,{subtree:true,childList:true,attributes:true,attributeFilter:['disabled','aria-disabled']});
      const timer=setInterval(sync,250);
      this.submissionState={release,sync};
      this.submissionCleanup=()=>{
        observer.disconnect(); captchaObserver.disconnect(); clearInterval(timer); abort.abort(); retryOrigin=false; release(); this.submissionCleanup=null;
      };
    }
    renderSuccess(root) {
      this.uploader?.observedSuccess(); this.fileCards?.dispose();
      const banner=root.querySelector('[data-testid="banner-success"]');
      if (!banner || banner.dataset.aesTradeSuccess) return;
      banner.dataset.aesTradeSuccess='true';
      this.dataset.aesSuccess='true';
      const prefix='aes-page-trade-program-section3';
      const content=this.querySelector('[data-aes-page-trade-program-section3-success]').content;
      if (content.querySelector('h2')) banner.replaceChildren(content.cloneNode(true));
      const intro=this.querySelector('.'+prefix+'-intro');
      if (intro) intro.hidden=true;
      const style=document.createElement('style');
      style.dataset.aesTradeSuccessStyle='';
      style.textContent=`
@layer aes-focus-policy {
  :is(:focus, :focus-visible, .focused) { outline: none !important; box-shadow: none !important; }
  :focus-within { outline: none !important; }
}

        [data-form-root],[data-testid="app-router"],#form-container-ref,section[role="dialog"] {width:100%!important;max-width:none!important;padding:0!important;margin:0!important}
        [class*="_gridItemContent_"] {padding:0!important}
        [data-testid="banner-success"] {padding:48px 0 40px!important;border-bottom:1px solid var(--aes-button-border-hover);text-align:center!important}
        [data-testid="banner-success"] h2 {margin:0 0 16px!important;font:400 24px/1.35 var(--aes-font-heading)!important;color:var(--aes-bg-brand)!important;outline:none!important}
        [data-testid="banner-success"] p {max-width:720px;margin:0 auto!important;font:400 12px/1.6 var(--aes-font-body)!important;color:var(--aes-bg-brand)!important}
        .${prefix}-success-image {display:flex;align-items:center;justify-content:center;width:64px;height:64px;object-fit:contain;margin:0 auto 24px;color:var(--aes-button-border-hover)}
        .${prefix}-success-image svg {display:block;flex:none;width:100%!important;height:100%!important;max-width:none!important;transform:none!important}
        .${prefix}-success-image [stroke] {stroke:currentColor;stroke-width:2.5px;vector-effect:non-scaling-stroke}
        .${prefix}-success-content>a {box-sizing:border-box;position:relative;display:inline-flex;align-items:center;gap:12px;min-height:49px;margin-top:32px;padding:0 20px;border:1px solid var(--aes-text-primary);text-decoration:none;color:var(--aes-text-primary);font:400 16px/1.35 var(--aes-font-heading);transition:background var(--aes-duration),color var(--aes-duration)}
        .${prefix}-success-content>a:focus {outline:none;box-shadow:none}
        .${prefix}-success-content>a::after {content:'';position:absolute;inset:var(--aes-button-inset);border:var(--aes-button-inset-border-width) solid currentColor;opacity:0;pointer-events:none}
        .${prefix}-success-content>a:is(:hover,:active,:focus-visible) {background:#897266;border-color:#897266;color:var(--aes-text-inverse)}
        .${prefix}-success-content>a:is(:hover,:active,:focus-visible)::after {opacity:1}
        .${prefix}-success-content>a>span {display:inline-flex;width:16px;height:16px;transform:rotate(-45deg)}
        .${prefix}-success-content>a svg {width:16px;height:16px;fill:currentColor}
        .${prefix}-success-content>a [fill]:not([fill="none"]) {fill:currentColor}
        @media(min-width:768px) {[data-testid="banner-success"] {padding-top:64px!important}}
        @media(min-width:1024px) {[data-testid="banner-success"] {padding-block:112px!important}[data-testid="banner-success"] h2 {font-size:36px!important}[data-testid="banner-success"] p {font-size:16px!important}.${prefix}-success-image {width:194px;height:194px}.${prefix}-success-image [stroke] {stroke-width:4px}.${prefix}-success-content>a {min-height:56px}}
        @media(prefers-reduced-motion:reduce) {.${prefix}-success-content>a {transition:none}}
      `;
      root.querySelector('style[data-aes-trade-success-style]')?.remove(); root.append(style);
      if (this.activeForm) banner.querySelector('h2')?.focus({preventScroll:true});
      this.activeForm=null;
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["aes-product-reviews"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('aes-product-reviews')) {
    customElements.define('aes-product-reviews', class extends HTMLElement {
      connectedCallback() {
        this.sourceStyle = document.querySelector('[data-aes-reviews-style]');
        this.retry = () => { this.stop(); const previous = this.querySelector('.gw-rv-main-widget-placeholder'); if (!previous) return; const next = previous.cloneNode(false); previous.replaceWith(next); this.start(); };
        this.querySelector('[data-reviews-retry]')?.addEventListener('click', this.retry);
        this.start();
      }
      disconnectedCallback() { this.stop(); this.querySelector('[data-reviews-retry]')?.removeEventListener('click', this.retry); }
      stop() { clearTimeout(this.timer); clearTimeout(this.deadline); cancelAnimationFrame(this.frame); this.observer?.disconnect(); this.observer = null; this.root = null; }
      state(value) {
        this.dataset.state = value;
        const pending = value === 'pending';
        const host = this.querySelector('.gw-rv-main-widget-placeholder');
        if (host) { host.inert = pending; host.setAttribute('aria-busy', String(pending)); }
        this.querySelector('[data-aes-global-loading]')?.toggleAttribute('hidden', !pending);
        this.querySelector('[data-reviews-error]')?.toggleAttribute('hidden', value !== 'error');
        const status = this.querySelector('[data-reviews-status]');
        if (status) status.textContent = value === 'pending' ? status.dataset.loadingText : value === 'error' ? status.dataset.errorText : '';
      }
      start() {
        this.state('pending');
        this.deadline = setTimeout(() => { if (this.dataset.state === 'pending') this.state('error'); }, 30000);
        const locate = () => {
          if (!this.isConnected) return;
          const host = this.querySelector('.gw-rv-main-widget-placeholder');
          const root = host?.shadowRoot || (host?.querySelector('.gw-rv-product-page-widget') ? host : null);
          if (!root) { this.timer = setTimeout(locate, this.dataset.state === 'error' ? 1000 : 200); return; }
          this.root = root;
          // Also supports theme editor section additions after SDK initialization.
          if (this.sourceStyle && !root.querySelector('[data-aes-reviews-applied]')) {
            const style = document.createElement('style'); style.dataset.aesReviewsApplied = ''; style.textContent = this.sourceStyle.textContent; root.append(style);
          }
          this.observer = new MutationObserver(() => { cancelAnimationFrame(this.frame); this.frame = requestAnimationFrame(() => this.adapt()); });
          this.observer.observe(root, { childList: true, subtree: true });
          this.adapt();
        };
        locate();
      }
      adapt() {
        if (!this.isConnected || !this.root) return;
        const widget = this.root.querySelector('.gw-rv-product-page-widget');
        if (!widget) return;
        const empty = widget.querySelector('.gw-rv-reviews-list-widget__empty-list-wrapper .gw-empty-state');
        this.toggleAttribute('data-empty', !!empty);
        // Add our own presentation only; the original Growave action button keeps its handler.
        if (empty && !empty.querySelector('[data-aes-empty-content]')) {
          const template = this.querySelector('[data-reviews-empty]');
          if (template) empty.prepend(template.content.cloneNode(true));
        }
        const linkIcon = this.querySelector('[data-reviews-link-icon]');
        if (linkIcon) widget.querySelectorAll('.gw-rv-list-settings__button-group .gw-btn__label, .gw-empty-state .gw-btn__label').forEach(label => {
          if (!label.querySelector('[data-aes-review-link-icon]')) label.append(linkIcon.content.cloneNode(true));
        });
        widget.toggleAttribute('data-aes-has-summary', !!widget.querySelector('.gw-rv-total-rate__bars'));
        widget.querySelectorAll('.gw-rv-item').forEach(item => {
          const top = item.firstElementChild;
          const header = top?.firstElementChild;
          const details = header?.nextElementSibling;
          const copy = details?.firstElementChild;
          const author = copy?.firstElementChild;
          const body = author?.nextElementSibling;
          const stars = header?.querySelector('.gw-rv-rating-stars');
          const date = header?.querySelector(':scope > .gw-text');
          const photos = details?.querySelector(':scope > .gw-rv-item-image-list');
          const title = body?.firstElementChild;
          const content = title?.nextElementSibling;
          const footer = details?.lastElementChild;
          // Fail open to native layout if Growave changes its component structure.
          if (!author?.querySelector('.gw-text--heading-md') || !content?.querySelector('.gw-view-more') || !stars || !date) return;
          item.dataset.aesLayout = '';
          [top, header, details, copy, body].forEach(el => el.setAttribute('data-aes-rv-flatten', ''));
          [[author, 'author'], [date, 'date'], [title, 'title'], [content, 'content'], [photos, 'photos'], [stars, 'stars']].forEach(([el, part]) => { if (el) el.dataset.aesRvPart = part; });
          if (footer && footer !== photos && footer !== copy) footer.dataset.aesRvPart = 'footer';
          // Native title and stars remain in their original DOM; grid aligns them on the same line.
        });
        const ready = widget.querySelector('.gw-rv-reviews-list-widget__empty-list-wrapper, .gw-rv-list > .gw-rv-item');
        if (ready) { clearTimeout(this.deadline); this.state('ready'); }
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
      this.setHeaderHeight = this.setHeaderHeight.bind(this);
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.mobileMediaQuery = window.matchMedia('(max-width: 990px)');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      this.mobileMediaQuery.addEventListener('change', this.setHeaderHeight);

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearches = this.querySelectorAll('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.mobileMediaQuery.removeEventListener('change', this.setHeaderHeight);
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if ([...this.predictiveSearches].some((predictiveSearch) => predictiveSearch.isOpen)) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModals = this.searchModals || this.header.querySelectorAll('details-modal');
      this.searchModals.forEach((searchModal) => searchModal.close(false));
    }
  }

  // The account `open` event is composed but does not bubble, so listen during capture.
  // Anchor the dialog to the bottom of the account button itself. The header group can be
  // much taller than the button's row (for example, a top-left logo pushes the menu to a
  // second row), so anchoring to the section bottom drops the dialog too low.
  document.addEventListener(
    'open',
    (event) => {
      if (!(event.target instanceof HTMLElement) || !event.target.matches('shopify-account')) return;

      const bottom = Math.max(0, Math.round(event.target.getBoundingClientRect().bottom));
      event.target.style.setProperty('--account-dialog-top', `${bottom}px`);
    },
    true
  );

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product"]) return;
  try {
    
if(!customElements.get('aes-material-product-add'))customElements.define('aes-material-product-add',class extends HTMLElement{
  connectedCallback(){
    this.pendingVariant=false;this.abort=new AbortController();this.button=this.querySelector('[data-aes-material-product-add]');this.error=this.querySelector('[data-aes-material-product-error]');
    this.sync=()=>{try{this.record=JSON.parse(this.querySelector('template[data-aes-material-product-record]').content.textContent);const service=window.aesMaterialSelection,valid=!!this.record.variantId&&['Fabric','Panel'].includes(this.record.category);this.button.disabled=this.pendingVariant||!service||service.locked||!valid;this.error.hidden=valid;const selected=!!service?.state.materials.some(x=>x.variantId===this.record.variantId);this.button.setAttribute('aria-pressed',String(selected));this.querySelector('[data-aes-add-text]').textContent=selected?this.dataset.editLabel:this.dataset.addLabel;}catch{this.button.disabled=true;this.error.hidden=false;}};
    document.addEventListener('aes:materials:change',this.sync,{signal:this.abort.signal});
    this.button.addEventListener('click',()=>{if(this.button.disabled)return;const selection=this.closest('product-info')?.querySelector('aes-material-selection');selection?.choose(this.record,this.button).catch(()=>{this.error.hidden=false;});},{signal:this.abort.signal});
    if(typeof subscribe==='function'&&typeof PUB_SUB_EVENTS!=='undefined'){
      this.optionUnsubscribe=subscribe(PUB_SUB_EVENTS.optionValueSelectionChange,({data})=>{if(this.closest('product-info')?.contains(data.event.target)){this.pendingVariant=true;this.button.disabled=true;}});
      this.unsubscribe=subscribe(PUB_SUB_EVENTS.variantChange,({data})=>{if(data.sectionId!==this.dataset.section)return;const next=data.html.querySelector('aes-material-product-add template[data-aes-material-product-record]');if(!next||!data.variant)return;try{const record=JSON.parse(next.content.textContent);if(record.variantId!==String(data.variant.id))return;this.querySelector('template[data-aes-material-product-record]').content.replaceChildren(next.content.cloneNode(true));this.pendingVariant=false;this.sync();}catch{this.button.disabled=true;this.error.hidden=false;}});
    }
    customElements.whenDefined('aes-material-selection').then(()=>{if(this.isConnected)this.sync();});this.sync();
  }
  disconnectedCallback(){this.abort?.abort();this.unsubscribe?.();this.optionUnsubscribe?.();}
});

  } catch(e) { console.error(e); }
})();
})();
